! function(t) {
    var e = {};

    function i(n) {
        if (e[n]) return e[n].exports;
        var r = e[n] = {
            i: n,
            l: !1,
            exports: {}
        };
        return t[n].call(r.exports, r, r.exports, i), r.l = !0, r.exports
    }
    i.m = t, i.c = e, i.d = function(t, e, n) {
        i.o(t, e) || Object.defineProperty(t, e, {
            enumerable: !0,
            get: n
        })
    }, i.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        })
    }, i.t = function(t, e) {
        if (1 & e && (t = i(t)), 8 & e) return t;
        if (4 & e && "object" == typeof t && t && t.__esModule) return t;
        var n = Object.create(null);
        if (i.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t)
            for (var r in t) i.d(n, r, function(e) {
                return t[e]
            }.bind(null, r));
        return n
    }, i.n = function(t) {
        var e = t && t.__esModule ? function() {
            return t.default
        } : function() {
            return t
        };
        return i.d(e, "a", e), e
    }, i.o = function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e)
    }, i.p = "", i(i.s = 35)
}([function(t, e, i) {
        var n, r, o;



        /*!
         * Flickity v2.2.2
         * Touch, responsive, flickable carousels
         *
         * Licensed GPLv3 for open source use
         * or Flickity Commercial License for commercial use
         *
         * https://flickity.metafizzy.co
         * Copyright 2015-2021 Metafizzy
         * 
         * 
         */
        window, r = [i(2), i(28), i(30), i(31), i(32), i(33), i(34)], void 0 === (o = "function" == typeof(n = function(t) {
            return t
        }) ? n.apply(e, r) : n) || (t.exports = o)
    }, function(t, e, i) {
        var n, r;
        ! function(o, s) {
            n = [i(24)], void 0 === (r = function(t) {
                return function(t, e) {
                    "use strict";
                    var i = {
                            extend: function(t, e) {
                                for (var i in e) t[i] = e[i];
                                return t
                            },
                            modulo: function(t, e) {
                                return (t % e + e) % e
                            }
                        },
                        n = Array.prototype.slice;
                    i.makeArray = function(t) {
                        return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? n.call(t) : [t]
                    }, i.removeFrom = function(t, e) {
                        var i = t.indexOf(e); - 1 != i && t.splice(i, 1)
                    }, i.getParent = function(t, i) {
                        for (; t.parentNode && t != document.body;)
                            if (t = t.parentNode, e(t, i)) return t
                    }, i.getQueryElement = function(t) {
                        return "string" == typeof t ? document.querySelector(t) : t
                    }, i.handleEvent = function(t) {
                        var e = "on" + t.type;
                        this[e] && this[e](t)
                    }, i.filterFindElements = function(t, n) {
                        t = i.makeArray(t);
                        var r = [];
                        return t.forEach((function(t) {
                            if (t instanceof HTMLElement)
                                if (n) {
                                    e(t, n) && r.push(t);
                                    for (var i = t.querySelectorAll(n), o = 0; o < i.length; o++) r.push(i[o])
                                } else r.push(t)
                        })), r
                    }, i.debounceMethod = function(t, e, i) {
                        i = i || 100;
                        var n = t.prototype[e],
                            r = e + "Timeout";
                        t.prototype[e] = function() {
                            var t = this[r];
                            clearTimeout(t);
                            var e = arguments,
                                o = this;
                            this[r] = setTimeout((function() {
                                n.apply(o, e), delete o[r]
                            }), i)
                        }
                    }, i.docReady = function(t) {
                        var e = document.readyState;
                        "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t)
                    }, i.toDashed = function(t) {
                        return t.replace(/(.)([A-Z])/g, (function(t, e, i) {
                            return e + "-" + i
                        })).toLowerCase()
                    };
                    var r = t.console;
                    return i.htmlInit = function(e, n) {
                        i.docReady((function() {
                            var o = i.toDashed(n),
                                s = "data-" + o,
                                a = document.querySelectorAll("[" + s + "]"),
                                l = document.querySelectorAll(".js-" + o),
                                c = i.makeArray(a).concat(i.makeArray(l)),
                                u = s + "-options",
                                h = t.jQuery;
                            c.forEach((function(t) {
                                var i, o = t.getAttribute(s) || t.getAttribute(u);
                                try {
                                    i = o && JSON.parse(o)
                                } catch (e) {
                                    return void(r && r.error("Error parsing " + s + " on " + t.className + ": " + e))
                                }
                                var a = new e(t, i);
                                h && h.data(t, n, a)
                            }))
                        }))
                    }, i
                }(o, t)
            }.apply(e, n)) || (t.exports = r)
        }(window)
    }, function(t, e, i) {
        var n, r;
        ! function(o, s) {
            n = [i(3), i(6), i(1), i(25), i(26), i(27)], void 0 === (r = function(t, e, i, n, r, s) {
                return function(t, e, i, n, r, o, s) {
                    "use strict";
                    var a = t.jQuery,
                        l = t.getComputedStyle,
                        c = t.console;

                    function u(t, e) {
                        for (t = n.makeArray(t); t.length;) e.appendChild(t.shift())
                    }
                    var h = 0,
                        d = {};

                    function f(t, e) {
                        var i = n.getQueryElement(t);
                        if (i) {
                            if (this.element = i, this.element.flickityGUID) {
                                var r = d[this.element.flickityGUID];
                                return r && r.option(e), r
                            }
                            a && (this.$element = a(this.element)), this.options = n.extend({}, this.constructor.defaults), this.option(e), this._create()
                        } else c && c.error("Bad element for Flickity: " + (i || t))
                    }
                    f.defaults = {
                        accessibility: !0,
                        cellAlign: "center",
                        freeScrollFriction: .075,
                        friction: .28,
                        namespaceJQueryEvents: !0,
                        percentPosition: !0,
                        resize: !0,
                        selectedAttraction: .025,
                        setGallerySize: !0
                    }, f.createMethods = [];
                    var p = f.prototype;
                    n.extend(p, e.prototype), p._create = function() {
                        var e = this.guid = ++h;
                        for (var i in this.element.flickityGUID = e, d[e] = this, this.selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), (this.options.resize || this.options.watchCSS) && t.addEventListener("resize", this), this.options.on) {
                            var n = this.options.on[i];
                            this.on(i, n)
                        }
                        f.createMethods.forEach((function(t) {
                            this[t]()
                        }), this), this.options.watchCSS ? this.watchCSS() : this.activate()
                    }, p.option = function(t) {
                        n.extend(this.options, t)
                    }, p.activate = function() {
                        this.isActive || (this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize(), u(this._filterFindCellElements(this.element.children), this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready"))
                    }, p._createSlider = function() {
                        var t = document.createElement("div");
                        t.className = "flickity-slider", t.style[this.originSide] = 0, this.slider = t
                    }, p._filterFindCellElements = function(t) {
                        return n.filterFindElements(t, this.options.cellSelector)
                    }, p.reloadCells = function() {
                        this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
                    }, p._makeCells = function(t) {
                        return this._filterFindCellElements(t).map((function(t) {
                            return new r(t, this)
                        }), this)
                    }, p.getLastCell = function() {
                        return this.cells[this.cells.length - 1]
                    }, p.getLastSlide = function() {
                        return this.slides[this.slides.length - 1]
                    }, p.positionCells = function() {
                        this._sizeCells(this.cells), this._positionCells(0)
                    }, p._positionCells = function(t) {
                        t = t || 0, this.maxCellHeight = t && this.maxCellHeight || 0;
                        var e = 0;
                        if (t > 0) {
                            var i = this.cells[t - 1];
                            e = i.x + i.size.outerWidth
                        }
                        for (var n = this.cells.length, r = t; r < n; r++) {
                            var o = this.cells[r];
                            o.setPosition(e), e += o.size.outerWidth, this.maxCellHeight = Math.max(o.size.outerHeight, this.maxCellHeight)
                        }
                        this.slideableWidth = e, this.updateSlides(), this._containSlides(), this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0
                    }, p._sizeCells = function(t) {
                        t.forEach((function(t) {
                            t.getSize()
                        }))
                    }, p.updateSlides = function() {
                        if (this.slides = [], this.cells.length) {
                            var t = new o(this);
                            this.slides.push(t);
                            var e = "left" == this.originSide ? "marginRight" : "marginLeft",
                                i = this._getCanCellFit();
                            this.cells.forEach((function(n, r) {
                                if (t.cells.length) {
                                    var s = t.outerWidth - t.firstMargin + (n.size.outerWidth - n.size[e]);
                                    i.call(this, r, s) || (t.updateTarget(), t = new o(this), this.slides.push(t)), t.addCell(n)
                                } else t.addCell(n)
                            }), this), t.updateTarget(), this.updateSelectedSlide()
                        }
                    }, p._getCanCellFit = function() {
                        var t = this.options.groupCells;
                        if (!t) return function() {
                            return !1
                        };
                        if ("number" == typeof t) {
                            var e = parseInt(t, 10);
                            return function(t) {
                                return t % e != 0
                            }
                        }
                        var i = "string" == typeof t && t.match(/^(\d+)%$/),
                            n = i ? parseInt(i[1], 10) / 100 : 1;
                        return function(t, e) {
                            return e <= (this.size.innerWidth + 1) * n
                        }
                    }, p._init = p.reposition = function() {
                        this.positionCells(), this.positionSliderAtSelected()
                    }, p.getSize = function() {
                        this.size = i(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
                    };
                    var g = {
                        center: {
                            left: .5,
                            right: .5
                        },
                        left: {
                            left: 0,
                            right: 1
                        },
                        right: {
                            right: 0,
                            left: 1
                        }
                    };
                    p.setCellAlign = function() {
                        var t = g[this.options.cellAlign];
                        this.cellAlign = t ? t[this.originSide] : this.options.cellAlign
                    }, p.setGallerySize = function() {
                        if (this.options.setGallerySize) {
                            var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                            this.viewport.style.height = t + "px"
                        }
                    }, p._getWrapShiftCells = function() {
                        if (this.options.wrapAround) {
                            this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                            var t = this.cursorPosition,
                                e = this.cells.length - 1;
                            this.beforeShiftCells = this._getGapCells(t, e, -1), t = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(t, 0, 1)
                        }
                    }, p._getGapCells = function(t, e, i) {
                        for (var n = []; t > 0;) {
                            var r = this.cells[e];
                            if (!r) break;
                            n.push(r), e += i, t -= r.size.outerWidth
                        }
                        return n
                    }, p._containSlides = function() {
                        if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                            var t = this.options.rightToLeft,
                                e = t ? "marginRight" : "marginLeft",
                                i = t ? "marginLeft" : "marginRight",
                                n = this.slideableWidth - this.getLastCell().size[i],
                                r = n < this.size.innerWidth,
                                o = this.cursorPosition + this.cells[0].size[e],
                                s = n - this.size.innerWidth * (1 - this.cellAlign);
                            this.slides.forEach((function(t) {
                                r ? t.target = n * this.cellAlign : (t.target = Math.max(t.target, o), t.target = Math.min(t.target, s))
                            }), this)
                        }
                    }, p.dispatchEvent = function(t, e, i) {
                        var n = e ? [e].concat(i) : i;
                        if (this.emitEvent(t, n), a && this.$element) {
                            var r = t += this.options.namespaceJQueryEvents ? ".flickity" : "";
                            if (e) {
                                var o = new a.Event(e);
                                o.type = t, r = o
                            }
                            this.$element.trigger(r, i)
                        }
                    }, p.select = function(t, e, i) {
                        if (this.isActive && (t = parseInt(t, 10), this._wrapSelect(t), (this.options.wrapAround || e) && (t = n.modulo(t, this.slides.length)), this.slides[t])) {
                            var r = this.selectedIndex;
                            this.selectedIndex = t, this.updateSelectedSlide(), i ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [t]), t != r && this.dispatchEvent("change", null, [t]), this.dispatchEvent("cellSelect")
                        }
                    }, p._wrapSelect = function(t) {
                        var e = this.slides.length;
                        if (!(this.options.wrapAround && e > 1)) return t;
                        var i = n.modulo(t, e),
                            r = Math.abs(i - this.selectedIndex),
                            o = Math.abs(i + e - this.selectedIndex),
                            s = Math.abs(i - e - this.selectedIndex);
                        !this.isDragSelect && o < r ? t += e : !this.isDragSelect && s < r && (t -= e), t < 0 ? this.x -= this.slideableWidth : t >= e && (this.x += this.slideableWidth)
                    }, p.previous = function(t, e) {
                        this.select(this.selectedIndex - 1, t, e)
                    }, p.next = function(t, e) {
                        this.select(this.selectedIndex + 1, t, e)
                    }, p.updateSelectedSlide = function() {
                        var t = this.slides[this.selectedIndex];
                        t && (this.unselectSelectedSlide(), this.selectedSlide = t, t.select(), this.selectedCells = t.cells, this.selectedElements = t.getCellElements(), this.selectedCell = t.cells[0], this.selectedElement = this.selectedElements[0])
                    }, p.unselectSelectedSlide = function() {
                        this.selectedSlide && this.selectedSlide.unselect()
                    }, p.selectInitialIndex = function() {
                        var t = this.options.initialIndex;
                        if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
                        else {
                            if (t && "string" == typeof t)
                                if (this.queryCell(t)) return void this.selectCell(t, !1, !0);
                            var e = 0;
                            t && this.slides[t] && (e = t), this.select(e, !1, !0)
                        }
                    }, p.selectCell = function(t, e, i) {
                        var n = this.queryCell(t);
                        if (n) {
                            var r = this.getCellSlideIndex(n);
                            this.select(r, e, i)
                        }
                    }, p.getCellSlideIndex = function(t) {
                        for (var e = 0; e < this.slides.length; e++) {
                            if (-1 != this.slides[e].cells.indexOf(t)) return e
                        }
                    }, p.getCell = function(t) {
                        for (var e = 0; e < this.cells.length; e++) {
                            var i = this.cells[e];
                            if (i.element == t) return i
                        }
                    }, p.getCells = function(t) {
                        t = n.makeArray(t);
                        var e = [];
                        return t.forEach((function(t) {
                            var i = this.getCell(t);
                            i && e.push(i)
                        }), this), e
                    }, p.getCellElements = function() {
                        return this.cells.map((function(t) {
                            return t.element
                        }))
                    }, p.getParentCell = function(t) {
                        var e = this.getCell(t);
                        return e || (t = n.getParent(t, ".flickity-slider > *"), this.getCell(t))
                    }, p.getAdjacentCellElements = function(t, e) {
                        if (!t) return this.selectedSlide.getCellElements();
                        e = void 0 === e ? this.selectedIndex : e;
                        var i = this.slides.length;
                        if (1 + 2 * t >= i) return this.getCellElements();
                        for (var r = [], o = e - t; o <= e + t; o++) {
                            var s = this.options.wrapAround ? n.modulo(o, i) : o,
                                a = this.slides[s];
                            a && (r = r.concat(a.getCellElements()))
                        }
                        return r
                    }, p.queryCell = function(t) {
                        if ("number" == typeof t) return this.cells[t];
                        if ("string" == typeof t) {
                            if (t.match(/^[#.]?[\d/]/)) return;
                            t = this.element.querySelector(t)
                        }
                        return this.getCell(t)
                    }, p.uiChange = function() {
                        this.emitEvent("uiChange")
                    }, p.childUIPointerDown = function(t) {
                        "touchstart" != t.type && t.preventDefault(), this.focus()
                    }, p.onresize = function() {
                        this.watchCSS(), this.resize()
                    }, n.debounceMethod(f, "onresize", 150), p.resize = function() {
                        if (this.isActive) {
                            this.getSize(), this.options.wrapAround && (this.x = n.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                            var t = this.selectedElements && this.selectedElements[0];
                            this.selectCell(t, !1, !0)
                        }
                    }, p.watchCSS = function() {
                        this.options.watchCSS && (-1 != l(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate())
                    }, p.onkeydown = function(t) {
                        var e = document.activeElement && document.activeElement != this.element;
                        if (this.options.accessibility && !e) {
                            var i = f.keyboardHandlers[t.keyCode];
                            i && i.call(this)
                        }
                    }, f.keyboardHandlers = {
                        37: function() {
                            var t = this.options.rightToLeft ? "next" : "previous";
                            this.uiChange(), this[t]()
                        },
                        39: function() {
                            var t = this.options.rightToLeft ? "previous" : "next";
                            this.uiChange(), this[t]()
                        }
                    }, p.focus = function() {
                        var e = t.pageYOffset;
                        this.element.focus({
                            preventScroll: !0
                        }), t.pageYOffset != e && t.scrollTo(t.pageXOffset, e)
                    }, p.deactivate = function() {
                        this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach((function(t) {
                            t.destroy()
                        })), this.element.removeChild(this.viewport), u(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
                    }, p.destroy = function() {
                        this.deactivate(), t.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), a && this.$element && a.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete d[this.guid]
                    }, n.extend(p, s), f.data = function(t) {
                        var e = (t = n.getQueryElement(t)) && t.flickityGUID;
                        return e && d[e]
                    }, n.htmlInit(f, "flickity"), a && a.bridget && a.bridget("flickity", f);
                    return f.setJQuery = function(t) {
                        a = t
                    }, f.Cell = r, f.Slide = o, f
                }(o, t, e, i, n, r, s)
            }.apply(e, n)) || (t.exports = r)
        }(window)
    }, function(t, e, i) {
        var n, r;
        "undefined" != typeof window && window, void 0 === (r = "function" == typeof(n = function() {
            "use strict";

            function t() {}
            var e = t.prototype;
            return e.on = function(t, e) {
                if (t && e) {
                    var i = this._events = this._events || {},
                        n = i[t] = i[t] || [];
                    return -1 == n.indexOf(e) && n.push(e), this
                }
            }, e.once = function(t, e) {
                if (t && e) {
                    this.on(t, e);
                    var i = this._onceEvents = this._onceEvents || {};
                    return (i[t] = i[t] || {})[e] = !0, this
                }
            }, e.off = function(t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    var n = i.indexOf(e);
                    return -1 != n && i.splice(n, 1), this
                }
            }, e.emitEvent = function(t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    i = i.slice(0), e = e || [];
                    for (var n = this._onceEvents && this._onceEvents[t], r = 0; r < i.length; r++) {
                        var o = i[r];
                        n && n[o] && (this.off(t, o), delete n[o]), o.apply(this, e)
                    }
                    return this
                }
            }, e.allOff = function() {
                delete this._events, delete this._onceEvents
            }, t
        }) ? n.call(e, i, e, t) : n) || (t.exports = r)
    }, function(t, e, i) {
        var n, r;
        /*!
         * Unipointer v2.3.0
         * base class for doing one thing with pointer event
         * MIT license
         */
        ! function(o, s) {
            n = [i(3)], void 0 === (r = function(t) {
                return function(t, e) {
                    "use strict";

                    function i() {}
                    var n = i.prototype = Object.create(e.prototype);
                    n.bindStartEvent = function(t) {
                        this._bindStartEvent(t, !0)
                    }, n.unbindStartEvent = function(t) {
                        this._bindStartEvent(t, !1)
                    }, n._bindStartEvent = function(e, i) {
                        var n = (i = void 0 === i || i) ? "addEventListener" : "removeEventListener",
                            r = "mousedown";
                        t.PointerEvent ? r = "pointerdown" : "ontouchstart" in t && (r = "touchstart"), e[n](r, this)
                    }, n.handleEvent = function(t) {
                        var e = "on" + t.type;
                        this[e] && this[e](t)
                    }, n.getTouch = function(t) {
                        for (var e = 0; e < t.length; e++) {
                            var i = t[e];
                            if (i.identifier == this.pointerIdentifier) return i
                        }
                    }, n.onmousedown = function(t) {
                        var e = t.button;
                        e && 0 !== e && 1 !== e || this._pointerDown(t, t)
                    }, n.ontouchstart = function(t) {
                        this._pointerDown(t, t.changedTouches[0])
                    }, n.onpointerdown = function(t) {
                        this._pointerDown(t, t)
                    }, n._pointerDown = function(t, e) {
                        t.button || this.isPointerDown || (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier, this.pointerDown(t, e))
                    }, n.pointerDown = function(t, e) {
                        this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e])
                    };
                    var r = {
                        mousedown: ["mousemove", "mouseup"],
                        touchstart: ["touchmove", "touchend", "touchcancel"],
                        pointerdown: ["pointermove", "pointerup", "pointercancel"]
                    };
                    return n._bindPostStartEvents = function(e) {
                        if (e) {
                            var i = r[e.type];
                            i.forEach((function(e) {
                                t.addEventListener(e, this)
                            }), this), this._boundPointerEvents = i
                        }
                    }, n._unbindPostStartEvents = function() {
                        this._boundPointerEvents && (this._boundPointerEvents.forEach((function(e) {
                            t.removeEventListener(e, this)
                        }), this), delete this._boundPointerEvents)
                    }, n.onmousemove = function(t) {
                        this._pointerMove(t, t)
                    }, n.onpointermove = function(t) {
                        t.pointerId == this.pointerIdentifier && this._pointerMove(t, t)
                    }, n.ontouchmove = function(t) {
                        var e = this.getTouch(t.changedTouches);
                        e && this._pointerMove(t, e)
                    }, n._pointerMove = function(t, e) {
                        this.pointerMove(t, e)
                    }, n.pointerMove = function(t, e) {
                        this.emitEvent("pointerMove", [t, e])
                    }, n.onmouseup = function(t) {
                        this._pointerUp(t, t)
                    }, n.onpointerup = function(t) {
                        t.pointerId == this.pointerIdentifier && this._pointerUp(t, t)
                    }, n.ontouchend = function(t) {
                        var e = this.getTouch(t.changedTouches);
                        e && this._pointerUp(t, e)
                    }, n._pointerUp = function(t, e) {
                        this._pointerDone(), this.pointerUp(t, e)
                    }, n.pointerUp = function(t, e) {
                        this.emitEvent("pointerUp", [t, e])
                    }, n._pointerDone = function() {
                        this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone()
                    }, n._pointerReset = function() {
                        this.isPointerDown = !1, delete this.pointerIdentifier
                    }, n.pointerDone = function() {}, n.onpointercancel = function(t) {
                        t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t)
                    }, n.ontouchcancel = function(t) {
                        var e = this.getTouch(t.changedTouches);
                        e && this._pointerCancel(t, e)
                    }, n._pointerCancel = function(t, e) {
                        this._pointerDone(), this.pointerCancel(t, e)
                    }, n.pointerCancel = function(t, e) {
                        this.emitEvent("pointerCancel", [t, e])
                    }, i.getPointerPoint = function(t) {
                        return {
                            x: t.pageX,
                            y: t.pageY
                        }
                    }, i
                }(o, t)
            }.apply(e, n)) || (t.exports = r)
        }(window)
    }, function(t, e) {
        t.exports = function(t, e, i) {
            var n = [],
                r = t.length;
            if (0 === r) return n;
            var o = e < 0 ? Math.max(0, e + r) : e || 0;
            for (void 0 !== i && (r = i < 0 ? i + r : i); r-- > o;) n[r - o] = t[r];
            return n
        }
    }, function(t, e, i) {
        var n, r;
        /*!
         * getSize v2.0.3
         * measure size of elements
         * MIT license
         */
        window, void 0 === (r = "function" == typeof(n = function() {
            "use strict";

            function t(t) {
                var e = parseFloat(t);
                return -1 == t.indexOf("%") && !isNaN(e) && e
            }
            var e = "undefined" == typeof console ? function() {} : function(t) {
                    console.error(t)
                },
                i = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
                n = i.length;

            function r(t) {
                var i = getComputedStyle(t);
                return i || e("Style returned " + i + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), i
            }
            var o, s = !1;

            function a(e) {
                if (function() {
                        if (!s) {
                            s = !0;
                            var e = document.createElement("div");
                            e.style.width = "200px", e.style.padding = "1px 2px 3px 4px", e.style.borderStyle = "solid", e.style.borderWidth = "1px 2px 3px 4px", e.style.boxSizing = "border-box";
                            var i = document.body || document.documentElement;
                            i.appendChild(e);
                            var n = r(e);
                            o = 200 == Math.round(t(n.width)), a.isBoxSizeOuter = o, i.removeChild(e)
                        }
                    }(), "string" == typeof e && (e = document.querySelector(e)), e && "object" == typeof e && e.nodeType) {
                    var l = r(e);
                    if ("none" == l.display) return function() {
                        for (var t = {
                                width: 0,
                                height: 0,
                                innerWidth: 0,
                                innerHeight: 0,
                                outerWidth: 0,
                                outerHeight: 0
                            }, e = 0; e < n; e++) t[i[e]] = 0;
                        return t
                    }();
                    var c = {};
                    c.width = e.offsetWidth, c.height = e.offsetHeight;
                    for (var u = c.isBorderBox = "border-box" == l.boxSizing, h = 0; h < n; h++) {
                        var d = i[h],
                            f = l[d],
                            p = parseFloat(f);
                        c[d] = isNaN(p) ? 0 : p
                    }
                    var g = c.paddingLeft + c.paddingRight,
                        v = c.paddingTop + c.paddingBottom,
                        m = c.marginLeft + c.marginRight,
                        y = c.marginTop + c.marginBottom,
                        _ = c.borderLeftWidth + c.borderRightWidth,
                        b = c.borderTopWidth + c.borderBottomWidth,
                        x = u && o,
                        w = t(l.width);
                    !1 !== w && (c.width = w + (x ? 0 : g + _));
                    var T = t(l.height);
                    return !1 !== T && (c.height = T + (x ? 0 : v + b)), c.innerWidth = c.width - (g + _), c.innerHeight = c.height - (v + b), c.outerWidth = c.width + m, c.outerHeight = c.height + y, c
                }
            }
            return a
        }) ? n.call(e, i, e, t) : n) || (t.exports = r)
    }, function(t, e, i) {
        var n = i(17),
            r = i(18),
            o = i(19),
            s = i(21);
        t.exports = function(t, e) {
            return n(t) || r(t, e) || o(t, e) || s()
        }
    }, function(t, e, i) {
        var n = i(23);
        t.exports = function(t, e) {
            if (null == t) return {};
            var i, r, o = n(t, e);
            if (Object.getOwnPropertySymbols) {
                var s = Object.getOwnPropertySymbols(t);
                for (r = 0; r < s.length; r++) i = s[r], e.indexOf(i) >= 0 || Object.prototype.propertyIsEnumerable.call(t, i) && (o[i] = t[i])
            }
            return o
        }
    }, function(t, e) {
        t.exports = function(t, e) {
            for (var i = 0, n = t.length; i < n; i++)
                if (!e(t[i], i, t)) return !1;
            return !0
        }
    }, , , , , , , , function(t, e) {
        t.exports = function(t) {
            if (Array.isArray(t)) return t
        }
    }, function(t, e) {
        t.exports = function(t, e) {
            if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) {
                var i = [],
                    n = !0,
                    r = !1,
                    o = void 0;
                try {
                    for (var s, a = t[Symbol.iterator](); !(n = (s = a.next()).done) && (i.push(s.value), !e || i.length !== e); n = !0);
                } catch (t) {
                    r = !0, o = t
                } finally {
                    try {
                        n || null == a.return || a.return()
                    } finally {
                        if (r) throw o
                    }
                }
                return i
            }
        }
    }, function(t, e, i) {
        var n = i(20);
        t.exports = function(t, e) {
            if (t) {
                if ("string" == typeof t) return n(t, e);
                var i = Object.prototype.toString.call(t).slice(8, -1);
                return "Object" === i && t.constructor && (i = t.constructor.name), "Map" === i || "Set" === i ? Array.from(t) : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i) ? n(t, e) : void 0
            }
        }
    }, function(t, e) {
        t.exports = function(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
            return n
        }
    }, function(t, e) {
        t.exports = function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
        }
    }, function(t, e, i) {}, function(t, e) {
        t.exports = function(t, e) {
            if (null == t) return {};
            var i, n, r = {},
                o = Object.keys(t);
            for (n = 0; n < o.length; n++) i = o[n], e.indexOf(i) >= 0 || (r[i] = t[i]);
            return r
        }
    }, function(t, e, i) {
        var n, r;
        ! function(o, s) {
            "use strict";
            void 0 === (r = "function" == typeof(n = s) ? n.call(e, i, e, t) : n) || (t.exports = r)
        }(window, (function() {
            "use strict";
            var t = function() {
                var t = window.Element.prototype;
                if (t.matches) return "matches";
                if (t.matchesSelector) return "matchesSelector";
                for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
                    var n = e[i] + "MatchesSelector";
                    if (t[n]) return n
                }
            }();
            return function(e, i) {
                return e[t](i)
            }
        }))
    }, function(t, e, i) {
        var n, r;
        window, n = [i(6)], void 0 === (r = function(t) {
            return function(t, e) {
                "use strict";

                function i(t, e) {
                    this.element = t, this.parent = e, this.create()
                }
                var n = i.prototype;
                return n.create = function() {
                    this.element.style.position = "absolute", this.element.setAttribute("aria-hidden", "true"), this.x = 0, this.shift = 0
                }, n.destroy = function() {
                    this.unselect(), this.element.style.position = "";
                    var t = this.parent.originSide;
                    this.element.style[t] = "", this.element.removeAttribute("aria-hidden")
                }, n.getSize = function() {
                    this.size = e(this.element)
                }, n.setPosition = function(t) {
                    this.x = t, this.updateTarget(), this.renderPosition(t)
                }, n.updateTarget = n.setDefaultTarget = function() {
                    var t = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
                    this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign
                }, n.renderPosition = function(t) {
                    var e = this.parent.originSide;
                    this.element.style[e] = this.parent.getPositionValue(t)
                }, n.select = function() {
                    this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden")
                }, n.unselect = function() {
                    this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true")
                }, n.wrapShift = function(t) {
                    this.shift = t, this.renderPosition(this.x + this.parent.slideableWidth * t)
                }, n.remove = function() {
                    this.element.parentNode.removeChild(this.element)
                }, i
            }(0, t)
        }.apply(e, n)) || (t.exports = r)
    }, function(t, e, i) {
        var n, r;
        window, void 0 === (r = "function" == typeof(n = function() {
            "use strict";

            function t(t) {
                this.parent = t, this.isOriginLeft = "left" == t.originSide, this.cells = [], this.outerWidth = 0, this.height = 0
            }
            var e = t.prototype;
            return e.addCell = function(t) {
                if (this.cells.push(t), this.outerWidth += t.size.outerWidth, this.height = Math.max(t.size.outerHeight, this.height), 1 == this.cells.length) {
                    this.x = t.x;
                    var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                    this.firstMargin = t.size[e]
                }
            }, e.updateTarget = function() {
                var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                    e = this.getLastCell(),
                    i = e ? e.size[t] : 0,
                    n = this.outerWidth - (this.firstMargin + i);
                this.target = this.x + this.firstMargin + n * this.parent.cellAlign
            }, e.getLastCell = function() {
                return this.cells[this.cells.length - 1]
            }, e.select = function() {
                this.cells.forEach((function(t) {
                    t.select()
                }))
            }, e.unselect = function() {
                this.cells.forEach((function(t) {
                    t.unselect()
                }))
            }, e.getCellElements = function() {
                return this.cells.map((function(t) {
                    return t.element
                }))
            }, t
        }) ? n.call(e, i, e, t) : n) || (t.exports = r)
    }, function(t, e, i) {
        var n, r;
        window, n = [i(1)], void 0 === (r = function(t) {
            return function(t, e) {
                "use strict";
                var i = {
                    startAnimation: function() {
                        this.isAnimating || (this.isAnimating = !0, this.restingFrames = 0, this.animate())
                    },
                    animate: function() {
                        this.applyDragForce(), this.applySelectedAttraction();
                        var t = this.x;
                        if (this.integratePhysics(), this.positionSlider(), this.settle(t), this.isAnimating) {
                            var e = this;
                            requestAnimationFrame((function() {
                                e.animate()
                            }))
                        }
                    },
                    positionSlider: function() {
                        var t = this.x;
                        this.options.wrapAround && this.cells.length > 1 && (t = e.modulo(t, this.slideableWidth), t -= this.slideableWidth, this.shiftWrapCells(t)), this.setTranslateX(t, this.isAnimating), this.dispatchScrollEvent()
                    },
                    setTranslateX: function(t, e) {
                        t += this.cursorPosition, t = this.options.rightToLeft ? -t : t;
                        var i = this.getPositionValue(t);
                        this.slider.style.transform = e ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")"
                    },
                    dispatchScrollEvent: function() {
                        var t = this.slides[0];
                        if (t) {
                            var e = -this.x - t.target,
                                i = e / this.slidesWidth;
                            this.dispatchEvent("scroll", null, [i, e])
                        }
                    },
                    positionSliderAtSelected: function() {
                        this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider())
                    },
                    getPositionValue: function(t) {
                        return this.options.percentPosition ? .01 * Math.round(t / this.size.innerWidth * 1e4) + "%" : Math.round(t) + "px"
                    },
                    settle: function(t) {
                        !this.isPointerDown && Math.round(100 * this.x) == Math.round(100 * t) && this.restingFrames++, this.restingFrames > 2 && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]))
                    },
                    shiftWrapCells: function(t) {
                        var e = this.cursorPosition + t;
                        this._shiftCells(this.beforeShiftCells, e, -1);
                        var i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
                        this._shiftCells(this.afterShiftCells, i, 1)
                    },
                    _shiftCells: function(t, e, i) {
                        for (var n = 0; n < t.length; n++) {
                            var r = t[n],
                                o = e > 0 ? i : 0;
                            r.wrapShift(o), e -= r.size.outerWidth
                        }
                    },
                    _unshiftCells: function(t) {
                        if (t && t.length)
                            for (var e = 0; e < t.length; e++) t[e].wrapShift(0)
                    },
                    integratePhysics: function() {
                        this.x += this.velocity, this.velocity *= this.getFrictionFactor()
                    },
                    applyForce: function(t) {
                        this.velocity += t
                    },
                    getFrictionFactor: function() {
                        return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
                    },
                    getRestingPosition: function() {
                        return this.x + this.velocity / (1 - this.getFrictionFactor())
                    },
                    applyDragForce: function() {
                        if (this.isDraggable && this.isPointerDown) {
                            var t = this.dragX - this.x - this.velocity;
                            this.applyForce(t)
                        }
                    },
                    applySelectedAttraction: function() {
                        if ((!this.isDraggable || !this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                            var t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                            this.applyForce(t)
                        }
                    }
                };
                return i
            }(0, t)
        }.apply(e, n)) || (t.exports = r)
    }, function(t, e, i) {
        var n, r;
        ! function(o, s) {
            n = [i(2), i(29), i(1)], void 0 === (r = function(t, e, i) {
                return function(t, e, i, n) {
                    "use strict";
                    n.extend(e.defaults, {
                        draggable: ">1",
                        dragThreshold: 3
                    }), e.createMethods.push("_createDrag");
                    var r = e.prototype;
                    n.extend(r, i.prototype), r._touchActionValue = "pan-y";
                    var o = "createTouch" in document,
                        s = !1;
                    r._createDrag = function() {
                        this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), o && !s && (t.addEventListener("touchmove", (function() {})), s = !0)
                    }, r.onActivateDrag = function() {
                        this.handles = [this.viewport], this.bindHandles(), this.updateDraggable()
                    }, r.onDeactivateDrag = function() {
                        this.unbindHandles(), this.element.classList.remove("is-draggable")
                    }, r.updateDraggable = function() {
                        ">1" == this.options.draggable ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable, this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
                    }, r.bindDrag = function() {
                        this.options.draggable = !0, this.updateDraggable()
                    }, r.unbindDrag = function() {
                        this.options.draggable = !1, this.updateDraggable()
                    }, r._uiChangeDrag = function() {
                        delete this.isFreeScrolling
                    }, r.pointerDown = function(e, i) {
                        this.isDraggable ? this.okayPointerDown(e) && (this._pointerDownPreventDefault(e), this.pointerDownFocus(e), document.activeElement != this.element && this.pointerDownBlur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = l(), t.addEventListener("scroll", this), this._pointerDownDefault(e, i)) : this._pointerDownDefault(e, i)
                    }, r._pointerDownDefault = function(t, e) {
                        this.pointerDownPointer = {
                            pageX: e.pageX,
                            pageY: e.pageY
                        }, this._bindPostStartEvents(t), this.dispatchEvent("pointerDown", t, [e])
                    };
                    var a = {
                        INPUT: !0,
                        TEXTAREA: !0,
                        SELECT: !0
                    };

                    function l() {
                        return {
                            x: t.pageXOffset,
                            y: t.pageYOffset
                        }
                    }
                    return r.pointerDownFocus = function(t) {
                        a[t.target.nodeName] || this.focus()
                    }, r._pointerDownPreventDefault = function(t) {
                        var e = "touchstart" == t.type,
                            i = "touch" == t.pointerType,
                            n = a[t.target.nodeName];
                        e || i || n || t.preventDefault()
                    }, r.hasDragStarted = function(t) {
                        return Math.abs(t.x) > this.options.dragThreshold
                    }, r.pointerUp = function(t, e) {
                        delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", t, [e]), this._dragPointerUp(t, e)
                    }, r.pointerDone = function() {
                        t.removeEventListener("scroll", this), delete this.pointerDownScroll
                    }, r.dragStart = function(e, i) {
                        this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), t.removeEventListener("scroll", this), this.dispatchEvent("dragStart", e, [i]))
                    }, r.pointerMove = function(t, e) {
                        var i = this._dragPointerMove(t, e);
                        this.dispatchEvent("pointerMove", t, [e, i]), this._dragMove(t, e, i)
                    }, r.dragMove = function(t, e, i) {
                        if (this.isDraggable) {
                            t.preventDefault(), this.previousDragX = this.dragX;
                            var n = this.options.rightToLeft ? -1 : 1;
                            this.options.wrapAround && (i.x %= this.slideableWidth);
                            var r = this.dragStartPosition + i.x * n;
                            if (!this.options.wrapAround && this.slides.length) {
                                var o = Math.max(-this.slides[0].target, this.dragStartPosition);
                                r = r > o ? .5 * (r + o) : r;
                                var s = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                                r = r < s ? .5 * (r + s) : r
                            }
                            this.dragX = r, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", t, [e, i])
                        }
                    }, r.dragEnd = function(t, e) {
                        if (this.isDraggable) {
                            this.options.freeScroll && (this.isFreeScrolling = !0);
                            var i = this.dragEndRestingSelect();
                            if (this.options.freeScroll && !this.options.wrapAround) {
                                var n = this.getRestingPosition();
                                this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target
                            } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
                            delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(i), delete this.isDragSelect, this.dispatchEvent("dragEnd", t, [e])
                        }
                    }, r.dragEndRestingSelect = function() {
                        var t = this.getRestingPosition(),
                            e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                            i = this._getClosestResting(t, e, 1),
                            n = this._getClosestResting(t, e, -1);
                        return i.distance < n.distance ? i.index : n.index
                    }, r._getClosestResting = function(t, e, i) {
                        for (var n = this.selectedIndex, r = 1 / 0, o = this.options.contain && !this.options.wrapAround ? function(t, e) {
                                return t <= e
                            } : function(t, e) {
                                return t < e
                            }; o(e, r) && (n += i, r = e, null !== (e = this.getSlideDistance(-t, n)));) e = Math.abs(e);
                        return {
                            distance: r,
                            index: n - i
                        }
                    }, r.getSlideDistance = function(t, e) {
                        var i = this.slides.length,
                            r = this.options.wrapAround && i > 1,
                            o = r ? n.modulo(e, i) : e,
                            s = this.slides[o];
                        if (!s) return null;
                        var a = r ? this.slideableWidth * Math.floor(e / i) : 0;
                        return t - (s.target + a)
                    }, r.dragEndBoostSelect = function() {
                        if (void 0 === this.previousDragX || !this.dragMoveTime || new Date - this.dragMoveTime > 100) return 0;
                        var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
                            e = this.previousDragX - this.dragX;
                        return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0
                    }, r.staticClick = function(t, e) {
                        var i = this.getParentCell(t.target),
                            n = i && i.element,
                            r = i && this.cells.indexOf(i);
                        this.dispatchEvent("staticClick", t, [e, n, r])
                    }, r.onscroll = function() {
                        var t = l(),
                            e = this.pointerDownScroll.x - t.x,
                            i = this.pointerDownScroll.y - t.y;
                        (Math.abs(e) > 3 || Math.abs(i) > 3) && this._pointerDone()
                    }, e
                }(o, t, e, i)
            }.apply(e, n)) || (t.exports = r)
        }(window)
    }, function(t, e, i) {
        var n, r;
        /*!
         * Unidragger v2.3.1
         * Draggable base class
         * MIT license
         */
        // !function(o,s){n=[i(4)],void 0===(r=function(t){return function(t,e){"use strict";function i(){}var n=i.prototype=Object.create(e.prototype);n.bindHandles=function(){this._bindHandles(!0)},n.unbindHandles=function(){this._bindHandles(!1)},n._bindHandles=function(e){for(var i=(e=void 0===e||e)?"addEventListener":"removeEventListener",n=e?this._touchActionValue:"",r=0;r<this.handles.length;r++){var o=this.handles[r];this._bindStartEvent(o,e),o[i]("click",this),t.PointerEvent&&(o.style.touchAction=n)}},n._touchActionValue="none",n.pointerDown=function(t,e){this.okayPointerDown(t)&&(this.pointerDownPointer={pageX:e.pageX,pageY:e.pageY},t.preventDefault(),this.pointerDownBlur(),this._bindPostStartEvents(t),this.emitEvent("pointerDown",[t,e]))};var r={TEXTAREA:!0,INPUT:!0,SELECT:!0,OPTION:!0},o={radio:!0,checkbox:!0,button:!0,submit:!0,image:!0,file:!0};return n.okayPointerDown=function(t){var e=r[t.target.nodeName],i=o[t.target.type],n=!e||i;return n||this._pointerReset(),n},n.pointerDownBlur=function(){var t=document.activeElement;t&&t.blur&&t!=document.body&&t.blur()},n.pointerMove=function(t,e){var i=this._dragPointerMove(t,e);this.emitEvent("pointerMove",[t,e,i]),this._dragMove(t,e,i)},n._dragPointerMove=function(t,e){var i={x:e.pageX-this.pointerDownPointer.pageX,y:e.pageY-this.pointerDownPointer.pageY};return!this.isDragging&&this.hasDragStarted(i)&&this._dragStart(t,e),i},n.hasDragStarted=function(t){return Math.abs(t.x)>3||Math.abs(t.y)>3},n.pointerUp=function(t,e){this.emitEvent("pointerUp",[t,e]),this._dragPointerUp(t,e)},n._dragPointerUp=function(t,e){this.isDragging?this._dragEnd(t,e):this._staticClick(t,e)},n._dragStart=function(t,e){this.isDragging=!0,this.isPreventingClicks=!0,this.dragStart(t,e)},n.dragStart=function(t,e){this.emitEvent("dragStart",[t,e])},n._dragMove=function(t,e,i){this.isDragging&&this.dragMove(t,e,i)},n.dragMove=function(t,e,i){t.preventDefault(),this.emitEvent("dragMove",[t,e,i])},n._dragEnd=function(t,e){this.isDragging=!1,setTimeout(function(){delete this.isPreventingClicks}.bind(this)),this.dragEnd(t,e)},n.dragEnd=function(t,e){this.emitEvent("dragEnd",[t,e])},n.onclick=function(t){this.isPreventingClicks&&t.preventDefault()},n._staticClick=function(t,e){this.isIgnoringMouseUp&&"mouseup"==t.type||(this.staticClick(t,e),"mouseup"!=t.type&&(this.isIgnoringMouseUp=!0,setTimeout(function(){delete this.isIgnoringMouseUp}.bind(this),400)))},n.staticClick=function(t,e){this.emitEvent("staticClick",[t,e])},i.getPointerPoint=e.getPointerPoint,i}(o,t)}.apply(e,n))||(t.exports=r)}(window)},function(t,e,i){var n,r;window,n=[i(2),i(4),i(1)],void 0===(r=function(t,e,i){return function(t,e,i,n){"use strict";var r="http://www.w3.org/2000/svg";function o(t,e){this.direction=t,this.parent=e,this._create()}o.prototype=Object.create(i.prototype),o.prototype._create=function(){this.isEnabled=!0,this.isPrevious=-1==this.direction;var t=this.parent.options.rightToLeft?1:-1;this.isLeft=this.direction==t;var e=this.element=document.createElement("button");e.className="flickity-button flickity-prev-next-button",e.className+=this.isPrevious?" previous":" next",e.setAttribute("type","button"),this.disable(),e.setAttribute("aria-label",this.isPrevious?"Previous":"Next");var i=this.createSVG();e.appendChild(i),this.parent.on("select",this.update.bind(this)),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},o.prototype.activate=function(){this.bindStartEvent(this.element),this.element.addEventListener("click",this),this.parent.element.appendChild(this.element)},o.prototype.deactivate=function(){this.parent.element.removeChild(this.element),this.unbindStartEvent(this.element),this.element.removeEventListener("click",this)},o.prototype.createSVG=function(){var t=document.createElementNS(r,"svg");t.setAttribute("class","flickity-button-icon"),t.setAttribute("viewBox","0 0 100 100");var e,i=document.createElementNS(r,"path"),n="string"==typeof(e=this.parent.options.arrowShape)?e:"M "+e.x0+",50 L "+e.x1+","+(e.y1+50)+" L "+e.x2+","+(e.y2+50)+" L "+e.x3+",50  L "+e.x2+","+(50-e.y2)+" L "+e.x1+","+(50-e.y1)+" Z";return i.setAttribute("d",n),i.setAttribute("class","arrow"),this.isLeft||i.setAttribute("transform","translate(100, 100) rotate(180) "),t.appendChild(i),t},o.prototype.handleEvent=n.handleEvent,o.prototype.onclick=function(){if(this.isEnabled){this.parent.uiChange();var t=this.isPrevious?"previous":"next";this.parent[t]()}},o.prototype.enable=function(){this.isEnabled||(this.element.disabled=!1,this.isEnabled=!0)},o.prototype.disable=function(){this.isEnabled&&(this.element.disabled=!0,this.isEnabled=!1)},o.prototype.update=function(){var t=this.parent.slides;if(this.parent.options.wrapAround&&t.length>1)this.enable();else{var e=t.length?t.length-1:0,i=this.isPrevious?0:e;this[this.parent.selectedIndex==i?"disable":"enable"]()}},o.prototype.destroy=function(){this.deactivate(),this.allOff()},n.extend(e.defaults,{prevNextButtons:!0,arrowShape:{x0:10,x1:60,y1:50,x2:70,y2:40,x3:30}}),e.createMethods.push("_createPrevNextButtons");var s=e.prototype;return s._createPrevNextButtons=function(){this.options.prevNextButtons&&(this.prevButton=new o(-1,this),this.nextButton=new o(1,this),this.on("activate",this.activatePrevNextButtons))},s.activatePrevNextButtons=function(){this.prevButton.activate(),this.nextButton.activate(),this.on("deactivate",this.deactivatePrevNextButtons)},s.deactivatePrevNextButtons=function(){this.prevButton.deactivate(),this.nextButton.deactivate(),this.off("deactivate",this.deactivatePrevNextButtons)},e.PrevNextButton=o,e}(0,t,e,i)}.apply(e,n))||(t.exports=r)},function(t,e,i){var n,r;window,n=[i(2),i(4),i(1)],void 0===(r=function(t,e,i){return function(t,e,i,n){"use strict";function r(t){this.parent=t,this._create()}r.prototype=Object.create(i.prototype),r.prototype._create=function(){this.holder=document.createElement("ol"),this.holder.className="flickity-page-dots",this.dots=[],this.handleClick=this.onClick.bind(this),this.on("pointerDown",this.parent.childUIPointerDown.bind(this.parent))},r.prototype.activate=function(){this.setDots(),this.holder.addEventListener("click",this.handleClick),this.bindStartEvent(this.holder),this.parent.element.appendChild(this.holder)},r.prototype.deactivate=function(){this.holder.removeEventListener("click",this.handleClick),this.unbindStartEvent(this.holder),this.parent.element.removeChild(this.holder)},r.prototype.setDots=function(){var t=this.parent.slides.length-this.dots.length;t>0?this.addDots(t):t<0&&this.removeDots(-t)},r.prototype.addDots=function(t){for(var e=document.createDocumentFragment(),i=[],n=this.dots.length,r=n+t,o=n;o<r;o++){var s=document.createElement("li");s.className="dot",s.setAttribute("aria-label","Page dot "+(o+1)),e.appendChild(s),i.push(s)}this.holder.appendChild(e),this.dots=this.dots.concat(i)},r.prototype.removeDots=function(t){this.dots.splice(this.dots.length-t,t).forEach((function(t){this.holder.removeChild(t)}),this)},r.prototype.updateSelected=function(){this.selectedDot&&(this.selectedDot.className="dot",this.selectedDot.removeAttribute("aria-current")),this.dots.length&&(this.selectedDot=this.dots[this.parent.selectedIndex],this.selectedDot.className="dot is-selected",this.selectedDot.setAttribute("aria-current","step"))},r.prototype.onTap=r.prototype.onClick=function(t){var e=t.target;if("LI"==e.nodeName){this.parent.uiChange();var i=this.dots.indexOf(e);this.parent.select(i)}},r.prototype.destroy=function(){this.deactivate(),this.allOff()},e.PageDots=r,n.extend(e.defaults,{pageDots:!0}),e.createMethods.push("_createPageDots");var o=e.prototype;return o._createPageDots=function(){this.options.pageDots&&(this.pageDots=new r(this),this.on("activate",this.activatePageDots),this.on("select",this.updateSelectedPageDots),this.on("cellChange",this.updatePageDots),this.on("resize",this.updatePageDots),this.on("deactivate",this.deactivatePageDots))},o.activatePageDots=function(){this.pageDots.activate()},o.updateSelectedPageDots=function(){this.pageDots.updateSelected()},o.updatePageDots=function(){this.pageDots.setDots()},o.deactivatePageDots=function(){this.pageDots.deactivate()},e.PageDots=r,e}(0,t,e,i)}.apply(e,n))||(t.exports=r)},function(t,e,i){var n,r;window,n=[i(3),i(1),i(2)],void 0===(r=function(t,e,i){return function(t,e,i){"use strict";function n(t){this.parent=t,this.state="stopped",this.onVisibilityChange=this.visibilityChange.bind(this),this.onVisibilityPlay=this.visibilityPlay.bind(this)}n.prototype=Object.create(t.prototype),n.prototype.play=function(){"playing"!=this.state&&(document.hidden?document.addEventListener("visibilitychange",this.onVisibilityPlay):(this.state="playing",document.addEventListener("visibilitychange",this.onVisibilityChange),this.tick()))},n.prototype.tick=function(){if("playing"==this.state){var t=this.parent.options.autoPlay;t="number"==typeof t?t:3e3;var e=this;this.clear(),this.timeout=setTimeout((function(){e.parent.next(!0),e.tick()}),t)}},n.prototype.stop=function(){this.state="stopped",this.clear(),document.removeEventListener("visibilitychange",this.onVisibilityChange)},n.prototype.clear=function(){clearTimeout(this.timeout)},n.prototype.pause=function(){"playing"==this.state&&(this.state="paused",this.clear())},n.prototype.unpause=function(){"paused"==this.state&&this.play()},n.prototype.visibilityChange=function(){this[document.hidden?"pause":"unpause"]()},n.prototype.visibilityPlay=function(){this.play(),document.removeEventListener("visibilitychange",this.onVisibilityPlay)},e.extend(i.defaults,{pauseAutoPlayOnHover:!0}),i.createMethods.push("_createPlayer");var r=i.prototype;return r._createPlayer=function(){this.player=new n(this),this.on("activate",this.activatePlayer),this.on("uiChange",this.stopPlayer),this.on("pointerDown",this.stopPlayer),this.on("deactivate",this.deactivatePlayer)},r.activatePlayer=function(){this.options.autoPlay&&(this.player.play(),this.element.addEventListener("mouseenter",this))},r.playPlayer=function(){this.player.play()},r.stopPlayer=function(){this.player.stop()},r.pausePlayer=function(){this.player.pause()},r.unpausePlayer=function(){this.player.unpause()},r.deactivatePlayer=function(){this.player.stop(),this.element.removeEventListener("mouseenter",this)},r.onmouseenter=function(){this.options.pauseAutoPlayOnHover&&(this.player.pause(),this.element.addEventListener("mouseleave",this))},r.onmouseleave=function(){this.player.unpause(),this.element.removeEventListener("mouseleave",this)},i.Player=n,i}(t,e,i)}.apply(e,n))||(t.exports=r)},function(t,e,i){var n,r;window,n=[i(2),i(1)],void 0===(r=function(t,e){return function(t,e,i){"use strict";var n=e.prototype;return n.insert=function(t,e){var i=this._makeCells(t);if(i&&i.length){var n=this.cells.length;e=void 0===e?n:e;var r=function(t){var e=document.createDocumentFragment();return t.forEach((function(t){e.appendChild(t.element)})),e}(i),o=e==n;if(o)this.slider.appendChild(r);else{var s=this.cells[e].element;this.slider.insertBefore(r,s)}if(0===e)this.cells=i.concat(this.cells);else if(o)this.cells=this.cells.concat(i);else{var a=this.cells.splice(e,n-e);this.cells=this.cells.concat(i).concat(a)}this._sizeCells(i),this.cellChange(e,!0)}},n.append=function(t){this.insert(t,this.cells.length)},n.prepend=function(t){this.insert(t,0)},n.remove=function(t){var e=this.getCells(t);if(e&&e.length){var n=this.cells.length-1;e.forEach((function(t){t.remove();var e=this.cells.indexOf(t);n=Math.min(e,n),i.removeFrom(this.cells,t)}),this),this.cellChange(n,!0)}},n.cellSizeChange=function(t){var e=this.getCell(t);if(e){e.getSize();var i=this.cells.indexOf(e);this.cellChange(i)}},n.cellChange=function(t,e){var i=this.selectedElement;this._positionCells(t),this._getWrapShiftCells(),this.setGallerySize();var n=this.getCell(i);n&&(this.selectedIndex=this.getCellSlideIndex(n)),this.selectedIndex=Math.min(this.slides.length-1,this.selectedIndex),this.emitEvent("cellChange",[t]),this.select(this.selectedIndex),e&&this.positionSliderAtSelected()},e}(0,t,e)}.apply(e,n))||(t.exports=r)},function(t,e,i){var n,r;window,n=[i(2),i(1)],void 0===(r=function(t,e){return function(t,e,i){"use strict";e.createMethods.push("_createLazyload");var n=e.prototype;function r(t,e){this.img=t,this.flickity=e,this.load()}return n._createLazyload=function(){this.on("select",this.lazyLoad)},n.lazyLoad=function(){var t=this.options.lazyLoad;if(t){var e="number"==typeof t?t:0,n=this.getAdjacentCellElements(e),o=[];n.forEach((function(t){var e=function(t){if("IMG"==t.nodeName){var e=t.getAttribute("data-flickity-lazyload"),n=t.getAttribute("data-flickity-lazyload-src"),r=t.getAttribute("data-flickity-lazyload-srcset");if(e||n||r)return[t]}var o=t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");return i.makeArray(o)}(t);o=o.concat(e)})),o.forEach((function(t){new r(t,this)}),this)}},r.prototype.handleEvent=i.handleEvent,r.prototype.load=function(){this.img.addEventListener("load",this),this.img.addEventListener("error",this);var t=this.img.getAttribute("data-flickity-lazyload")||this.img.getAttribute("data-flickity-lazyload-src"),e=this.img.getAttribute("data-flickity-lazyload-srcset");this.img.src=t,e&&this.img.setAttribute("srcset",e),this.img.removeAttribute("data-flickity-lazyload"),this.img.removeAttribute("data-flickity-lazyload-src"),this.img.removeAttribute("data-flickity-lazyload-srcset")},r.prototype.onload=function(t){this.complete(t,"flickity-lazyloaded")},r.prototype.onerror=function(t){this.complete(t,"flickity-lazyerror")},r.prototype.complete=function(t,e){this.img.removeEventListener("load",this),this.img.removeEventListener("error",this);var i=this.flickity.getParentCell(this.img),n=i&&i.element;this.flickity.cellSizeChange(n),this.img.classList.add(e),this.flickity.dispatchEvent("lazyLoad",t,n)},e.LazyLoader=r,e}(0,t,e)}.apply(e,n))||(t.exports=r)},function(t,e,i){"use strict";i.r(e);var n=i(7),r=i.n(n),o=(i(22),i(5)),s=i.n(o);window.slater=Object.assign(window.slater||{},{qs:function(t,e){return(e||document).querySelector(t)},qsa:function(t,e){return s()((e||document).querySelectorAll(t))},gebtn:function(t,e){return s()((e||document).getElementsByTagName(t))},gebi:function(t){return document.getElementById(t)}});var a,l,c,u,h,d,f,p,g,v,m=[];function y(t,e){return l=window.pageXOffset,u=window.pageYOffset,d=window.innerHeight,p=window.innerWidth,c||(c=l),h||(h=u),g||(g=p),f||(f=d),(e||u!==h||l!==c||d!==f||p!==g)&&(function(t){for(var e=0;e<m.length;e++)m[e]({x:l,y:u,px:c,py:h,vh:d,pvh:f,vw:p,pvw:g},t)}(t),c=l,h=u,f=d,g=p),requestAnimationFrame(y)}function _(){v&&v.update()}function b(t){var e;void 0===t&&(t="data-src");for(var i=document.querySelectorAll("["+t+"]"),n=function(n){var r,o,s=i[n],l="IMG"===s.nodeName?s:s.getElementsByTagName("img")[0],c=s.getAttribute(t);l.onload=function(){s.classList.add("is-loaded")},s.removeAttribute(t),e=(r=s,void 0===o&&(o={}),function(t,e){var i=!1,n=parseFloat(r.getAttribute("data-threshold")||o.threshold||0);return function(t){return m.indexOf(t)<0&&m.push(t),a=a||y(performance.now()),{update:function(){y(performance.now(),!0)},destroy:function(){m.splice(m.indexOf(t),1)}}}((function(){for(var o=[],s=arguments.length;s--;)o[s]=arguments[s];var a=o[0],l=a.y,c=a.vh,u=r.getBoundingClientRect(),h=u.top+l,d=n>=.5?n:n*c,f=h+u.height-d>=l&&h+d<=l+c;f&&!i?(i=!0,t&&t.apply(void 0,o)):!f&&i&&(i=!1,e&&e.apply(void 0,o))}))})((function(){s.classList.add("is-visible"),l.src=c}))},r=0;r<i.length;r++)n(r);e&&(e.update(),v||(v=e))}var x=function(t){if("object"!=typeof(e=t)||Array.isArray(e))throw"state should be an object";var e},w=function(t,e,i,n){return(r=t,r.reduce((function(t,e,i){return t.indexOf(e)>-1?t:t.concat(e)}),[])).reduce((function(t,i){return t.concat(e[i]||[])}),[]).map((function(t){return t(i,n)}));var r};function T(t){void 0===t&&(t={});var e={};return{getState:function(){return Object.assign({},t)},hydrate:function(i){return x(i),Object.assign(t,i),function(){var n=["*"].concat(Object.keys(i));w(n,e,t)}},on:function(t,i){return(t=[].concat(t)).map((function(t){return e[t]=(e[t]||[]).concat(i)})),function(){return t.map((function(t){return e[t].splice(e[t].indexOf(i),1)}))}},emit:function(i,n,r){var o=("*"===i?[]:["*"]).concat(i);(n="function"==typeof n?n(t):n)&&(x(n),Object.assign(t,n),o=o.concat(Object.keys(n))),w(o,e,t,r)}}}T();var S=function(t){return"object"==typeof t&&!Array.isArray(t)},A=function(t){return"function"==typeof t};function C(t){return function(e,i){var n=[];return{subs:n,unmount:t(e,Object.assign({},i,{on:function(t,e){var r=i.on(t,e);return n.push(r),r}})),node:e}}}function k(t,e){if(!Array.isArray(t))return e(t);for(var i=0;i<t.length;i++)e(t[i])}function L(t){return function(e,i,n){return k(e,(function(e){return e[t+"EventListener"](i,n)}))}}function E(t){return function(e){for(var i=arguments.length,n=new Array(i>1?i-1:0),r=1;r<i;r++)n[r-1]=arguments[r];return k(e,(function(e){var i;return(i=e.classList)[t].apply(i,n)}))}}function O(t,e,i){return L("add")(t,e,i),function(){return L("remove")(t,e,i)}}function P(t){for(var e=arguments.length,i=new Array(e>1?e-1:0),n=1;n<e;n++)i[n-1]=arguments[n];E("add").apply(void 0,[t].concat(i))}function M(t,e){return void 0===e&&(e=document),e.querySelector(t)}var D=function(t,e){return void 0===t&&(t=document.body),void 0===e&&(e="js-"),[].slice.call(t.querySelectorAll('*[class*="'+e+'"]')).reduce((function(t,i){var n=i.className.split(e)[1].split(" ")[0];return t[n]=t[n]?t[n].constructor===Array?t[n].concat(i):[t[n],i]:i,t}),{})},R=C((function(t,e){for(var i=D(t),n=i.announce,r=i.announceClose,o=t.querySelector(".js-cart-count"),s=t.querySelectorAll(".js-cart-drawer-toggle"),a=0;a<s.length;a++)s[a].addEventListener("click",(function(t){t.preventDefault(),e.emit("cart:toggle",(function(t){return{cartOpen:!t.cartOpen}}))}));e.on("cart:updated",(function(t){o.innerHTML=t.cart.item_count})),o.innerHTML=e.getState().cart.item_count,O(window,"scroll",(function(){var e=window.pageYOffset;document.documentElement.clientWidth>850&&-1==window.location.href.indexOf("about")&&(e>200?t.classList.contains("hasBlur")||t.classList.add("hasBlur"):t.classList.contains("hasBlur")&&t.classList.remove("hasBlur"))})),O(r,"click",(function(){n.classList.add("dn")}))})),q=function(t,e){return e=e||{},new Promise((function(i,n){var r=new XMLHttpRequest,o=[],s=[],a={},l=function(){return{ok:2==(r.status/100|0),statusText:r.statusText,status:r.status,url:r.responseURL,text:function(){return Promise.resolve(r.responseText)},json:function(){return Promise.resolve(r.responseText).then(JSON.parse)},blob:function(){return Promise.resolve(new Blob([r.response]))},clone:l,headers:{keys:function(){return o},entries:function(){return s},get:function(t){return a[t.toLowerCase()]},has:function(t){return t.toLowerCase()in a}}}};for(var c in r.open(e.method||"get",t,!0),r.onload=function(){r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,(function(t,e,i){o.push(e=e.toLowerCase()),s.push([e,i]),a[e]=a[e]?a[e]+","+i:i})),i(l())},r.onerror=n,r.withCredentials="include"==e.credentials,e.headers)r.setRequestHeader(c,e.headers[c]);r.send(e.body||null)}))};function z(t,e,i){var n="deny"===t.inventory_policy&&"shopify"===t.inventory_management?t.inventory_quantity:null;return F().then((function(r){var o=((r.items.filter((function(e){return e.id===t.id}))[0]||{}).quantity||0)+e;if(null!==n&&o>n){var s="There are only ".concat(n," of that product available, requested ").concat(o,".");throw na.emit("error",s),new Error(s)}return function(t,e,i){return na.emit("cart:updating"),q("/cart/add.js",{method:"POST",credentials:"include",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:t,quantity:e,selling_plan:i})}).then((function(t){return t.json()})).then((function(t){return F().then((function(e){return na.hydrate({cart:e}),na.emit("cart:updated"),console.log(t,'success'),na.emit("cart:toggle",(function(t){return{cartOpen:!t.cartOpen}})),{item:t,cart:e}}))}))}(t.id,e,i)}))}function I(t,e,i){return F().then((function(n){for(var r=n.items,o=0;o<r.length;o++)if(null!=e){if(r[o].selling_plan_allocation&&r[o].variant_id===parseInt(t)&&r[o].selling_plan_allocation.selling_plan.id===parseInt(e))return B(o+1,i)}else if(r[o].variant_id===parseInt(t))return B(o+1,i)}))}function B(t,e){return na.emit("cart:updating"),q("/cart/change.js",{method:"POST",credentials:"include",headers:{"Content-Type":"application/json"},body:JSON.stringify({line:t,quantity:e})}).then((function(t){return t.json()})).then((function(t){return na.hydrate({cart:t}),na.emit("cart:updated",{cart:t}),t}))}function F(){return q("/cart.js",{method:"GET",credentials:"include"}).then((function(t){return t.json()}))}function j(t,e){var i="undefined"!=typeof Symbol&&t[Symbol.iterator]||t["@@iterator"];if(!i){if(Array.isArray(t)||(i=function(t,e){if(!t)return;if("string"==typeof t)return N(t,e);var i=Object.prototype.toString.call(t).slice(8,-1);"Object"===i&&t.constructor&&(i=t.constructor.name);if("Map"===i||"Set"===i)return Array.from(t);if("Arguments"===i||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i))return N(t,e)}(t))||e&&t&&"number"==typeof t.length){i&&(t=i);var n=0,r=function(){};return{s:r,n:function(){return n>=t.length?{done:!0}:{done:!1,value:t[n++]}},e:function(t){throw t},f:r}}throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}var o,s=!0,a=!1;return{s:function(){i=i.call(t)},n:function(){var t=i.next();return s=t.done,t},e:function(t){a=!0,o=t},f:function(){try{s||null==i.return||i.return()}finally{if(a)throw o}}}}function N(t,e){(null==e||e>t.length)&&(e=t.length);for(var i=0,n=new Array(e);i<e;i++)n[i]=t[i];return n}var H={};function W(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:window.location.pathname.split("/").reverse()[0],e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{};return H[t]&&!e.refetch?Promise.resolve(H[t]):fetch(window.location.origin+"/products/"+t+".json").then((function(t){return t.json()})).then((function(e){var i=e.product;return H[t]=i,i}))}var U=C((function(t){t.node;var e=function(t,e){e=Object.assign({select:"[data-option-select]",radio:"[data-option-radio]",main:"[data-option-main]"},e);var i=[],n={id:null,options:[]},r=slater.qsa(e.select),o=slater.qsa(e.radio),s=slater.qs(e.main);if(!s||!s.length)throw"data-option-main is missing";if(o.length>3)throw"you have more than three radio groups";if(r.length>3)throw"you have more than three select inputs";var a=[].slice.call(s.children).reduce((function(t,e){return t[e.innerHTML]=e.value,t}),{});function l(){n.id=a[n.options.join(" / ")],s.value=n.id;var t,e=j(i);try{for(e.s();!(t=e.n()).done;){(0,t.value)(n)}}catch(t){e.e(t)}finally{e.f()}}return r.forEach((function(t){if("SELECT"!==t.nodeName)throw"data-option-select should be defined on the individual option selectors";var e=parseInt(t.getAttribute("data-index"));n.options[e]=t.value,t.addEventListener("change",(function(t){n.options[e]=t.target.value,l()}))})),o.forEach((function(t){if("INPUT"===t.nodeName)throw"data-option-radio should be defined on a parent of the radio group, not the inputs themselves";var e=parseInt(t.getAttribute("data-index")),i=[].slice.call(t.getElementsByTagName("input"));i.forEach((function(t){t.checked&&(n.options[e]=t.value)})),function(t,e){t.map((function(t){return t.onclick=function(t){return e(t.target.value)}}))}(i,(function(t){n.options[e]=t,l()}))})),l(),{get state(){return n},onUpdate:function(t){return i.indexOf(t)<0&&i.push(t),function(){return i.splice(i.indexOf(t),1)}}}}();W(),e.onUpdate((function(t){W().then((function(e){e.variants.filter((function(e){return e.id==t.id}))[0]}))}))})),X=i(8),Y=i.n(X);function V(t,e){if(null===e)return t;if("master"===e)return G(t);var i=t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);if(i){var n=t.split(i[0]),r=i[0];return G(n[0]+"_"+e+r)}return null}function G(t){return t.replace(/http(s)?:/,"")}function Q(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"${{amount}}";"string"==typeof t&&(t=t.replace(".",""));var i="",n=/\{\{\s*(\w+)\s*\}\}/;function r(t,e,i,n){if(e=e||2,i=i||",",n=n||".",isNaN(t)||null==t)return 0;var r=(t=(t/100).toFixed(e)).split(".");return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+i)+(r[1]?n+r[1]:"")}switch(e.match(n)[1]){case"amount":i=r(t,2);break;case"amount_no_decimals":i=r(t,0);break;case"amount_with_space_separator":i=r(t,2," ",".");break;case"amount_no_decimals_with_comma_separator":i=r(t,0,",",".");break;case"amount_no_decimals_with_space_separator":i=r(t,0," ")}return e.replace(n,i)}var K=["variant_id","product_title","line_price","variant_title","image","url","quantity","properties"];function J(t){return t.length>0?t.reduce((function(t,e){return t+=function(t){var e=t.variant_id,i=t.product_title,n=t.line_price,r=(t.variant_title,t.image),o=t.url,s=t.quantity,a=(t.properties,Y()(t,K)),l=r?V(r.replace("."+function(t){var e=t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);return e?e[1]:null}(r),""),"200x"):"https://source.unsplash.com/R9OS29xJb-8/2000x1333";return"\n<div class='cart-drawer__item mb30' data-component='cartDrawerItem' data-id=".concat(e," ").concat(a.selling_plan_allocation?"data-planid='".concat(a.selling_plan_allocation.selling_plan.id,"'"):"",">\n  <div class='df aic cart-item x'>\n    <a class=\"cart-itemImg\" href='").concat(o,"'>\n      <img src='").concat(l,'\' alt="moment drink functional beverage"/>\n    </a>\n    <div class=\'__content c-black x\'>\n      <div class="x">\n        <div class="df x jcb">\n          <a href=\'').concat(o,"' class='serif f22 x'>").concat(i,'</a>\n          <button aria-label="close" type="button" class=\'button--reset js-remove-item df\'>').concat('<svg viewBox="0 0 40.867 40.867">\n  <g data-name="Group 327" fill="none" stroke="#000" stroke-linecap="round" stroke-width="3">\n    <path data-name="Path 118" d="M1.061 1.061l38.745 38.745"/>\n    <path data-name="Path 119" d="M39.806 1.061L1.061 39.806"/>\n  </g>\n</svg>','</button>\n        </div>\n        <div class="mt10 f16">').concat(a.selling_plan_allocation?a.selling_plan_allocation.selling_plan.name:"onetime","</div>\n        <div class=\"df jcb x mt10\">\n          <div class='df aic f16'>\n            <div class=\"mr15\">QTY</div>\n            <div class='cart-quantity js-remove-single mr10 point'>–</div>\n            <div class='js-single-quantity'>").concat(s,"</div>\n            <div class='cart-quantity js-add-single ml10 point'>+</div>\n          </div>\n          <div class='f16 sansm'>").concat(Q(n),"</div>\n        </div>\n      </div>\n\n      \n    </div>\n  </div>\n</div>\n")}(e)}),""):"<div class='pv1'><p class='i'>Your cart is empty</p></div>"}var Z=C((function(t,e){var i=t.querySelector(".js-overlay"),n=t.querySelector(".js-close"),r=t.querySelector(".js-subtotal"),o=t.querySelector(".js-items"),s=o.innerHTML,a=function(t){o.innerHTML=J(t.items),r.innerHTML=Q(t.total_price)},l=function(){t.classList.remove("is-visible"),setTimeout((function(){t.classList.remove("is-active"),na.hydrate({cartOpen:!1})}),400),i.classList.add("pen")};a(e.getState().cart),i.addEventListener("click",l),n.addEventListener("click",l),e.on("cart:toggle",(function(e){var n=e.cart;e.cartOpen&&function(e){t.classList.add("is-active"),o.innerHTML=s,setTimeout((function(){t.classList.add("is-visible"),setTimeout(a(e),10),na.mount()}),50),i.classList.remove("pen")}(n)})),e.on("cart:updated",(function(){a(e.getState().cart),na.mount()}))})),tt=C((function(t,e){var i=t.querySelector(".js-remove-item"),n=t.querySelector(".js-remove-single"),r=t.querySelector(".js-add-single"),o=t.querySelector(".js-single-quantity").innerHTML,s=t.getAttribute("data-id"),a=t.getAttribute("data-planid");i.addEventListener("click",(function(t){t.preventDefault(),function(t,e){I(t,e,0)}(s,a)})),n.addEventListener("click",(function(t){t.preventDefault(),I(s,a,parseInt(o)-1)})),r.addEventListener("click",(function(t){t.preventDefault(),I(s,a,parseInt(o)+1)}))})),et=C((function(t,e){var i=t.querySelector(".js-login-dialog"),n=t.querySelector(".js-recover-dialog"),r=t.querySelector(".js-recover-trigger"),o=t.querySelector(".js-recover-cancel"),s=!!window.location.hash.match(/\#recover/),a=null!==t.querySelector(".js-recover-success");s||a?(i.style.display="none",n.style.display="block"):i.style.display="block",r.addEventListener("click",(function(t){t.preventDefault(),i.style.display="none",n.style.display="block"})),o.addEventListener("click",(function(t){t.preventDefault(),n.style.display="none",i.style.display="block"}))})),it=C((function(t,e){var i,n=JSON.parse(t.querySelector(".js-product-json").innerHTML),r=t.querySelector("form"),o=n.selectedOrFirstAvailableVariant,s=n.product;s.variants.filter((function(t){return t.id===o}))[0];r.addEventListener("submit",(function(e){e.preventDefault(),i="recharge"==r.elements.id.dataset.type&&t.querySelector(".js-sellingPlan")?parseInt(t.querySelector(".js-sellingPlan").value):null;var n=r.elements.quantity?r.elements.quantity.value:1;z(s.variants.filter((function(t){return t.id===parseInt(r.elements.id.value)}))[0],n,i)}))})),nt=C((function(t,e){var i,n=JSON.parse(document.querySelector(".js-product-json").innerHTML),r=t.querySelector("form"),o=n.selectedOrFirstAvailableVariant,s=n.product.variants.filter((function(t){return t.id===o}))[0];r.addEventListener("submit",(function(e){e.preventDefault(),i="recharge"==r.elements.id.value?parseInt(t.querySelector(".js-sellingPlan").value):null,z(s,1,i)}))})),rt=C((function(t,e){var i=JSON.parse(t.querySelector(".js-product-json").innerHTML),n=i.selectedOrFirstAvailableVariant,r=i.product.variants.filter((function(t){return t.id===n}))[0];t.addEventListener("click",(function(){if("recharge"==form.elements.id.dataset.type){var t=document.querySelector("#rc_shipping_interval_frequency").value;z(r,form.elements.quantity.value,t)}else z(r,form.elements.quantity.value)}))})),ot=C((function(t,e){var i=t.querySelector(".js-counter-remove"),n=t.querySelector(".js-counter-add"),r=t.querySelector(".js-counter-quantity"),o=parseInt(r.attributes.min.value),s=parseInt(r.attributes.max.value),a=parseInt(r.value),l=function(t){a=Math.max(o,Math.min(t,s||1e4)),r.value=a};i.addEventListener("click",(function(t){t.preventDefault(),l(--a)})),n.addEventListener("click",(function(t){t.preventDefault(),l(++a)}))}));function st(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function at(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t,t.__proto__=e}
        ! function(o, s) {
            n = [i(4)], void 0 === (r = function(t) {
                return function(t, e) {
                    "use strict";

                    function i() {}
                    var n = i.prototype = Object.create(e.prototype);
                    n.bindHandles = function() {
                        this._bindHandles(!0)
                    }, n.unbindHandles = function() {
                        this._bindHandles(!1)
                    }, n._bindHandles = function(e) {
                        for (var i = (e = void 0 === e || e) ? "addEventListener" : "removeEventListener", n = e ? this._touchActionValue : "", r = 0; r < this.handles.length; r++) {
                            var o = this.handles[r];
                            this._bindStartEvent(o, e), o[i]("click", this), t.PointerEvent && (o.style.touchAction = n)
                        }
                    }, n._touchActionValue = "none", n.pointerDown = function(t, e) {
                        this.okayPointerDown(t) && (this.pointerDownPointer = {
                            pageX: e.pageX,
                            pageY: e.pageY
                        }, t.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]))
                    };
                    var r = {
                            TEXTAREA: !0,
                            INPUT: !0,
                            SELECT: !0,
                            OPTION: !0
                        },
                        o = {
                            radio: !0,
                            checkbox: !0,
                            button: !0,
                            submit: !0,
                            image: !0,
                            file: !0
                        };
                    return n.okayPointerDown = function(t) {
                        var e = r[t.target.nodeName],
                            i = o[t.target.type],
                            n = !e || i;
                        return n || this._pointerReset(), n
                    }, n.pointerDownBlur = function() {
                        var t = document.activeElement;
                        t && t.blur && t != document.body && t.blur()
                    }, n.pointerMove = function(t, e) {
                        var i = this._dragPointerMove(t, e);
                        this.emitEvent("pointerMove", [t, e, i]), this._dragMove(t, e, i)
                    }, n._dragPointerMove = function(t, e) {
                        var i = {
                            x: e.pageX - this.pointerDownPointer.pageX,
                            y: e.pageY - this.pointerDownPointer.pageY
                        };
                        return !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e), i
                    }, n.hasDragStarted = function(t) {
                        return Math.abs(t.x) > 3 || Math.abs(t.y) > 3
                    }, n.pointerUp = function(t, e) {
                        this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e)
                    }, n._dragPointerUp = function(t, e) {
                        this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e)
                    }, n._dragStart = function(t, e) {
                        this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart(t, e)
                    }, n.dragStart = function(t, e) {
                        this.emitEvent("dragStart", [t, e])
                    }, n._dragMove = function(t, e, i) {
                        this.isDragging && this.dragMove(t, e, i)
                    }, n.dragMove = function(t, e, i) {
                        t.preventDefault(), this.emitEvent("dragMove", [t, e, i])
                    }, n._dragEnd = function(t, e) {
                        this.isDragging = !1, setTimeout(function() {
                            delete this.isPreventingClicks
                        }.bind(this)), this.dragEnd(t, e)
                    }, n.dragEnd = function(t, e) {
                        this.emitEvent("dragEnd", [t, e])
                    }, n.onclick = function(t) {
                        this.isPreventingClicks && t.preventDefault()
                    }, n._staticClick = function(t, e) {
                        this.isIgnoringMouseUp && "mouseup" == t.type || (this.staticClick(t, e), "mouseup" != t.type && (this.isIgnoringMouseUp = !0, setTimeout(function() {
                            delete this.isIgnoringMouseUp
                        }.bind(this), 400)))
                    }, n.staticClick = function(t, e) {
                        this.emitEvent("staticClick", [t, e])
                    }, i.getPointerPoint = e.getPointerPoint, i
                }(o, t)
            }.apply(e, n)) || (t.exports = r)
        }(window)
    },
    function(t, e, i) {
        var n, r;
        window, n = [i(2), i(4), i(1)], void 0 === (r = function(t, e, i) {
            return function(t, e, i, n) {
                "use strict";
                var r = "http://www.w3.org/2000/svg";

                function o(t, e) {
                    this.direction = t, this.parent = e, this._create()
                }
                o.prototype = Object.create(i.prototype), o.prototype._create = function() {
                    this.isEnabled = !0, this.isPrevious = -1 == this.direction;
                    var t = this.parent.options.rightToLeft ? 1 : -1;
                    this.isLeft = this.direction == t;
                    var e = this.element = document.createElement("button");
                    e.className = "flickity-button flickity-prev-next-button", e.className += this.isPrevious ? " previous" : " next", e.setAttribute("type", "button"), this.disable(), e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                    var i = this.createSVG();
                    e.appendChild(i), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
                }, o.prototype.activate = function() {
                    this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element)
                }, o.prototype.deactivate = function() {
                    this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this)
                }, o.prototype.createSVG = function() {
                    var t = document.createElementNS(r, "svg");
                    t.setAttribute("class", "flickity-button-icon"), t.setAttribute("viewBox", "0 0 100 100");
                    var e, i = document.createElementNS(r, "path"),
                        n = "string" == typeof(e = this.parent.options.arrowShape) ? e : "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z";
                    return i.setAttribute("d", n), i.setAttribute("class", "arrow"), this.isLeft || i.setAttribute("transform", "translate(100, 100) rotate(180) "), t.appendChild(i), t
                }, o.prototype.handleEvent = n.handleEvent, o.prototype.onclick = function() {
                    if (this.isEnabled) {
                        this.parent.uiChange();
                        var t = this.isPrevious ? "previous" : "next";
                        this.parent[t]()
                    }
                }, o.prototype.enable = function() {
                    this.isEnabled || (this.element.disabled = !1, this.isEnabled = !0)
                }, o.prototype.disable = function() {
                    this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
                }, o.prototype.update = function() {
                    var t = this.parent.slides;
                    if (this.parent.options.wrapAround && t.length > 1) this.enable();
                    else {
                        var e = t.length ? t.length - 1 : 0,
                            i = this.isPrevious ? 0 : e;
                        this[this.parent.selectedIndex == i ? "disable" : "enable"]()
                    }
                }, o.prototype.destroy = function() {
                    this.deactivate(), this.allOff()
                }, n.extend(e.defaults, {
                    prevNextButtons: !0,
                    arrowShape: {
                        x0: 10,
                        x1: 60,
                        y1: 50,
                        x2: 70,
                        y2: 40,
                        x3: 30
                    }
                }), e.createMethods.push("_createPrevNextButtons");
                var s = e.prototype;
                return s._createPrevNextButtons = function() {
                    this.options.prevNextButtons && (this.prevButton = new o(-1, this), this.nextButton = new o(1, this), this.on("activate", this.activatePrevNextButtons))
                }, s.activatePrevNextButtons = function() {
                    this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
                }, s.deactivatePrevNextButtons = function() {
                    this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
                }, e.PrevNextButton = o, e
            }(0, t, e, i)
        }.apply(e, n)) || (t.exports = r)
    },
    function(t, e, i) {
        var n, r;
        window, n = [i(2), i(4), i(1)], void 0 === (r = function(t, e, i) {
            return function(t, e, i, n) {
                "use strict";

                function r(t) {
                    this.parent = t, this._create()
                }
                r.prototype = Object.create(i.prototype), r.prototype._create = function() {
                    this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", this.dots = [], this.handleClick = this.onClick.bind(this), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
                }, r.prototype.activate = function() {
                    this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder)
                }, r.prototype.deactivate = function() {
                    this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder)
                }, r.prototype.setDots = function() {
                    var t = this.parent.slides.length - this.dots.length;
                    t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t)
                }, r.prototype.addDots = function(t) {
                    for (var e = document.createDocumentFragment(), i = [], n = this.dots.length, r = n + t, o = n; o < r; o++) {
                        var s = document.createElement("li");
                        s.className = "dot", s.setAttribute("aria-label", "Page dot " + (o + 1)), e.appendChild(s), i.push(s)
                    }
                    this.holder.appendChild(e), this.dots = this.dots.concat(i)
                }, r.prototype.removeDots = function(t) {
                    this.dots.splice(this.dots.length - t, t).forEach((function(t) {
                        this.holder.removeChild(t)
                    }), this)
                }, r.prototype.updateSelected = function() {
                    this.selectedDot && (this.selectedDot.className = "dot", this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected", this.selectedDot.setAttribute("aria-current", "step"))
                }, r.prototype.onTap = r.prototype.onClick = function(t) {
                    var e = t.target;
                    if ("LI" == e.nodeName) {
                        this.parent.uiChange();
                        var i = this.dots.indexOf(e);
                        this.parent.select(i)
                    }
                }, r.prototype.destroy = function() {
                    this.deactivate(), this.allOff()
                }, e.PageDots = r, n.extend(e.defaults, {
                    pageDots: !0
                }), e.createMethods.push("_createPageDots");
                var o = e.prototype;
                return o._createPageDots = function() {
                    this.options.pageDots && (this.pageDots = new r(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
                }, o.activatePageDots = function() {
                    this.pageDots.activate()
                }, o.updateSelectedPageDots = function() {
                    this.pageDots.updateSelected()
                }, o.updatePageDots = function() {
                    this.pageDots.setDots()
                }, o.deactivatePageDots = function() {
                    this.pageDots.deactivate()
                }, e.PageDots = r, e
            }(0, t, e, i)
        }.apply(e, n)) || (t.exports = r)
    },
    function(t, e, i) {
        var n, r;
        window, n = [i(3), i(1), i(2)], void 0 === (r = function(t, e, i) {
            return function(t, e, i) {
                "use strict";

                function n(t) {
                    this.parent = t, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this)
                }
                n.prototype = Object.create(t.prototype), n.prototype.play = function() {
                    "playing" != this.state && (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : (this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()))
                }, n.prototype.tick = function() {
                    if ("playing" == this.state) {
                        var t = this.parent.options.autoPlay;
                        t = "number" == typeof t ? t : 3e3;
                        var e = this;
                        this.clear(), this.timeout = setTimeout((function() {
                            e.parent.next(!0), e.tick()
                        }), t)
                    }
                }, n.prototype.stop = function() {
                    this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange)
                }, n.prototype.clear = function() {
                    clearTimeout(this.timeout)
                }, n.prototype.pause = function() {
                    "playing" == this.state && (this.state = "paused", this.clear())
                }, n.prototype.unpause = function() {
                    "paused" == this.state && this.play()
                }, n.prototype.visibilityChange = function() {
                    this[document.hidden ? "pause" : "unpause"]()
                }, n.prototype.visibilityPlay = function() {
                    this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay)
                }, e.extend(i.defaults, {
                    pauseAutoPlayOnHover: !0
                }), i.createMethods.push("_createPlayer");
                var r = i.prototype;
                return r._createPlayer = function() {
                    this.player = new n(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
                }, r.activatePlayer = function() {
                    this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
                }, r.playPlayer = function() {
                    this.player.play()
                }, r.stopPlayer = function() {
                    this.player.stop()
                }, r.pausePlayer = function() {
                    this.player.pause()
                }, r.unpausePlayer = function() {
                    this.player.unpause()
                }, r.deactivatePlayer = function() {
                    this.player.stop(), this.element.removeEventListener("mouseenter", this)
                }, r.onmouseenter = function() {
                    this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
                }, r.onmouseleave = function() {
                    this.player.unpause(), this.element.removeEventListener("mouseleave", this)
                }, i.Player = n, i
            }(t, e, i)
        }.apply(e, n)) || (t.exports = r)
    },
    function(t, e, i) {
        var n, r;
        window, n = [i(2), i(1)], void 0 === (r = function(t, e) {
            return function(t, e, i) {
                "use strict";
                var n = e.prototype;
                return n.insert = function(t, e) {
                    var i = this._makeCells(t);
                    if (i && i.length) {
                        var n = this.cells.length;
                        e = void 0 === e ? n : e;
                        var r = function(t) {
                                var e = document.createDocumentFragment();
                                return t.forEach((function(t) {
                                    e.appendChild(t.element)
                                })), e
                            }(i),
                            o = e == n;
                        if (o) this.slider.appendChild(r);
                        else {
                            var s = this.cells[e].element;
                            this.slider.insertBefore(r, s)
                        }
                        if (0 === e) this.cells = i.concat(this.cells);
                        else if (o) this.cells = this.cells.concat(i);
                        else {
                            var a = this.cells.splice(e, n - e);
                            this.cells = this.cells.concat(i).concat(a)
                        }
                        this._sizeCells(i), this.cellChange(e, !0)
                    }
                }, n.append = function(t) {
                    this.insert(t, this.cells.length)
                }, n.prepend = function(t) {
                    this.insert(t, 0)
                }, n.remove = function(t) {
                    var e = this.getCells(t);
                    if (e && e.length) {
                        var n = this.cells.length - 1;
                        e.forEach((function(t) {
                            t.remove();
                            var e = this.cells.indexOf(t);
                            n = Math.min(e, n), i.removeFrom(this.cells, t)
                        }), this), this.cellChange(n, !0)
                    }
                }, n.cellSizeChange = function(t) {
                    var e = this.getCell(t);
                    if (e) {
                        e.getSize();
                        var i = this.cells.indexOf(e);
                        this.cellChange(i)
                    }
                }, n.cellChange = function(t, e) {
                    var i = this.selectedElement;
                    this._positionCells(t), this._getWrapShiftCells(), this.setGallerySize();
                    var n = this.getCell(i);
                    n && (this.selectedIndex = this.getCellSlideIndex(n)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [t]), this.select(this.selectedIndex), e && this.positionSliderAtSelected()
                }, e
            }(0, t, e)
        }.apply(e, n)) || (t.exports = r)
    },
    function(t, e, i) {
        var n, r;
        window, n = [i(2), i(1)], void 0 === (r = function(t, e) {
            return function(t, e, i) {
                "use strict";
                e.createMethods.push("_createLazyload");
                var n = e.prototype;

                function r(t, e) {
                    this.img = t, this.flickity = e, this.load()
                }
                return n._createLazyload = function() {
                    this.on("select", this.lazyLoad)
                }, n.lazyLoad = function() {
                    var t = this.options.lazyLoad;
                    if (t) {
                        var e = "number" == typeof t ? t : 0,
                            n = this.getAdjacentCellElements(e),
                            o = [];
                        n.forEach((function(t) {
                            var e = function(t) {
                                if ("IMG" == t.nodeName) {
                                    var e = t.getAttribute("data-flickity-lazyload"),
                                        n = t.getAttribute("data-flickity-lazyload-src"),
                                        r = t.getAttribute("data-flickity-lazyload-srcset");
                                    if (e || n || r) return [t]
                                }
                                var o = t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");
                                return i.makeArray(o)
                            }(t);
                            o = o.concat(e)
                        })), o.forEach((function(t) {
                            new r(t, this)
                        }), this)
                    }
                }, r.prototype.handleEvent = i.handleEvent, r.prototype.load = function() {
                    this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                    var t = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                        e = this.img.getAttribute("data-flickity-lazyload-srcset");
                    this.img.src = t, e && this.img.setAttribute("srcset", e), this.img.removeAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload-src"), this.img.removeAttribute("data-flickity-lazyload-srcset")
                }, r.prototype.onload = function(t) {
                    this.complete(t, "flickity-lazyloaded")
                }, r.prototype.onerror = function(t) {
                    this.complete(t, "flickity-lazyerror")
                }, r.prototype.complete = function(t, e) {
                    this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                    var i = this.flickity.getParentCell(this.img),
                        n = i && i.element;
                    this.flickity.cellSizeChange(n), this.img.classList.add(e), this.flickity.dispatchEvent("lazyLoad", t, n)
                }, e.LazyLoader = r, e
            }(0, t, e)
        }.apply(e, n)) || (t.exports = r)
    },
    function(t, e, i) {
        "use strict";
        i.r(e);
        var n = i(7),
            r = i.n(n),
            o = (i(22), i(5)),
            s = i.n(o);
        window.slater = Object.assign(window.slater || {}, {
            qs: function(t, e) {
                return (e || document).querySelector(t)
            },
            qsa: function(t, e) {
                return s()((e || document).querySelectorAll(t))
            },
            gebtn: function(t, e) {
                return s()((e || document).getElementsByTagName(t))
            },
            gebi: function(t) {
                return document.getElementById(t)
            }
        });
        var a, l, c, u, h, d, f, p, g, v, m = [];

        function y(t, e) {
            return l = window.pageXOffset, u = window.pageYOffset, d = window.innerHeight, p = window.innerWidth, c || (c = l), h || (h = u), g || (g = p), f || (f = d), (e || u !== h || l !== c || d !== f || p !== g) && (function(t) {
                for (var e = 0; e < m.length; e++) m[e]({
                    x: l,
                    y: u,
                    px: c,
                    py: h,
                    vh: d,
                    pvh: f,
                    vw: p,
                    pvw: g
                }, t)
            }(t), c = l, h = u, f = d, g = p), requestAnimationFrame(y)
        }

        function _() {
            v && v.update()
        }

        function b(t) {
            var e;
            void 0 === t && (t = "data-src");
            for (var i = document.querySelectorAll("[" + t + "]"), n = function(n) {
                    var r, o, s = i[n],
                        l = "IMG" === s.nodeName ? s : s.getElementsByTagName("img")[0],
                        c = s.getAttribute(t);
                    l.onload = function() {
                        s.classList.add("is-loaded")
                    }, s.removeAttribute(t), e = (r = s, void 0 === o && (o = {}), function(t, e) {
                        var i = !1,
                            n = parseFloat(r.getAttribute("data-threshold") || o.threshold || 0);
                        return function(t) {
                            return m.indexOf(t) < 0 && m.push(t), a = a || y(performance.now()), {
                                update: function() {
                                    y(performance.now(), !0)
                                },
                                destroy: function() {
                                    m.splice(m.indexOf(t), 1)
                                }
                            }
                        }((function() {
                            for (var o = [], s = arguments.length; s--;) o[s] = arguments[s];
                            var a = o[0],
                                l = a.y,
                                c = a.vh,
                                u = r.getBoundingClientRect(),
                                h = u.top + l,
                                d = n >= .5 ? n : n * c,
                                f = h + u.height - d >= l && h + d <= l + c;
                            f && !i ? (i = !0, t && t.apply(void 0, o)) : !f && i && (i = !1, e && e.apply(void 0, o))
                        }))
                    })((function() {
                        s.classList.add("is-visible"), l.src = c
                    }))
                }, r = 0; r < i.length; r++) n(r);
            e && (e.update(), v || (v = e))
        }
        var x = function(t) {
                if ("object" != typeof(e = t) || Array.isArray(e)) throw "state should be an object";
                var e
            },
            w = function(t, e, i, n) {
                return (r = t, r.reduce((function(t, e, i) {
                    return t.indexOf(e) > -1 ? t : t.concat(e)
                }), [])).reduce((function(t, i) {
                    return t.concat(e[i] || [])
                }), []).map((function(t) {
                    return t(i, n)
                }));
                var r
            };

        function T(t) {
            void 0 === t && (t = {});
            var e = {};
            return {
                getState: function() {
                    return Object.assign({}, t)
                },
                hydrate: function(i) {
                    return x(i), Object.assign(t, i),
                        function() {
                            var n = ["*"].concat(Object.keys(i));
                            w(n, e, t)
                        }
                },
                on: function(t, i) {
                    return (t = [].concat(t)).map((function(t) {
                            return e[t] = (e[t] || []).concat(i)
                        })),
                        function() {
                            return t.map((function(t) {
                                return e[t].splice(e[t].indexOf(i), 1)
                            }))
                        }
                },
                emit: function(i, n, r) {
                    var o = ("*" === i ? [] : ["*"]).concat(i);
                    (n = "function" == typeof n ? n(t) : n) && (x(n), Object.assign(t, n), o = o.concat(Object.keys(n))), w(o, e, t, r)
                }
            }
        }
        T();
        var S = function(t) {
                return "object" == typeof t && !Array.isArray(t)
            },
            A = function(t) {
                return "function" == typeof t
            };

        function C(t) {
            return function(e, i) {
                var n = [];
                return {
                    subs: n,
                    unmount: t(e, Object.assign({}, i, {
                        on: function(t, e) {
                            var r = i.on(t, e);
                            return n.push(r), r
                        }
                    })),
                    node: e
                }
            }
        }

        function k(t, e) {
            if (!Array.isArray(t)) return e(t);
            for (var i = 0; i < t.length; i++) e(t[i])
        }

        function L(t) {
            return function(e, i, n) {
                return k(e, (function(e) {
                    return e[t + "EventListener"](i, n)
                }))
            }
        }

        function E(t) {
            return function(e) {
                for (var i = arguments.length, n = new Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++) n[r - 1] = arguments[r];
                return k(e, (function(e) {
                    var i;
                    return (i = e.classList)[t].apply(i, n)
                }))
            }
        }

        function O(t, e, i) {
            return L("add")(t, e, i),
                function() {
                    return L("remove")(t, e, i)
                }
        }

        function P(t) {
            for (var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) i[n - 1] = arguments[n];
            E("add").apply(void 0, [t].concat(i))
        }

        function M(t, e) {
            return void 0 === e && (e = document), e.querySelector(t)
        }
        var D = function(t, e) {
                return void 0 === t && (t = document.body), void 0 === e && (e = "js-"), [].slice.call(t.querySelectorAll('*[class*="' + e + '"]')).reduce((function(t, i) {
                    var n = i.className.split(e)[1].split(" ")[0];
                    return t[n] = t[n] ? t[n].constructor === Array ? t[n].concat(i) : [t[n], i] : i, t
                }), {})
            },
            R = C((function(t, e) {
                for (var i = D(t), n = i.announce, r = i.announceClose, o = t.querySelector(".js-cart-count"), s = t.querySelectorAll(".js-cart-drawer-toggle"), a = 0; a < s.length; a++) s[a].addEventListener("click", (function(t) {
                    t.preventDefault(), e.emit("cart:toggle", (function(t) {
                        return {
                            cartOpen: !t.cartOpen
                        }
                    }))
                }));
                e.on("cart:updated", (function(t) {
                    o.innerHTML = t.cart.item_count
                })), o.innerHTML = e.getState().cart.item_count, O(window, "scroll", (function() {
                    var e = window.pageYOffset;
                    document.documentElement.clientWidth > 850 && -1 == window.location.href.indexOf("about") && (e > 100 ? t.classList.contains("hasBlur") || t.classList.add("hasBlur") : t.classList.contains("hasBlur") && t.classList.remove("hasBlur"))
                })), O(r, "click", (function() {
                    n.classList.add("dn")
                }))
            })),
            q = function(t, e) {
                return e = e || {}, new Promise((function(i, n) {
                    var r = new XMLHttpRequest,
                        o = [],
                        s = [],
                        a = {},
                        l = function() {
                            return {
                                ok: 2 == (r.status / 100 | 0),
                                statusText: r.statusText,
                                status: r.status,
                                url: r.responseURL,
                                text: function() {
                                    return Promise.resolve(r.responseText)
                                },
                                json: function() {
                                    return Promise.resolve(r.responseText).then(JSON.parse)
                                },
                                blob: function() {
                                    return Promise.resolve(new Blob([r.response]))
                                },
                                clone: l,
                                headers: {
                                    keys: function() {
                                        return o
                                    },
                                    entries: function() {
                                        return s
                                    },
                                    get: function(t) {
                                        return a[t.toLowerCase()]
                                    },
                                    has: function(t) {
                                        return t.toLowerCase() in a
                                    }
                                }
                            }
                        };
                    for (var c in r.open(e.method || "get", t, !0), r.onload = function() {
                            r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, (function(t, e, i) {
                                o.push(e = e.toLowerCase()), s.push([e, i]), a[e] = a[e] ? a[e] + "," + i : i
                            })), i(l())
                        }, r.onerror = n, r.withCredentials = "include" == e.credentials, e.headers) r.setRequestHeader(c, e.headers[c]);
                    r.send(e.body || null)
                }))
            };

        function z(t, e, i, pId=0, mainForm) {
            if (document.querySelector('body').classList.contains('custom-template-page')) {
                var v_id_pro = parseInt(document.querySelector('.variant_dropdown[name="id"]').value);
            }
            document.querySelector('body').classList.contains('custom-template-page') ? t = v_id_pro : t
            var n = "deny" === t.inventory_policy && "shopify" === t.inventory_management ? t.inventory_quantity : null;
            return F().then((function(r) {
                var o = ((r.items.filter((function(e) {
                    return e.id === t.id
                }))[0] || {}).quantity || 0) + e;
                if (null !== n && o > n) {
                    var s = "There are only ".concat(n, " of that product available, requested ").concat(o, ".");
                    throw na.emit("error", s), new Error(s)
                }
                return function(t, e, i) {
                    if (document.querySelector('body').classList.contains('custom-template-page')) {
                        var v_id = parseInt(document.querySelector('.variant_dropdown[name="id"]').value);
                    }

                  document.querySelector('body').classList.contains('custom-template-page') ? t = v_id : t
                  var selling_plan_default;
                  

                  function mapSellingPlan(t) {
                    var lsp;
                    if (t == '43144032026880' || t == 43144032026880) {
                      // sparkling variety pack - 24 cans
                      lsp = '3350921472'
                    }else if (t == '42264375984384' || t == 42264375984384) {
                      // lychee mint
                      lsp = '3457351936'
                    } else if (t == '42770230673664' || t == 42770230673664) {
                      // mixed variety pack - 18 cans
                      lsp = '3355279616'
                    } else if (t == '42783862554880' || t == 42783862554880) {
                      // mixed variety pack - 24 cans
                      lsp = '3350921472'
                    }else if (t == '43877508710656' || t == 43877508710656) {
                      // reishi orange (24 pack)
                      lsp = '3346268416'
                    }else if (window.location.pathname.indexOf('/collections/')!==-1) {
                      if (t == '40919358668961' || t == 40919358668961) {
                        // still variety pack - 24 cans
                        lsp = '3350921472'
                      }  else if (t == '43547386249472' || t == 43547386249472) {
                        // cacao adaptogen blend
                        lsp = '3464986880'
                      } else if (t == '43616405815552' || t == 43616405815552){
                        lsp = '3464986880'
                      } else {
                        // other flavours
                        lsp = '3346268416'
                      }
                      
                    }else{
                        console.log('in the else')
                      if($('main div:first').attr('data-template') == 'subscription' && $('#rc_autodeliver_options').length){
                        lsp = $('#rc_autodeliver_options').find('.js-sellingPlan').val();
                          console.log('SP', lsp, $('#rc_autodeliver_options').find('.js-sellingPlan'))
                      }
                    } 
                    return lsp;
                  }
                  
                  // manually set the selling plan for collection page - Unneccesary
                  /*
                    if ( document.querySelector('form[action^="/cart/add"]').querySelector('input[name="selling_plan"]')) {
                      selling_plan_default = document.querySelector('form[action^="/cart/add"]').querySelector('input[name="selling_plan"]').value;                       
                    } else {
                      // var product = document.querySelector(`form[data-productid='${t}']`);
                      console.log('product id:', t)
                      var product = document.querySelector(`option[value='${t}']`)
                      if (product) {
                        var dataType = product.parentElement.getAttribute('data-type')
                        console.log('looking for link: ', product)
                        if (product && dataType != 'onetime') {
                            // verify that there's at least a subscription option, data type can != one time but still be a 1 time product
                            if (product.parentElement && product.parentElement.parentElement && product.parentElement.parentElement.querySelector(`#rc_purchase_type_autodeliver`)){
                              console.log('product type: ', dataType)
                              selling_plan_default = mapSellingPlan(t)
                            }
                        }
                      } else {                           
                          var options = document.querySelector('select[name="id"]')
                          if (options) {
                            if (options.value == 'recharge') {
                               selling_plan_default = mapSellingPlan(t)
                               console.log('mapping custom page plan: ', selling_plan_default)
                            }
                          }
                        }  
                    } 
                   */
                let spInput =mainForm ? mainForm.querySelector('input[name="selling_plan"]') : document.querySelector('input[name="selling_plan"]');
                selling_plan_default = spInput ? spInput.value : '';

                if (pId) { 
                  // Using product ID to get the unique selling plan ID
                  const sellingPlanParent = document.querySelector(`.for_selling_plan_${pId}`)?.closest("form");
                
                  if (sellingPlanParent) {
                    const selectBox = sellingPlanParent.querySelector('select[name="rtx_selling_plan"]');
                    const purchaseLabel = sellingPlanParent.querySelector(".rtx-purchase-label.sub");
                
                    if (selectBox && purchaseLabel) {
                      const firstOptionValue = selectBox.options[0]?.value || null; // get to the first option
                      const planSelectedStatus = purchaseLabel.classList.contains("is-selected");
                
                      // Assign selling plan if conditions are met
                      if (firstOptionValue && planSelectedStatus) {
                        selling_plan_default = firstOptionValue;
                      }
                    }
                  }
                }  

                  
                //Update to read the SP ID for LPs -- excluding product pages
                if(document.querySelector(`.js-freqToggleText`)?.innerText.includes('Subscribe') || document.querySelector(`div.active_button.double_subscription`)){
                  if(window.location.href.indexOf('/pages/fermat') === -1){ // exclude fermant LP because is using the Stay Ai snippet  
                    if(window.location.href.includes('better-than-booze') || (window.location.href.includes('pages') && !window.location.href.includes('products'))) {
                        let isSubscription = document.querySelector(`.js-freqToggleText`)?.innerText.includes('Subscribe') || document.querySelector(`div.active_button.double_subscription`) ? true : false;
                        selling_plan_default = isSubscription ? document.querySelector('input[name="selling_plan"]')?.value : '';
                      
                    }
                  }
                }

                // Prepare the properties object for the cart item
                  let gift_card_active = 'false'; 
                  if (document.querySelector('input[name="properties[__shopify_send_gift_card_to_recipient]"]:checked')) {
                        gift_card_active = 'true'; 
                  }
                  function isValidEmail(email) {
                      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                      return regex.test(email);
                  }
                  function isValidSendOnDate(date) {
                      // If the date is blank, return true (allow blank date)
                      if (!date) return true;
                      
                      const currentDate = new Date();
                      const selectedDate = new Date(date);
                      const maxDate = new Date();
                      maxDate.setDate(currentDate.getDate() + 90);  // 90 days from today
                      // Ensure the selected date is within the valid range
                      return selectedDate.toLocaleDateString() >= currentDate.toLocaleDateString() && selectedDate <= maxDate;
                  }

                  function giftScrollTo(element, offset=0){
										if (element){
												var scrollDiv = 0;
												if(window.screen.width > 768){
													scrollDiv = element.offsetTop + offset;
												}else{
													scrollDiv = element.offsetTop;
												}
												window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
										}
                  }
                  
                  const properties = {};
                  if(gift_card_active == 'true' ){
                      const recipientEmail = document.querySelector('input[name="properties[Recipient email]"]')?.value;
                      const recipientName = document.querySelector('input[name="properties[Recipient name]"]')?.value;
                      const recipientMessage = document.querySelector('textarea[name="properties[Message]"]')?.value;
                      const recipientSendOn = document.querySelector('input[name="properties[Send on]"]')?.value;
											const recipientEmailInput = document.querySelector('input[name="properties[Recipient email]"]');
											const gift_form = recipientEmailInput?.closest('form');
                      let errorMessage = "";
                      let date="";
                      const errorContainer = document.getElementById("RecipientForm-email-error");
                      var offset_attribute  = new Date()
                        .getTimezoneOffset()
                        .toString();
                      
                      if (recipientEmail.trim() === "") {
                          errorMessage = "Email cannot be blank.";
													giftScrollTo(gift_form);
												} else {
													if (!isValidEmail(recipientEmail)) {
														errorMessage = "Invalid email format.";
														giftScrollTo(gift_form);
                          }
                      }
                        
                      if (errorMessage !== "") {
                        document.getElementById("error-message").innerText = errorMessage; 
												document.querySelector('.gift-email-error').classList.remove('hidden');
                        setTimeout(function() {
                            document.getElementById("error-message").innerText = "";
														document.querySelector('.gift-email-error').classList.add('hidden');
                        }, 5000);
                        return false;
                      }
                      
                      if (!isValidSendOnDate(recipientSendOn)) {
                          if (recipientSendOn.trim() === "") {
                              // If the date is blank, don't show any error
                              return true;
                          }
                          // Show error message for invalid date
                          date = "Send on must be within 90 days from today.";
                          document.getElementById("error-message-date").innerText = date; 
													document.querySelector('.gift-sendon-error').classList.remove('hidden');
													giftScrollTo(gift_form, 300);
                          setTimeout(function() {
														document.getElementById("error-message-date").innerText = "";
														document.querySelector('.gift-sendon-error').classList.add('hidden');
                          }, 5000);
                          return false;
                      }
                        
                      properties["Recipient email"] = recipientEmail || "";
                      properties["Recipient name"] = recipientName || "";
                      properties["Message"] = recipientMessage || "";
                      properties["Send on"] = recipientSendOn || "";
                      properties["__shopify_offset"] = offset_attribute;
                      properties["__shopify_send_gift_card_to_recipient"]= "on";
                  }

                  // Construct the request body
                  const requestBody = {
                      id: t,
                      quantity: e,
                      selling_plan: selling_plan_default,
                  };

                  if (gift_card_active == 'true' ) {
                      requestBody.properties = properties;
                  }

                  
                  console.log('index.js -> adding to cart...')
                    
                    return na.emit("cart:updating"), q("/cart/add.js", {
                        method: "POST",
                        credentials: "include",
                        headers: {
                            "Content-Type": "application/json"
                        },
                        body: JSON.stringify(requestBody)
                    }).then((function(t) {
                        return t.json()
                    })).then((function(t) {
                        return F().then((function(e) {
                            return na.hydrate({
                                cart: e
                            }), na.emit("cart:updated"), console.log(t, 'success'), na.emit("cart:toggle", (function(t) {
                                const recipientForm = document.querySelector('recipient-form');
                                if(recipientForm){
                                    const inputs = recipientForm.querySelectorAll('input, textarea');
                                    inputs.forEach(input => {
                                        if (input.type !== 'checkbox') {
                                            input.value = '';  
                                        }
                                    });
                                }
                                return {
                                    cartOpen: !t.cartOpen
                                }
                            })), {
                                item: t,
                                cart: e
                            }
                        }))
                    }))
                }(t.id, e, i)
            }))
        }

        function I(t, e, i) {
            return F().then((function(n) {
                for (var r = n.items, o = 0; o < r.length; o++)
                    if (null != e) {
                        if (r[o].selling_plan_allocation && r[o].variant_id === parseInt(t) && r[o].selling_plan_allocation.selling_plan.id === parseInt(e)) return B(o + 1, i)
                    } else if (r[o].variant_id === parseInt(t)) return B(o + 1, i)
            }))
        }

        function B(t, e) {
            return na.emit("cart:updating"), q("/cart/change.js", {
                method: "POST",
                credentials: "include",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    line: t,
                    quantity: e
                })
            }).then((function(t) {
                return t.json()
            })).then((function(t) {
                return na.hydrate({
                    cart: t
                }), na.emit("cart:updated", {
                    cart: t
                }), t
            }))
        }

        function F() {
            return q("/cart.js", {
                method: "GET",
                credentials: "include"
            }).then((function(t) {
                return t.json()
            }))
        }

        function j(t, e) {
            var i = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
            if (!i) {
                if (Array.isArray(t) || (i = function(t, e) {
                        if (!t) return;
                        if ("string" == typeof t) return N(t, e);
                        var i = Object.prototype.toString.call(t).slice(8, -1);
                        "Object" === i && t.constructor && (i = t.constructor.name);
                        if ("Map" === i || "Set" === i) return Array.from(t);
                        if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return N(t, e)
                    }(t)) || e && t && "number" == typeof t.length) {
                    i && (t = i);
                    var n = 0,
                        r = function() {};
                    return {
                        s: r,
                        n: function() {
                            return n >= t.length ? {
                                done: !0
                            } : {
                                done: !1,
                                value: t[n++]
                            }
                        },
                        e: function(t) {
                            throw t
                        },
                        f: r
                    }
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
            }
            var o, s = !0,
                a = !1;
            return {
                s: function() {
                    i = i.call(t)
                },
                n: function() {
                    var t = i.next();
                    return s = t.done, t
                },
                e: function(t) {
                    a = !0, o = t
                },
                f: function() {
                    try {
                        s || null == i.return || i.return()
                    } finally {
                        if (a) throw o
                    }
                }
            }
        }

        function N(t, e) {
            (null == e || e > t.length) && (e = t.length);
            for (var i = 0, n = new Array(e); i < e; i++) n[i] = t[i];
            return n
        }
        var H = {};

        function W() {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.pathname.split("/").reverse()[0],
                e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return H[t] && !e.refetch ? Promise.resolve(H[t]) : fetch(window.location.origin + "/products/" + t + ".json").then((function(t) {
                return t.json()
            })).then((function(e) {
                var i = e.product;
                return H[t] = i, i
            }))
        }
        var U = C((function(t) {
                t.node;
                var e = function(t, e) {
                    e = Object.assign({
                        select: "[data-option-select]",
                        radio: "[data-option-radio]",
                        main: "[data-option-main]"
                    }, e);
                    var i = [],
                        n = {
                            id: null,
                            options: []
                        },
                        r = slater.qsa(e.select),
                        o = slater.qsa(e.radio),
                        s = slater.qs(e.main);
                    if (!s || !s.length) throw "data-option-main is missing";
                    if (o.length > 3) throw "you have more than three radio groups";
                    if (r.length > 3) throw "you have more than three select inputs";
                    var a = [].slice.call(s.children).reduce((function(t, e) {
                        return t[e.innerHTML] = e.value, t
                    }), {});

                    function l() {
                        n.id = a[n.options.join(" / ")], s.value = n.id;
                        var t, e = j(i);
                        try {
                            for (e.s(); !(t = e.n()).done;) {
                                (0, t.value)(n)
                            }
                        } catch (t) {
                            e.e(t)
                        } finally {
                            e.f()
                        }
                    }
                    return r.forEach((function(t) {
                        if ("SELECT" !== t.nodeName) throw "data-option-select should be defined on the individual option selectors";
                        var e = parseInt(t.getAttribute("data-index"));
                        n.options[e] = t.value, t.addEventListener("change", (function(t) {
                            n.options[e] = t.target.value, l()
                        }))
                    })), o.forEach((function(t) {
                        if ("INPUT" === t.nodeName) throw "data-option-radio should be defined on a parent of the radio group, not the inputs themselves";
                        var e = parseInt(t.getAttribute("data-index")),
                            i = [].slice.call(t.getElementsByTagName("input"));
                        i.forEach((function(t) {
                                t.checked && (n.options[e] = t.value)
                            })),
                            function(t, e) {
                                t.map((function(t) {
                                    return t.onclick = function(t) {
                                        return e(t.target.value)
                                    }
                                }))
                            }(i, (function(t) {
                                n.options[e] = t, l()
                            }))
                    })), l(), {
                        get state() {
                            return n
                        },
                        onUpdate: function(t) {
                            return i.indexOf(t) < 0 && i.push(t),
                                function() {
                                    return i.splice(i.indexOf(t), 1)
                                }
                        }
                    }
                }();
                W(), e.onUpdate((function(t) {
                    W().then((function(e) {
                        e.variants.filter((function(e) {
                            return e.id == t.id
                        }))[0]
                    }))
                }))
            })),
            X = i(8),
            Y = i.n(X);

        function V(t, e) {
            if (null === e) return t;
            if ("master" === e) return G(t);
            var i = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
            if (i) {
                var n = t.split(i[0]),
                    r = i[0];
                return G(n[0] + "_" + e + r)
            }
            return null
        }

        function G(t) {
            return t.replace(/http(s)?:/, "")
        }

        function Q(t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "${{amount}}";
            "string" == typeof t && (t = t.replace(".", ""));
            var i = "",
                n = /\{\{\s*(\w+)\s*\}\}/;

            function r(t, e, i, n) {
                if (e = e || 2, i = i || ",", n = n || ".", isNaN(t) || null == t) return 0;
                var r = (t = (t / 100).toFixed(e)).split(".");
                return r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (r[1] ? n + r[1] : "")
            }
            switch (e.match(n)[1]) {
                case "amount":
                    i = r(t, 2);
                    break;
                case "amount_no_decimals":
                    i = r(t, 0);
                    break;
                case "amount_with_space_separator":
                    i = r(t, 2, " ", ".");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    i = r(t, 0, ",", ".");
                    break;
                case "amount_no_decimals_with_space_separator":
                    i = r(t, 0, " ")
            }
            return e.replace(n, i)
        }
        var K = ["variant_id", "product_title", "line_price", "variant_title", "image", "url", "quantity", "properties"];

        function J(t) {
            return t.length > 0 ? t.reduce((function(t, e) {
                return t += function(t) {
                    var e = t.variant_id,
                        i = t.product_title,
                        n = t.line_price,
                        r = (t.variant_title, t.image),
                        o = t.url,
                        s = t.quantity,
                        a = (t.properties, Y()(t, K)),
                        l = r ? V(r.replace("." + function(t) {
                            var e = t.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
                            return e ? e[1] : null
                        }(r), ""), "200x") : "https://source.unsplash.com/R9OS29xJb-8/2000x1333";
                    return "\n<div class='cart-drawer__item mb30' data-component='cartDrawerItem' data-id=".concat(e, " ").concat(a.selling_plan_allocation ? "data-planid='".concat(a.selling_plan_allocation.selling_plan.id, "'") : "", ">\n  <div class='df aic cart-item x'>\n    <a class=\"cart-itemImg\" href='").concat(o, "'>\n      <img src='").concat(l, '\' alt="moment drink functional beverage"/>\n    </a>\n    <div class=\'__content c-black x\'>\n      <div class="x">\n        <div class="df x jcb">\n          <a href=\'').concat(o, "' class='serif f22 x'>").concat(i, '</a>\n          <button aria-label="close" type="button" class=\'button--reset js-remove-item df\'>').concat('<svg viewBox="0 0 40.867 40.867">\n  <g data-name="Group 327" fill="none" stroke="#000" stroke-linecap="round" stroke-width="3">\n    <path data-name="Path 118" d="M1.061 1.061l38.745 38.745"/>\n    <path data-name="Path 119" d="M39.806 1.061L1.061 39.806"/>\n  </g>\n</svg>', '</button>\n        </div>\n        <div class="mt10 f16">').concat(a.selling_plan_allocation ? a.selling_plan_allocation.selling_plan.name : "onetime", "</div>\n        <div class=\"df jcb x mt10\">\n          <div class='df aic f16'>\n            <div class=\"mr15\">QTY</div>\n            <div class='cart-quantity js-remove-single mr10 point'>–</div>\n            <div class='js-single-quantity'>").concat(s, "</div>\n            <div class='cart-quantity js-add-single ml10 point'>+</div>\n          </div>\n          <div class='f16 sansm'>").concat(Q(n), "</div>\n        </div>\n      </div>\n\n      \n    </div>\n  </div>\n</div>\n")
                }(e)
            }), "") : "<div class='pv1'><p class='i'>Your cart is empty</p></div>"
        }
        var Z = C((function(t, e) {
                var i = t.querySelector(".js-overlay"),
                    n = t.querySelector(".js-close"),
                    r = t.querySelector(".js-subtotal"),
                    o = t.querySelector(".js-items"),
                    s = o.innerHTML,
                    a = function(t) {
                        o.innerHTML = J(t.items), r.innerHTML = Q(t.total_price)
                    },
                    l = function() {
                        t.classList.remove("is-visible"), setTimeout((function() {
                            t.classList.remove("is-active"), na.hydrate({
                                cartOpen: !1
                            })
                        }), 400), i.classList.add("pen")
                    };
                a(e.getState().cart), i.addEventListener("click", l), n.addEventListener("click", l), e.on("cart:toggle", (function(e) {
                    var n = e.cart;
                    e.cartOpen && function(e) {
                        t.classList.add("is-active"), o.innerHTML = s, setTimeout((function() {
                            t.classList.add("is-visible"), setTimeout(a(e), 10), na.mount()
                        }), 50), i.classList.remove("pen")
                    }(n)
                })), e.on("cart:updated", (function() {
                    a(e.getState().cart), na.mount()
                }))
            })),
            tt = C((function(t, e) {
                var i = t.querySelector(".js-remove-item"),
                    n = t.querySelector(".js-remove-single"),
                    r = t.querySelector(".js-add-single"),
                    o = t.querySelector(".js-single-quantity").innerHTML,
                    s = t.getAttribute("data-id"),
                    a = t.getAttribute("data-planid");
                i.addEventListener("click", (function(t) {
                    t.preventDefault(),
                        function(t, e) {
                            I(t, e, 0)
                        }(s, a)
                })), n.addEventListener("click", (function(t) {
                    t.preventDefault(), I(s, a, parseInt(o) - 1)
                })), r.addEventListener("click", (function(t) {
                    t.preventDefault(), I(s, a, parseInt(o) + 1)
                }))
            })),
            et = C((function(t, e) {
                var i = t.querySelector(".js-login-dialog"),
                    n = t.querySelector(".js-recover-dialog"),
                    r = t.querySelector(".js-recover-trigger"),
                    o = t.querySelector(".js-recover-cancel"),
                    s = !!window.location.hash.match(/\#recover/),
                    a = null !== t.querySelector(".js-recover-success");
                s || a ? (i.style.display = "none", n.style.display = "block") : i.style.display = "block", r.addEventListener("click", (function(t) {
                    t.preventDefault(), i.style.display = "none", n.style.display = "block"
                })), o.addEventListener("click", (function(t) {
                    t.preventDefault(), n.style.display = "none", i.style.display = "block"
                }))
            })),
            it = C((function(t, e) {
                var i, n = JSON.parse(t.querySelector(".js-product-json").innerHTML),
                    r = t.querySelector("form"),
                    o = n.selectedOrFirstAvailableVariant,
                    s = n.product;
                s.variants.filter((function(t) {
                    return t.id === o
                }))[0];
                r.addEventListener("submit", (function(e) { 
                  let pID = e.target.dataset.productid;
                    e.preventDefault(), i = "recharge" == r.elements.id.dataset.type && t.querySelector(".js-sellingPlan") ? parseInt(t.querySelector(".js-sellingPlan").value) : null;                  
                    var n = r.elements.quantity ? r.elements.quantity.value : 1;
                    z(s.variants.filter((function(t) {

                        return t.id === parseInt(r.elements.id.value)
                    }))[0], n, i, pID, r)
                }))
            })),
            nt = C((function(t, e) {
                var i, n = JSON.parse(document.querySelector(".js-product-json").innerHTML),
                    r = t.querySelector("form"),
                    o = n.selectedOrFirstAvailableVariant,
                    s = n.product.variants.filter((function(t) {
                        return t.id === o
                    }))[0];
                r.addEventListener("submit", (function(e) {                 
                 
                  var n = r.elements.quantity ? r.elements.quantity.value : 1;
                  
                   //Update for Stay AI Subscriptions
                    e.preventDefault();
                    i = r.querySelector('input[name="selling_plan"]') ? r.querySelector('input[name="selling_plan"]').value : '';                    
                    z(s, n, i);
                }))
            })),
            rt = C((function(t, e) {
                var i = JSON.parse(t.querySelector(".js-product-json").innerHTML),
                    n = i.selectedOrFirstAvailableVariant,
                    r = i.product.variants.filter((function(t) {
                        return t.id === n
                    }))[0];
                t.addEventListener("click", (function() {
                    form.reset();
                    if ("recharge" == form.elements.id.dataset.type) {
                        var t = document.querySelector("#rc_shipping_interval_frequency").value;
                        z(r, form.elements.quantity.value, t)
                    } else z(r, form.elements.quantity.value)
                }))
            })),
            ot = C((function(t, e) {
                var i = t.querySelector(".js-counter-remove"),
                    n = t.querySelector(".js-counter-add"),
                    r = t.querySelector(".js-counter-quantity"),
                    o = parseInt(r.attributes.min.value),
                    s = parseInt(r.attributes.max.value),
                    a = parseInt(r.value),
                    l = function(t) {
                        a = Math.max(o, Math.min(t, s || 1e4)), r.value = a
                    };
                i.addEventListener("click", (function(t) {
                    t.preventDefault(), l(--a)
                })), n.addEventListener("click", (function(t) {
                    t.preventDefault(), l(++a)
                }))
            }));

        function st(t) {
            if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return t
        }

        function at(t, e) {
            t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e
        }
        /*!
         * GSAP 3.6.0
         * https://greensock.com
         *
         * @license Copyright 2008-2021, GreenSock. All rights reserved.
         * Subject to the terms at https://greensock.com/standard-license or for
         * Club GreenSock members, the agreement issued with that membership.
         * @author: Jack Doyle, jack@greensock.com
         */
        var lt, ct, ut, ht, dt, ft, pt, gt, vt, mt, yt, _t, bt, xt = {
                autoSleep: 120,
                force3D: "auto",
                nullTargetWarn: 1,
                units: {
                    lineHeight: ""
                }
            },
            wt = {
                duration: .5,
                overwrite: !1,
                delay: 0
            },
            Tt = 1e8,
            St = 2 * Math.PI,
            At = St / 4,
            Ct = 0,
            kt = Math.sqrt,
            Lt = Math.cos,
            Et = Math.sin,
            Ot = function(t) {
                return "string" == typeof t
            },
            Pt = function(t) {
                return "function" == typeof t
            },
            Mt = function(t) {
                return "number" == typeof t
            },
            Dt = function(t) {
                return void 0 === t
            },
            Rt = function(t) {
                return "object" == typeof t
            },
            qt = function(t) {
                return !1 !== t
            },
            zt = function() {
                return "undefined" != typeof window
            },
            It = function(t) {
                return Pt(t) || Ot(t)
            },
            Bt = "function" == typeof ArrayBuffer && ArrayBuffer.isView || function() {},
            Ft = Array.isArray,
            jt = /(?:-?\.?\d|\.)+/gi,
            Nt = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
            Ht = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
            Wt = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
            Ut = /[+-]=-?[.\d]+/,
            Xt = /[#\-+.]*\b[a-z\d-=+%.]+/gi,
            Yt = /[\d.+\-=]+(?:e[-+]\d*)*/i,
            Vt = {},
            Gt = {},
            $t = function(t) {
                return (Gt = xe(t, Vt)) && rn
            },
            Qt = function(t, e) {
                return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()")
            },
            Kt = function(t, e) {
                return !e && console.warn(t)
            },
            Jt = function(t, e) {
                return t && (Vt[t] = e) && Gt && (Gt[t] = e) || Vt
            },
            Zt = function() {
                return 0
            },
            te = {},
            ee = [],
            ie = {},
            ne = {},
            re = {},
            oe = 30,
            se = [],
            ae = "",
            le = function(t) {
                var e, i, n = t[0];
                if (Rt(n) || Pt(n) || (t = [t]), !(e = (n._gsap || {}).harness)) {
                    for (i = se.length; i-- && !se[i].targetTest(n););
                    e = se[i]
                }
                for (i = t.length; i--;) t[i] && (t[i]._gsap || (t[i]._gsap = new Li(t[i], e))) || t.splice(i, 1);
                return t
            },
            ce = function(t) {
                return t._gsap || le(Ge(t))[0]._gsap
            },
            ue = function(t, e, i) {
                return (i = t[e]) && Pt(i) ? t[e]() : Dt(i) && t.getAttribute && t.getAttribute(e) || i
            },
            he = function(t, e) {
                return (t = t.split(",")).forEach(e) || t
            },
            de = function(t) {
                return Math.round(1e5 * t) / 1e5 || 0
            },
            fe = function(t, e) {
                for (var i = e.length, n = 0; t.indexOf(e[n]) < 0 && ++n < i;);
                return n < i
            },
            pe = function(t, e, i) {
                var n, r = Mt(t[1]),
                    o = (r ? 2 : 1) + (e < 2 ? 0 : 1),
                    s = t[o];
                if (r && (s.duration = t[1]), s.parent = i, e) {
                    for (n = s; i && !("immediateRender" in n);) n = i.vars.defaults || {}, i = qt(i.vars.inherit) && i.parent;
                    s.immediateRender = qt(n.immediateRender), e < 2 ? s.runBackwards = 1 : s.startAt = t[o - 1]
                }
                return s
            },
            ge = function() {
                var t, e, i = ee.length,
                    n = ee.slice(0);
                for (ie = {}, ee.length = 0, t = 0; t < i; t++)(e = n[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0)
            },
            ve = function(t, e, i, n) {
                ee.length && ge(), t.render(e, i, n), ee.length && ge()
            },
            me = function(t) {
                var e = parseFloat(t);
                return (e || 0 === e) && (t + "").match(Xt).length < 2 ? e : Ot(t) ? t.trim() : t
            },
            ye = function(t) {
                return t
            },
            _e = function(t, e) {
                for (var i in e) i in t || (t[i] = e[i]);
                return t
            },
            be = function(t, e) {
                for (var i in e) i in t || "duration" === i || "ease" === i || (t[i] = e[i])
            },
            xe = function(t, e) {
                for (var i in e) t[i] = e[i];
                return t
            },
            we = function t(e, i) {
                for (var n in i) "__proto__" !== n && "constructor" !== n && "prototype" !== n && (e[n] = Rt(i[n]) ? t(e[n] || (e[n] = {}), i[n]) : i[n]);
                return e
            },
            Te = function(t, e) {
                var i, n = {};
                for (i in t) i in e || (n[i] = t[i]);
                return n
            },
            Se = function(t) {
                var e = t.parent || ct,
                    i = t.keyframes ? be : _e;
                if (qt(t.inherit))
                    for (; e;) i(t, e.vars.defaults), e = e.parent || e._dp;
                return t
            },
            Ae = function(t, e, i, n) {
                void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
                var r = e._prev,
                    o = e._next;
                r ? r._next = o : t[i] === e && (t[i] = o), o ? o._prev = r : t[n] === e && (t[n] = r), e._next = e._prev = e.parent = null
            },
            Ce = function(t, e) {
                t.parent && (!e || t.parent.autoRemoveChildren) && t.parent.remove(t), t._act = 0
            },
            ke = function(t, e) {
                if (t && (!e || e._end > t._dur || e._start < 0))
                    for (var i = t; i;) i._dirty = 1, i = i.parent;
                return t
            },
            Le = function(t) {
                for (var e = t.parent; e && e.parent;) e._dirty = 1, e.totalDuration(), e = e.parent;
                return t
            },
            Ee = function(t) {
                return t._repeat ? Oe(t._tTime, t = t.duration() + t._rDelay) * t : 0
            },
            Oe = function(t, e) {
                var i = Math.floor(t /= e);
                return t && i === t ? i - 1 : i
            },
            Pe = function(t, e) {
                return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur)
            },
            Me = function(t) {
                return t._end = de(t._start + (t._tDur / Math.abs(t._ts || t._rts || 1e-8) || 0))
            },
            De = function(t, e) {
                var i = t._dp;
                return i && i.smoothChildTiming && t._ts && (t._start = de(i._time - (t._ts > 0 ? e / t._ts : ((t._dirty ? t.totalDuration() : t._tDur) - e) / -t._ts)), Me(t), i._dirty || ke(i, t)), t
            },
            Re = function(t, e) {
                var i;
                if ((e._time || e._initted && !e._dur) && (i = Pe(t.rawTime(), e), (!e._dur || We(0, e.totalDuration(), i) - e._tTime > 1e-8) && e.render(i, !0)), ke(t, e)._dp && t._initted && t._time >= t._dur && t._ts) {
                    if (t._dur < t.duration())
                        for (i = t; i._dp;) i.rawTime() >= 0 && i.totalTime(i._tTime), i = i._dp;
                    t._zTime = -1e-8
                }
            },
            qe = function(t, e, i, n) {
                return e.parent && Ce(e), e._start = de(i + e._delay), e._end = de(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)),
                    function(t, e, i, n, r) {
                        void 0 === i && (i = "_first"), void 0 === n && (n = "_last");
                        var o, s = t[n];
                        if (r)
                            for (o = e[r]; s && s[r] > o;) s = s._prev;
                        s ? (e._next = s._next, s._next = e) : (e._next = t[i], t[i] = e), e._next ? e._next._prev = e : t[n] = e, e._prev = s, e.parent = e._dp = t
                    }(t, e, "_first", "_last", t._sort ? "_start" : 0), t._recent = e, n || Re(t, e), t
            },
            ze = function(t, e) {
                return (Vt.ScrollTrigger || Qt("scrollTrigger", e)) && Vt.ScrollTrigger.create(e, t)
            },
            Ie = function(t, e, i, n) {
                return qi(t, e), t._initted ? !i && t._pt && (t._dur && !1 !== t.vars.lazy || !t._dur && t.vars.lazy) && pt !== gi.frame ? (ee.push(t), t._lazy = [e, n], 1) : void 0 : 1
            },
            Be = function(t, e, i, n) {
                var r = t._repeat,
                    o = de(e) || 0,
                    s = t._tTime / t._tDur;
                return s && !n && (t._time *= o / t._dur), t._dur = o, t._tDur = r ? r < 0 ? 1e10 : de(o * (r + 1) + t._rDelay * r) : o, s && !n ? De(t, t._tTime = t._tDur * s) : t.parent && Me(t), i || ke(t.parent, t), t
            },
            Fe = function(t) {
                return t instanceof Oi ? ke(t) : Be(t, t._dur)
            },
            je = {
                _start: 0,
                endTime: Zt
            },
            Ne = function t(e, i) {
                var n, r, o = e.labels,
                    s = e._recent || je,
                    a = e.duration() >= Tt ? s.endTime(!1) : e._dur;
                return Ot(i) && (isNaN(i) || i in o) ? "<" === (n = i.charAt(0)) || ">" === n ? ("<" === n ? s._start : s.endTime(s._repeat >= 0)) + (parseFloat(i.substr(1)) || 0) : (n = i.indexOf("=")) < 0 ? (i in o || (o[i] = a), o[i]) : (r = +(i.charAt(n - 1) + i.substr(n + 1)), n > 1 ? t(e, i.substr(0, n - 1)) + r : a + r) : null == i ? a : +i
            },
            He = function(t, e) {
                return t || 0 === t ? e(t) : e
            },
            We = function(t, e, i) {
                return i < t ? t : i > e ? e : i
            },
            Ue = function(t) {
                if ("string" != typeof t) return "";
                var e = Yt.exec(t);
                return e ? t.substr(e.index + e[0].length) : ""
            },
            Xe = [].slice,
            Ye = function(t, e) {
                return t && Rt(t) && "length" in t && (!e && !t.length || t.length - 1 in t && Rt(t[0])) && !t.nodeType && t !== ut
            },
            Ve = function(t, e, i) {
                return void 0 === i && (i = []), t.forEach((function(t) {
                    var n;
                    return Ot(t) && !e || Ye(t, 1) ? (n = i).push.apply(n, Ge(t)) : i.push(t)
                })) || i
            },
            Ge = function(t, e) {
                return !Ot(t) || e || !ht && vi() ? Ft(t) ? Ve(t, e) : Ye(t) ? Xe.call(t, 0) : t ? [t] : [] : Xe.call(dt.querySelectorAll(t), 0)
            },
            $e = function(t) {
                return t.sort((function() {
                    return .5 - Math.random()
                }))
            },
            Qe = function(t) {
                if (Pt(t)) return t;
                var e = Rt(t) ? t : {
                        each: t
                    },
                    i = Ti(e.ease),
                    n = e.from || 0,
                    r = parseFloat(e.base) || 0,
                    o = {},
                    s = n > 0 && n < 1,
                    a = isNaN(n) || s,
                    l = e.axis,
                    c = n,
                    u = n;
                return Ot(n) ? c = u = {
                        center: .5,
                        edges: .5,
                        end: 1
                    }[n] || 0 : !s && a && (c = n[0], u = n[1]),
                    function(t, s, h) {
                        var d, f, p, g, v, m, y, _, b, x = (h || e).length,
                            w = o[x];
                        if (!w) {
                            if (!(b = "auto" === e.grid ? 0 : (e.grid || [1, Tt])[1])) {
                                for (y = -Tt; y < (y = h[b++].getBoundingClientRect().left) && b < x;);
                                b--
                            }
                            for (w = o[x] = [], d = a ? Math.min(b, x) * c - .5 : n % b, f = a ? x * u / b - .5 : n / b | 0, y = 0, _ = Tt, m = 0; m < x; m++) p = m % b - d, g = f - (m / b | 0), w[m] = v = l ? Math.abs("y" === l ? g : p) : kt(p * p + g * g), v > y && (y = v), v < _ && (_ = v);
                            "random" === n && $e(w), w.max = y - _, w.min = _, w.v = x = (parseFloat(e.amount) || parseFloat(e.each) * (b > x ? x - 1 : l ? "y" === l ? x / b : b : Math.max(b, x / b)) || 0) * ("edges" === n ? -1 : 1), w.b = x < 0 ? r - x : r, w.u = Ue(e.amount || e.each) || 0, i = i && x < 0 ? xi(i) : i
                        }
                        return x = (w[t] - w.min) / w.max || 0, de(w.b + (i ? i(x) : x) * w.v) + w.u
                    }
            },
            Ke = function(t) {
                var e = t < 1 ? Math.pow(10, (t + "").length - 2) : 1;
                return function(i) {
                    var n = Math.round(parseFloat(i) / t) * t * e;
                    return (n - n % 1) / e + (Mt(i) ? 0 : Ue(i))
                }
            },
            Je = function(t, e) {
                var i, n, r = Ft(t);
                return !r && Rt(t) && (i = r = t.radius || Tt, t.values ? (t = Ge(t.values), (n = !Mt(t[0])) && (i *= i)) : t = Ke(t.increment)), He(e, r ? Pt(t) ? function(e) {
                    return n = t(e), Math.abs(n - e) <= i ? n : e
                } : function(e) {
                    for (var r, o, s = parseFloat(n ? e.x : e), a = parseFloat(n ? e.y : 0), l = Tt, c = 0, u = t.length; u--;)(r = n ? (r = t[u].x - s) * r + (o = t[u].y - a) * o : Math.abs(t[u] - s)) < l && (l = r, c = u);
                    return c = !i || l <= i ? t[c] : e, n || c === e || Mt(e) ? c : c + Ue(e)
                } : Ke(t))
            },
            Ze = function(t, e, i, n) {
                return He(Ft(t) ? !e : !0 === i ? !!(i = 0) : !n, (function() {
                    return Ft(t) ? t[~~(Math.random() * t.length)] : (i = i || 1e-5) && (n = i < 1 ? Math.pow(10, (i + "").length - 2) : 1) && Math.floor(Math.round((t - i / 2 + Math.random() * (e - t + .99 * i)) / i) * i * n) / n
                }))
            },
            ti = function(t, e, i) {
                return He(i, (function(i) {
                    return t[~~e(i)]
                }))
            },
            ei = function(t) {
                for (var e, i, n, r, o = 0, s = ""; ~(e = t.indexOf("random(", o));) n = t.indexOf(")", e), r = "[" === t.charAt(e + 7), i = t.substr(e + 7, n - e - 7).match(r ? Xt : jt), s += t.substr(o, e - o) + Ze(r ? i : +i[0], r ? 0 : +i[1], +i[2] || 1e-5), o = n + 1;
                return s + t.substr(o, t.length - o)
            },
            ii = function(t, e, i, n, r) {
                var o = e - t,
                    s = n - i;
                return He(r, (function(e) {
                    return i + ((e - t) / o * s || 0)
                }))
            },
            ni = function(t, e, i) {
                var n, r, o, s = t.labels,
                    a = Tt;
                for (n in s)(r = s[n] - e) < 0 == !!i && r && a > (r = Math.abs(r)) && (o = n, a = r);
                return o
            },
            ri = function(t, e, i) {
                var n, r, o = t.vars,
                    s = o[e];
                if (s) return n = o[e + "Params"], r = o.callbackScope || t, i && ee.length && ge(), n ? s.apply(r, n) : s.call(r)
            },
            oi = function(t) {
                return Ce(t), t.progress() < 1 && ri(t, "onInterrupt"), t
            },
            si = function(t) {
                var e = (t = !t.name && t.default || t).name,
                    i = Pt(t),
                    n = e && !i && t.init ? function() {
                        this._props = []
                    } : t,
                    r = {
                        init: Zt,
                        render: Gi,
                        add: Di,
                        kill: Qi,
                        modifier: $i,
                        rawVars: 0
                    },
                    o = {
                        targetTest: 0,
                        get: 0,
                        getSetter: Ui,
                        aliases: {},
                        register: 0
                    };
                if (vi(), t !== n) {
                    if (ne[e]) return;
                    _e(n, _e(Te(t, r), o)), xe(n.prototype, xe(r, Te(t, o))), ne[n.prop = e] = n, t.targetTest && (se.push(n), te[e] = 1), e = ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin"
                }
                Jt(e, n), t.register && t.register(rn, n, Zi)
            },
            ai = {
                aqua: [0, 255, 255],
                lime: [0, 255, 0],
                silver: [192, 192, 192],
                black: [0, 0, 0],
                maroon: [128, 0, 0],
                teal: [0, 128, 128],
                blue: [0, 0, 255],
                navy: [0, 0, 128],
                white: [255, 255, 255],
                olive: [128, 128, 0],
                yellow: [255, 255, 0],
                orange: [255, 165, 0],
                gray: [128, 128, 128],
                purple: [128, 0, 128],
                green: [0, 128, 0],
                red: [255, 0, 0],
                pink: [255, 192, 203],
                cyan: [0, 255, 255],
                transparent: [255, 255, 255, 0]
            },
            li = function(t, e, i) {
                return 255 * (6 * (t = t < 0 ? t + 1 : t > 1 ? t - 1 : t) < 1 ? e + (i - e) * t * 6 : t < .5 ? i : 3 * t < 2 ? e + (i - e) * (2 / 3 - t) * 6 : e) + .5 | 0
            },
            ci = function(t, e, i) {
                var n, r, o, s, a, l, c, u, h, d, f = t ? Mt(t) ? [t >> 16, t >> 8 & 255, 255 & t] : 0 : ai.black;
                if (!f) {
                    if ("," === t.substr(-1) && (t = t.substr(0, t.length - 1)), ai[t]) f = ai[t];
                    else if ("#" === t.charAt(0)) {
                        if (t.length < 6 && (n = t.charAt(1), r = t.charAt(2), o = t.charAt(3), t = "#" + n + n + r + r + o + o + (5 === t.length ? t.charAt(4) + t.charAt(4) : "")), 9 === t.length) return [(f = parseInt(t.substr(1, 6), 16)) >> 16, f >> 8 & 255, 255 & f, parseInt(t.substr(7), 16) / 255];
                        f = [(t = parseInt(t.substr(1), 16)) >> 16, t >> 8 & 255, 255 & t]
                    } else if ("hsl" === t.substr(0, 3))
                        if (f = d = t.match(jt), e) {
                            if (~t.indexOf("=")) return f = t.match(Nt), i && f.length < 4 && (f[3] = 1), f
                        } else s = +f[0] % 360 / 360, a = +f[1] / 100, n = 2 * (l = +f[2] / 100) - (r = l <= .5 ? l * (a + 1) : l + a - l * a), f.length > 3 && (f[3] *= 1), f[0] = li(s + 1 / 3, n, r), f[1] = li(s, n, r), f[2] = li(s - 1 / 3, n, r);
                    else f = t.match(jt) || ai.transparent;
                    f = f.map(Number)
                }
                return e && !d && (n = f[0] / 255, r = f[1] / 255, o = f[2] / 255, l = ((c = Math.max(n, r, o)) + (u = Math.min(n, r, o))) / 2, c === u ? s = a = 0 : (h = c - u, a = l > .5 ? h / (2 - c - u) : h / (c + u), s = c === n ? (r - o) / h + (r < o ? 6 : 0) : c === r ? (o - n) / h + 2 : (n - r) / h + 4, s *= 60), f[0] = ~~(s + .5), f[1] = ~~(100 * a + .5), f[2] = ~~(100 * l + .5)), i && f.length < 4 && (f[3] = 1), f
            },
            ui = function(t) {
                var e = [],
                    i = [],
                    n = -1;
                return t.split(di).forEach((function(t) {
                    var r = t.match(Ht) || [];
                    e.push.apply(e, r), i.push(n += r.length + 1)
                })), e.c = i, e
            },
            hi = function(t, e, i) {
                var n, r, o, s, a = "",
                    l = (t + a).match(di),
                    c = e ? "hsla(" : "rgba(",
                    u = 0;
                if (!l) return t;
                if (l = l.map((function(t) {
                        return (t = ci(t, e, 1)) && c + (e ? t[0] + "," + t[1] + "%," + t[2] + "%," + t[3] : t.join(",")) + ")"
                    })), i && (o = ui(t), (n = i.c).join(a) !== o.c.join(a)))
                    for (s = (r = t.replace(di, "1").split(Ht)).length - 1; u < s; u++) a += r[u] + (~n.indexOf(u) ? l.shift() || c + "0,0,0,0)" : (o.length ? o : l.length ? l : i).shift());
                if (!r)
                    for (s = (r = t.split(di)).length - 1; u < s; u++) a += r[u] + l[u];
                return a + r[s]
            },
            di = function() {
                var t, e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b";
                for (t in ai) e += "|" + t + "\\b";
                return new RegExp(e + ")", "gi")
            }(),
            fi = /hsl[a]?\(/,
            pi = function(t) {
                var e, i = t.join(" ");
                if (di.lastIndex = 0, di.test(i)) return e = fi.test(i), t[1] = hi(t[1], e), t[0] = hi(t[0], e, ui(t[1])), !0
            },
            gi = function() {
                var t, e, i, n, r, o, s = Date.now,
                    a = 500,
                    l = 33,
                    c = s(),
                    u = c,
                    h = 1e3 / 240,
                    d = h,
                    f = [],
                    p = function i(p) {
                        var g, v, m, y, _ = s() - u,
                            b = !0 === p;
                        if (_ > a && (c += _ - l), ((g = (m = (u += _) - c) - d) > 0 || b) && (y = ++n.frame, r = m - 1e3 * n.time, n.time = m /= 1e3, d += g + (g >= h ? 4 : h - g), v = 1), b || (t = e(i)), v)
                            for (o = 0; o < f.length; o++) f[o](m, r, y, p)
                    };
                return n = {
                    time: 0,
                    frame: 0,
                    tick: function() {
                        p(!0)
                    },
                    deltaRatio: function(t) {
                        return r / (1e3 / (t || 60))
                    },
                    wake: function() {
                        ft && (!ht && zt() && (ut = ht = window, dt = ut.document || {}, Vt.gsap = rn, (ut.gsapVersions || (ut.gsapVersions = [])).push(rn.version), $t(Gt || ut.GreenSockGlobals || !ut.gsap && ut || {}), i = ut.requestAnimationFrame), t && n.sleep(), e = i || function(t) {
                            return setTimeout(t, d - 1e3 * n.time + 1 | 0)
                        }, vt = 1, p(2))
                    },
                    sleep: function() {
                        (i ? ut.cancelAnimationFrame : clearTimeout)(t), vt = 0, e = Zt
                    },
                    lagSmoothing: function(t, e) {
                        a = t || 1 / 1e-8, l = Math.min(e, a, 0)
                    },
                    fps: function(t) {
                        h = 1e3 / (t || 240), d = 1e3 * n.time + h
                    },
                    add: function(t) {
                        f.indexOf(t) < 0 && f.push(t), vi()
                    },
                    remove: function(t) {
                        var e;
                        ~(e = f.indexOf(t)) && f.splice(e, 1) && o >= e && o--
                    },
                    _listeners: f
                }
            }(),
            vi = function() {
                return !vt && gi.wake()
            },
            mi = {},
            yi = /^[\d.\-M][\d.\-,\s]/,
            _i = /["']/g,
            bi = function(t) {
                for (var e, i, n, r = {}, o = t.substr(1, t.length - 3).split(":"), s = o[0], a = 1, l = o.length; a < l; a++) i = o[a], e = a !== l - 1 ? i.lastIndexOf(",") : i.length, n = i.substr(0, e), r[s] = isNaN(n) ? n.replace(_i, "").trim() : +n, s = i.substr(e + 1).trim();
                return r
            },
            xi = function(t) {
                return function(e) {
                    return 1 - t(1 - e)
                }
            },
            wi = function t(e, i) {
                for (var n, r = e._first; r;) r instanceof Oi ? t(r, i) : !r.vars.yoyoEase || r._yoyo && r._repeat || r._yoyo === i || (r.timeline ? t(r.timeline, i) : (n = r._ease, r._ease = r._yEase, r._yEase = n, r._yoyo = i)), r = r._next
            },
            Ti = function(t, e) {
                return t && (Pt(t) ? t : mi[t] || function(t) {
                    var e, i, n, r, o = (t + "").split("("),
                        s = mi[o[0]];
                    return s && o.length > 1 && s.config ? s.config.apply(null, ~t.indexOf("{") ? [bi(o[1])] : (e = t, i = e.indexOf("(") + 1, n = e.indexOf(")"), r = e.indexOf("(", i), e.substring(i, ~r && r < n ? e.indexOf(")", n + 1) : n)).split(",").map(me)) : mi._CE && yi.test(t) ? mi._CE("", t) : s
                }(t)) || e
            },
            Si = function(t, e, i, n) {
                void 0 === i && (i = function(t) {
                    return 1 - e(1 - t)
                }), void 0 === n && (n = function(t) {
                    return t < .5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2
                });
                var r, o = {
                    easeIn: e,
                    easeOut: i,
                    easeInOut: n
                };
                return he(t, (function(t) {
                    for (var e in mi[t] = Vt[t] = o, mi[r = t.toLowerCase()] = i, o) mi[r + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = mi[t + "." + e] = o[e]
                })), o
            },
            Ai = function(t) {
                return function(e) {
                    return e < .5 ? (1 - t(1 - 2 * e)) / 2 : .5 + t(2 * (e - .5)) / 2
                }
            },
            Ci = function t(e, i, n) {
                var r = i >= 1 ? i : 1,
                    o = (n || (e ? .3 : .45)) / (i < 1 ? i : 1),
                    s = o / St * (Math.asin(1 / r) || 0),
                    a = function(t) {
                        return 1 === t ? 1 : r * Math.pow(2, -10 * t) * Et((t - s) * o) + 1
                    },
                    l = "out" === e ? a : "in" === e ? function(t) {
                        return 1 - a(1 - t)
                    } : Ai(a);
                return o = St / o, l.config = function(i, n) {
                    return t(e, i, n)
                }, l
            },
            ki = function t(e, i) {
                void 0 === i && (i = 1.70158);
                var n = function(t) {
                        return t ? --t * t * ((i + 1) * t + i) + 1 : 0
                    },
                    r = "out" === e ? n : "in" === e ? function(t) {
                        return 1 - n(1 - t)
                    } : Ai(n);
                return r.config = function(i) {
                    return t(e, i)
                }, r
            };
        he("Linear,Quad,Cubic,Quart,Quint,Strong", (function(t, e) {
            var i = e < 5 ? e + 1 : e;
            Si(t + ",Power" + (i - 1), e ? function(t) {
                return Math.pow(t, i)
            } : function(t) {
                return t
            }, (function(t) {
                return 1 - Math.pow(1 - t, i)
            }), (function(t) {
                return t < .5 ? Math.pow(2 * t, i) / 2 : 1 - Math.pow(2 * (1 - t), i) / 2
            }))
        })), mi.Linear.easeNone = mi.none = mi.Linear.easeIn, Si("Elastic", Ci("in"), Ci("out"), Ci()), mt = 7.5625, _t = 1 / (yt = 2.75), Si("Bounce", (function(t) {
            return 1 - bt(1 - t)
        }), bt = function(t) {
            return t < _t ? mt * t * t : t < .7272727272727273 ? mt * Math.pow(t - 1.5 / yt, 2) + .75 : t < .9090909090909092 ? mt * (t -= 2.25 / yt) * t + .9375 : mt * Math.pow(t - 2.625 / yt, 2) + .984375
        }), Si("Expo", (function(t) {
            return t ? Math.pow(2, 10 * (t - 1)) : 0
        })), Si("Circ", (function(t) {
            return -(kt(1 - t * t) - 1)
        })), Si("Sine", (function(t) {
            return 1 === t ? 1 : 1 - Lt(t * At)
        })), Si("Back", ki("in"), ki("out"), ki()), mi.SteppedEase = mi.steps = Vt.SteppedEase = {
            config: function(t, e) {
                void 0 === t && (t = 1);
                var i = 1 / t,
                    n = t + (e ? 0 : 1),
                    r = e ? 1 : 0;
                return function(t) {
                    return ((n * We(0, 1 - 1e-8, t) | 0) + r) * i
                }
            }
        }, wt.ease = mi["quad.out"], he("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", (function(t) {
            return ae += t + "," + t + "Params,"
        }));
        var Li = function(t, e) {
                this.id = Ct++, t._gsap = this, this.target = t, this.harness = e, this.get = e ? e.get : ue, this.set = e ? e.getSetter : Ui
            },
            Ei = function() {
                function t(t, e) {
                    var i = t.parent || ct;
                    this.vars = t, this._delay = +t.delay || 0, (this._repeat = t.repeat === 1 / 0 ? -2 : t.repeat || 0) && (this._rDelay = t.repeatDelay || 0, this._yoyo = !!t.yoyo || !!t.yoyoEase), this._ts = 1, Be(this, +t.duration, 1, 1), this.data = t.data, vt || gi.wake(), i && qe(i, this, e || 0 === e ? e : i._time, 1), t.reversed && this.reverse(), t.paused && this.paused(!0)
                }
                var e = t.prototype;
                return e.delay = function(t) {
                    return t || 0 === t ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t - this._delay), this._delay = t, this) : this._delay
                }, e.duration = function(t) {
                    return arguments.length ? this.totalDuration(this._repeat > 0 ? t + (t + this._rDelay) * this._repeat : t) : this.totalDuration() && this._dur
                }, e.totalDuration = function(t) {
                    return arguments.length ? (this._dirty = 0, Be(this, this._repeat < 0 ? t : (t - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur
                }, e.totalTime = function(t, e) {
                    if (vi(), !arguments.length) return this._tTime;
                    var i = this._dp;
                    if (i && i.smoothChildTiming && this._ts) {
                        for (De(this, t), !i._dp || i.parent || Re(i, this); i.parent;) i.parent._time !== i._start + (i._ts >= 0 ? i._tTime / i._ts : (i.totalDuration() - i._tTime) / -i._ts) && i.totalTime(i._tTime, !0), i = i.parent;
                        !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && t < this._tDur || this._ts < 0 && t > 0 || !this._tDur && !t) && qe(this._dp, this, this._start - this._delay)
                    }
                    return (this._tTime !== t || !this._dur && !e || this._initted && 1e-8 === Math.abs(this._zTime) || !t && !this._initted && (this.add || this._ptLookup)) && (this._ts || (this._pTime = t), ve(this, t, e)), this
                }, e.time = function(t, e) {
                    return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t + Ee(this)) % this._dur || (t ? this._dur : 0), e) : this._time
                }, e.totalProgress = function(t, e) {
                    return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio
                }, e.progress = function(t, e) {
                    return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t : 1 - t) + Ee(this), e) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio
                }, e.iteration = function(t, e) {
                    var i = this.duration() + this._rDelay;
                    return arguments.length ? this.totalTime(this._time + (t - 1) * i, e) : this._repeat ? Oe(this._tTime, i) + 1 : 1
                }, e.timeScale = function(t) {
                    if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
                    if (this._rts === t) return this;
                    var e = this.parent && this._ts ? Pe(this.parent._time, this) : this._tTime;
                    return this._rts = +t || 0, this._ts = this._ps || -1e-8 === t ? 0 : this._rts, Le(this.totalTime(We(-this._delay, this._tDur, e), !0))
                }, e.paused = function(t) {
                    return arguments.length ? (this._ps !== t && (this._ps = t, t ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (vi(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && (this._tTime -= 1e-8) && 1e-8 !== Math.abs(this._zTime)))), this) : this._ps
                }, e.startTime = function(t) {
                    if (arguments.length) {
                        this._start = t;
                        var e = this.parent || this._dp;
                        return e && (e._sort || !this.parent) && qe(e, this, t - this._delay), this
                    }
                    return this._start
                }, e.endTime = function(t) {
                    return this._start + (qt(t) ? this.totalDuration() : this.duration()) / Math.abs(this._ts)
                }, e.rawTime = function(t) {
                    var e = this.parent || this._dp;
                    return e ? t && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Pe(e.rawTime(t), this) : this._tTime : this._tTime
                }, e.globalTime = function(t) {
                    for (var e = this, i = arguments.length ? t : e.rawTime(); e;) i = e._start + i / (e._ts || 1), e = e._dp;
                    return i
                }, e.repeat = function(t) {
                    return arguments.length ? (this._repeat = t === 1 / 0 ? -2 : t, Fe(this)) : -2 === this._repeat ? 1 / 0 : this._repeat
                }, e.repeatDelay = function(t) {
                    return arguments.length ? (this._rDelay = t, Fe(this)) : this._rDelay
                }, e.yoyo = function(t) {
                    return arguments.length ? (this._yoyo = t, this) : this._yoyo
                }, e.seek = function(t, e) {
                    return this.totalTime(Ne(this, t), qt(e))
                }, e.restart = function(t, e) {
                    return this.play().totalTime(t ? -this._delay : 0, qt(e))
                }, e.play = function(t, e) {
                    return null != t && this.seek(t, e), this.reversed(!1).paused(!1)
                }, e.reverse = function(t, e) {
                    return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1)
                }, e.pause = function(t, e) {
                    return null != t && this.seek(t, e), this.paused(!0)
                }, e.resume = function() {
                    return this.paused(!1)
                }, e.reversed = function(t) {
                    return arguments.length ? (!!t !== this.reversed() && this.timeScale(-this._rts || (t ? -1e-8 : 0)), this) : this._rts < 0
                }, e.invalidate = function() {
                    return this._initted = this._act = 0, this._zTime = -1e-8, this
                }, e.isActive = function() {
                    var t, e = this.parent || this._dp,
                        i = this._start;
                    return !(e && !(this._ts && this._initted && e.isActive() && (t = e.rawTime(!0)) >= i && t < this.endTime(!0) - 1e-8))
                }, e.eventCallback = function(t, e, i) {
                    var n = this.vars;
                    return arguments.length > 1 ? (e ? (n[t] = e, i && (n[t + "Params"] = i), "onUpdate" === t && (this._onUpdate = e)) : delete n[t], this) : n[t]
                }, e.then = function(t) {
                    var e = this;
                    return new Promise((function(i) {
                        var n = Pt(t) ? t : ye,
                            r = function() {
                                var t = e.then;
                                e.then = null, Pt(n) && (n = n(e)) && (n.then || n === e) && (e.then = t), i(n), e.then = t
                            };
                        e._initted && 1 === e.totalProgress() && e._ts >= 0 || !e._tTime && e._ts < 0 ? r() : e._prom = r
                    }))
                }, e.kill = function() {
                    oi(this)
                }, t
            }();
        _e(Ei.prototype, {
            _time: 0,
            _start: 0,
            _end: 0,
            _tTime: 0,
            _tDur: 0,
            _dirty: 0,
            _repeat: 0,
            _yoyo: !1,
            parent: null,
            _initted: !1,
            _rDelay: 0,
            _ts: 1,
            _dp: 0,
            ratio: 0,
            _zTime: -1e-8,
            _prom: 0,
            _ps: !1,
            _rts: 1
        });
        var Oi = function(t) {
            function e(e, i) {
                var n;
                return void 0 === e && (e = {}), (n = t.call(this, e, i) || this).labels = {}, n.smoothChildTiming = !!e.smoothChildTiming, n.autoRemoveChildren = !!e.autoRemoveChildren, n._sort = qt(e.sortChildren), n.parent && Re(n.parent, st(n)), e.scrollTrigger && ze(st(n), e.scrollTrigger), n
            }
            at(e, t);
            var i = e.prototype;
            return i.to = function(t, e, i) {
                return new Fi(t, pe(arguments, 0, this), Ne(this, Mt(e) ? arguments[3] : i)), this
            }, i.from = function(t, e, i) {
                return new Fi(t, pe(arguments, 1, this), Ne(this, Mt(e) ? arguments[3] : i)), this
            }, i.fromTo = function(t, e, i, n) {
                return new Fi(t, pe(arguments, 2, this), Ne(this, Mt(e) ? arguments[4] : n)), this
            }, i.set = function(t, e, i) {
                return e.duration = 0, e.parent = this, Se(e).repeatDelay || (e.repeat = 0), e.immediateRender = !!e.immediateRender, new Fi(t, e, Ne(this, i), 1), this
            }, i.call = function(t, e, i) {
                return qe(this, Fi.delayedCall(0, t, e), Ne(this, i))
            }, i.staggerTo = function(t, e, i, n, r, o, s) {
                return i.duration = e, i.stagger = i.stagger || n, i.onComplete = o, i.onCompleteParams = s, i.parent = this, new Fi(t, i, Ne(this, r)), this
            }, i.staggerFrom = function(t, e, i, n, r, o, s) {
                return i.runBackwards = 1, Se(i).immediateRender = qt(i.immediateRender), this.staggerTo(t, e, i, n, r, o, s)
            }, i.staggerFromTo = function(t, e, i, n, r, o, s, a) {
                return n.startAt = i, Se(n).immediateRender = qt(n.immediateRender), this.staggerTo(t, e, n, r, o, s, a)
            }, i.render = function(t, e, i) {
                var n, r, o, s, a, l, c, u, h, d, f, p, g = this._time,
                    v = this._dirty ? this.totalDuration() : this._tDur,
                    m = this._dur,
                    y = this !== ct && t > v - 1e-8 && t >= 0 ? v : t < 1e-8 ? 0 : t,
                    _ = this._zTime < 0 != t < 0 && (this._initted || !m);
                if (y !== this._tTime || i || _) {
                    if (g !== this._time && m && (y += this._time - g, t += this._time - g), n = y, h = this._start, l = !(u = this._ts), _ && (m || (g = this._zTime), (t || !e) && (this._zTime = t)), this._repeat) {
                        if (f = this._yoyo, a = m + this._rDelay, this._repeat < -1 && t < 0) return this.totalTime(100 * a + t, e, i);
                        if (n = de(y % a), y === v ? (s = this._repeat, n = m) : ((s = ~~(y / a)) && s === y / a && (n = m, s--), n > m && (n = m)), d = Oe(this._tTime, a), !g && this._tTime && d !== s && (d = s), f && 1 & s && (n = m - n, p = 1), s !== d && !this._lock) {
                            var b = f && 1 & d,
                                x = b === (f && 1 & s);
                            if (s < d && (b = !b), g = b ? 0 : m, this._lock = 1, this.render(g || (p ? 0 : de(s * a)), e, !m)._lock = 0, !e && this.parent && ri(this, "onRepeat"), this.vars.repeatRefresh && !p && (this.invalidate()._lock = 1), g !== this._time || l !== !this._ts) return this;
                            if (m = this._dur, v = this._tDur, x && (this._lock = 2, g = b ? m : -1e-4, this.render(g, !0), this.vars.repeatRefresh && !p && this.invalidate()), this._lock = 0, !this._ts && !l) return this;
                            wi(this, p)
                        }
                    }
                    if (this._hasPause && !this._forcing && this._lock < 2 && (c = function(t, e, i) {
                            var n;
                            if (i > e)
                                for (n = t._first; n && n._start <= i;) {
                                    if (!n._dur && "isPause" === n.data && n._start > e) return n;
                                    n = n._next
                                } else
                                    for (n = t._last; n && n._start >= i;) {
                                        if (!n._dur && "isPause" === n.data && n._start < e) return n;
                                        n = n._prev
                                    }
                        }(this, de(g), de(n))) && (y -= n - (n = c._start)), this._tTime = y, this._time = n, this._act = !u, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = t, g = 0), !g && (n || !m && t >= 0) && !e && ri(this, "onStart"), n >= g && t >= 0)
                        for (r = this._first; r;) {
                            if (o = r._next, (r._act || n >= r._start) && r._ts && c !== r) {
                                if (r.parent !== this) return this.render(t, e, i);
                                if (r.render(r._ts > 0 ? (n - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (n - r._start) * r._ts, e, i), n !== this._time || !this._ts && !l) {
                                    c = 0, o && (y += this._zTime = -1e-8);
                                    break
                                }
                            }
                            r = o
                        } else {
                            r = this._last;
                            for (var w = t < 0 ? t : n; r;) {
                                if (o = r._prev, (r._act || w <= r._end) && r._ts && c !== r) {
                                    if (r.parent !== this) return this.render(t, e, i);
                                    if (r.render(r._ts > 0 ? (w - r._start) * r._ts : (r._dirty ? r.totalDuration() : r._tDur) + (w - r._start) * r._ts, e, i), n !== this._time || !this._ts && !l) {
                                        c = 0, o && (y += this._zTime = w ? -1e-8 : 1e-8);
                                        break
                                    }
                                }
                                r = o
                            }
                        }
                    if (c && !e && (this.pause(), c.render(n >= g ? 0 : -1e-8)._zTime = n >= g ? 1 : -1, this._ts)) return this._start = h, Me(this), this.render(t, e, i);
                    this._onUpdate && !e && ri(this, "onUpdate", !0), (y === v && v >= this.totalDuration() || !y && g) && (h !== this._start && Math.abs(u) === Math.abs(this._ts) || this._lock || ((t || !m) && (y === v && this._ts > 0 || !y && this._ts < 0) && Ce(this, 1), e || t < 0 && !g || !y && !g || (ri(this, y === v ? "onComplete" : "onReverseComplete", !0), this._prom && !(y < v && this.timeScale() > 0) && this._prom())))
                }
                return this
            }, i.add = function(t, e) {
                var i = this;
                if (Mt(e) || (e = Ne(this, e)), !(t instanceof Ei)) {
                    if (Ft(t)) return t.forEach((function(t) {
                        return i.add(t, e)
                    })), this;
                    if (Ot(t)) return this.addLabel(t, e);
                    if (!Pt(t)) return this;
                    t = Fi.delayedCall(0, t)
                }
                return this !== t ? qe(this, t, e) : this
            }, i.getChildren = function(t, e, i, n) {
                void 0 === t && (t = !0), void 0 === e && (e = !0), void 0 === i && (i = !0), void 0 === n && (n = -Tt);
                for (var r = [], o = this._first; o;) o._start >= n && (o instanceof Fi ? e && r.push(o) : (i && r.push(o), t && r.push.apply(r, o.getChildren(!0, e, i)))), o = o._next;
                return r
            }, i.getById = function(t) {
                for (var e = this.getChildren(1, 1, 1), i = e.length; i--;)
                    if (e[i].vars.id === t) return e[i]
            }, i.remove = function(t) {
                return Ot(t) ? this.removeLabel(t) : Pt(t) ? this.killTweensOf(t) : (Ae(this, t), t === this._recent && (this._recent = this._last), ke(this))
            }, i.totalTime = function(e, i) {
                return arguments.length ? (this._forcing = 1, !this._dp && this._ts && (this._start = de(gi.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))), t.prototype.totalTime.call(this, e, i), this._forcing = 0, this) : this._tTime
            }, i.addLabel = function(t, e) {
                return this.labels[t] = Ne(this, e), this
            }, i.removeLabel = function(t) {
                return delete this.labels[t], this
            }, i.addPause = function(t, e, i) {
                var n = Fi.delayedCall(0, e || Zt, i);
                return n.data = "isPause", this._hasPause = 1, qe(this, n, Ne(this, t))
            }, i.removePause = function(t) {
                var e = this._first;
                for (t = Ne(this, t); e;) e._start === t && "isPause" === e.data && Ce(e), e = e._next
            }, i.killTweensOf = function(t, e, i) {
                for (var n = this.getTweensOf(t, i), r = n.length; r--;) Pi !== n[r] && n[r].kill(t, e);
                return this
            }, i.getTweensOf = function(t, e) {
                for (var i, n = [], r = Ge(t), o = this._first, s = Mt(e); o;) o instanceof Fi ? fe(o._targets, r) && (s ? (!Pi || o._initted && o._ts) && o.globalTime(0) <= e && o.globalTime(o.totalDuration()) > e : !e || o.isActive()) && n.push(o) : (i = o.getTweensOf(r, e)).length && n.push.apply(n, i), o = o._next;
                return n
            }, i.tweenTo = function(t, e) {
                e = e || {};
                var i = this,
                    n = Ne(i, t),
                    r = e,
                    o = r.startAt,
                    s = r.onStart,
                    a = r.onStartParams,
                    l = r.immediateRender,
                    c = Fi.to(i, _e({
                        ease: "none",
                        lazy: !1,
                        immediateRender: !1,
                        time: n,
                        overwrite: "auto",
                        duration: e.duration || Math.abs((n - (o && "time" in o ? o.time : i._time)) / i.timeScale()) || 1e-8,
                        onStart: function() {
                            i.pause();
                            var t = e.duration || Math.abs((n - i._time) / i.timeScale());
                            c._dur !== t && Be(c, t, 0, 1).render(c._time, !0, !0), s && s.apply(c, a || [])
                        }
                    }, e));
                return l ? c.render(0) : c
            }, i.tweenFromTo = function(t, e, i) {
                return this.tweenTo(e, _e({
                    startAt: {
                        time: Ne(this, t)
                    }
                }, i))
            }, i.recent = function() {
                return this._recent
            }, i.nextLabel = function(t) {
                return void 0 === t && (t = this._time), ni(this, Ne(this, t))
            }, i.previousLabel = function(t) {
                return void 0 === t && (t = this._time), ni(this, Ne(this, t), 1)
            }, i.currentLabel = function(t) {
                return arguments.length ? this.seek(t, !0) : this.previousLabel(this._time + 1e-8)
            }, i.shiftChildren = function(t, e, i) {
                void 0 === i && (i = 0);
                for (var n, r = this._first, o = this.labels; r;) r._start >= i && (r._start += t, r._end += t), r = r._next;
                if (e)
                    for (n in o) o[n] >= i && (o[n] += t);
                return ke(this)
            }, i.invalidate = function() {
                var e = this._first;
                for (this._lock = 0; e;) e.invalidate(), e = e._next;
                return t.prototype.invalidate.call(this)
            }, i.clear = function(t) {
                void 0 === t && (t = !0);
                for (var e, i = this._first; i;) e = i._next, this.remove(i), i = e;
                return this._dp && (this._time = this._tTime = this._pTime = 0), t && (this.labels = {}), ke(this)
            }, i.totalDuration = function(t) {
                var e, i, n, r = 0,
                    o = this,
                    s = o._last,
                    a = Tt;
                if (arguments.length) return o.timeScale((o._repeat < 0 ? o.duration() : o.totalDuration()) / (o.reversed() ? -t : t));
                if (o._dirty) {
                    for (n = o.parent; s;) e = s._prev, s._dirty && s.totalDuration(), (i = s._start) > a && o._sort && s._ts && !o._lock ? (o._lock = 1, qe(o, s, i - s._delay, 1)._lock = 0) : a = i, i < 0 && s._ts && (r -= i, (!n && !o._dp || n && n.smoothChildTiming) && (o._start += i / o._ts, o._time -= i, o._tTime -= i), o.shiftChildren(-i, !1, -Infinity), a = 0), s._end > r && s._ts && (r = s._end), s = e;
                    Be(o, o === ct && o._time > r ? o._time : r, 1, 1), o._dirty = 0
                }
                return o._tDur
            }, e.updateRoot = function(t) {
                if (ct._ts && (ve(ct, Pe(t, ct)), pt = gi.frame), gi.frame >= oe) {
                    oe += xt.autoSleep || 120;
                    var e = ct._first;
                    if ((!e || !e._ts) && xt.autoSleep && gi._listeners.length < 2) {
                        for (; e && !e._ts;) e = e._next;
                        e || gi.sleep()
                    }
                }
            }, e
        }(Ei);
        _e(Oi.prototype, {
            _lock: 0,
            _hasPause: 0,
            _forcing: 0
        });
        var Pi, Mi = function(t, e, i, n, r, o, s) {
                var a, l, c, u, h, d, f, p, g = new Zi(this._pt, t, e, 0, 1, Vi, null, r),
                    v = 0,
                    m = 0;
                for (g.b = i, g.e = n, i += "", (f = ~(n += "").indexOf("random(")) && (n = ei(n)), o && (o(p = [i, n], t, e), i = p[0], n = p[1]), l = i.match(Wt) || []; a = Wt.exec(n);) u = a[0], h = n.substring(v, a.index), c ? c = (c + 1) % 5 : "rgba(" === h.substr(-5) && (c = 1), u !== l[m++] && (d = parseFloat(l[m - 1]) || 0, g._pt = {
                    _next: g._pt,
                    p: h || 1 === m ? h : ",",
                    s: d,
                    c: "=" === u.charAt(1) ? parseFloat(u.substr(2)) * ("-" === u.charAt(0) ? -1 : 1) : parseFloat(u) - d,
                    m: c && c < 4 ? Math.round : 0
                }, v = Wt.lastIndex);
                return g.c = v < n.length ? n.substring(v, n.length) : "", g.fp = s, (Ut.test(n) || f) && (g.e = 0), this._pt = g, g
            },
            Di = function(t, e, i, n, r, o, s, a, l) {
                Pt(n) && (n = n(r || 0, t, o));
                var c, u = t[e],
                    h = "get" !== i ? i : Pt(u) ? l ? t[e.indexOf("set") || !Pt(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t[e]() : u,
                    d = Pt(u) ? l ? Hi : Ni : ji;
                if (Ot(n) && (~n.indexOf("random(") && (n = ei(n)), "=" === n.charAt(1) && (n = parseFloat(h) + parseFloat(n.substr(2)) * ("-" === n.charAt(0) ? -1 : 1) + (Ue(h) || 0))), h !== n) return isNaN(h * n) ? (!u && !(e in t) && Qt(e, n), Mi.call(this, t, e, h, n, d, a || xt.stringFilter, l)) : (c = new Zi(this._pt, t, e, +h || 0, n - (h || 0), "boolean" == typeof u ? Yi : Xi, 0, d), l && (c.fp = l), s && c.modifier(s, this, t), this._pt = c)
            },
            Ri = function(t, e, i, n, r, o) {
                var s, a, l, c;
                if (ne[t] && !1 !== (s = new ne[t]).init(r, s.rawVars ? e[t] : function(t, e, i, n, r) {
                        if (Pt(t) && (t = zi(t, r, e, i, n)), !Rt(t) || t.style && t.nodeType || Ft(t) || Bt(t)) return Ot(t) ? zi(t, r, e, i, n) : t;
                        var o, s = {};
                        for (o in t) s[o] = zi(t[o], r, e, i, n);
                        return s
                    }(e[t], n, r, o, i), i, n, o) && (i._pt = a = new Zi(i._pt, r, t, 0, 1, s.render, s, 0, s.priority), i !== gt))
                    for (l = i._ptLookup[i._targets.indexOf(r)], c = s._props.length; c--;) l[s._props[c]] = a;
                return s
            },
            qi = function t(e, i) {
                var n, r, o, s, a, l, c, u, h, d, f, p, g, v = e.vars,
                    m = v.ease,
                    y = v.startAt,
                    _ = v.immediateRender,
                    b = v.lazy,
                    x = v.onUpdate,
                    w = v.onUpdateParams,
                    T = v.callbackScope,
                    S = v.runBackwards,
                    A = v.yoyoEase,
                    C = v.keyframes,
                    k = v.autoRevert,
                    L = e._dur,
                    E = e._startAt,
                    O = e._targets,
                    P = e.parent,
                    M = P && "nested" === P.data ? P.parent._targets : O,
                    D = "auto" === e._overwrite && !lt,
                    R = e.timeline;
                if (R && (!C || !m) && (m = "none"), e._ease = Ti(m, wt.ease), e._yEase = A ? xi(Ti(!0 === A ? m : A, wt.ease)) : 0, A && e._yoyo && !e._repeat && (A = e._yEase, e._yEase = e._ease, e._ease = A), !R) {
                    if (p = (u = O[0] ? ce(O[0]).harness : 0) && v[u.prop], n = Te(v, te), E && E.render(-1, !0).kill(), y) {
                        if (Ce(e._startAt = Fi.set(O, _e({
                                data: "isStart",
                                overwrite: !1,
                                parent: P,
                                immediateRender: !0,
                                lazy: qt(b),
                                startAt: null,
                                delay: 0,
                                onUpdate: x,
                                onUpdateParams: w,
                                callbackScope: T,
                                stagger: 0
                            }, y))), _)
                            if (i > 0) k || (e._startAt = 0);
                            else if (L && !(i < 0 && E)) return void(i && (e._zTime = i))
                    } else if (S && L)
                        if (E) !k && (e._startAt = 0);
                        else if (i && (_ = !1), o = _e({
                            overwrite: !1,
                            data: "isFromStart",
                            lazy: _ && qt(b),
                            immediateRender: _,
                            stagger: 0,
                            parent: P
                        }, n), p && (o[u.prop] = p), Ce(e._startAt = Fi.set(O, o)), _) {
                        if (!i) return
                    } else t(e._startAt, 1e-8);
                    for (e._pt = 0, b = L && qt(b) || b && !L, r = 0; r < O.length; r++) {
                        if (c = (a = O[r])._gsap || le(O)[r]._gsap, e._ptLookup[r] = d = {}, ie[c.id] && ee.length && ge(), f = M === O ? r : M.indexOf(a), u && !1 !== (h = new u).init(a, p || n, e, f, M) && (e._pt = s = new Zi(e._pt, a, h.name, 0, 1, h.render, h, 0, h.priority), h._props.forEach((function(t) {
                                d[t] = s
                            })), h.priority && (l = 1)), !u || p)
                            for (o in n) ne[o] && (h = Ri(o, n, e, f, a, M)) ? h.priority && (l = 1) : d[o] = s = Di.call(e, a, o, "get", n[o], f, M, 0, v.stringFilter);
                        e._op && e._op[r] && e.kill(a, e._op[r]), D && e._pt && (Pi = e, ct.killTweensOf(a, d, e.globalTime(0)), g = !e.parent, Pi = 0), e._pt && b && (ie[c.id] = 1)
                    }
                    l && Ji(e), e._onInit && e._onInit(e)
                }
                e._from = !R && !!v.runBackwards, e._onUpdate = x, e._initted = (!e._op || e._pt) && !g
            },
            zi = function(t, e, i, n, r) {
                return Pt(t) ? t.call(e, i, n, r) : Ot(t) && ~t.indexOf("random(") ? ei(t) : t
            },
            Ii = ae + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase",
            Bi = (Ii + ",id,stagger,delay,duration,paused,scrollTrigger").split(","),
            Fi = function(t) {
                function e(e, i, n, r) {
                    var o;
                    "number" == typeof i && (n.duration = i, i = n, n = null);
                    var s, a, l, c, u, h, d, f, p = (o = t.call(this, r ? i : Se(i), n) || this).vars,
                        g = p.duration,
                        v = p.delay,
                        m = p.immediateRender,
                        y = p.stagger,
                        _ = p.overwrite,
                        b = p.keyframes,
                        x = p.defaults,
                        w = p.scrollTrigger,
                        T = p.yoyoEase,
                        S = o.parent,
                        A = (Ft(e) || Bt(e) ? Mt(e[0]) : "length" in i) ? [e] : Ge(e);
                    if (o._targets = A.length ? le(A) : Kt("GSAP target " + e + " not found. https://greensock.com", !xt.nullTargetWarn) || [], o._ptLookup = [], o._overwrite = _, b || y || It(g) || It(v)) {
                        if (i = o.vars, (s = o.timeline = new Oi({
                                data: "nested",
                                defaults: x || {}
                            })).kill(), s.parent = s._dp = st(o), s._start = 0, b) _e(s.vars.defaults, {
                            ease: "none"
                        }), b.forEach((function(t) {
                            return s.to(A, t, ">")
                        }));
                        else {
                            if (c = A.length, d = y ? Qe(y) : Zt, Rt(y))
                                for (u in y) ~Ii.indexOf(u) && (f || (f = {}), f[u] = y[u]);
                            for (a = 0; a < c; a++) {
                                for (u in l = {}, i) Bi.indexOf(u) < 0 && (l[u] = i[u]);
                                l.stagger = 0, T && (l.yoyoEase = T), f && xe(l, f), h = A[a], l.duration = +zi(g, st(o), a, h, A), l.delay = (+zi(v, st(o), a, h, A) || 0) - o._delay, !y && 1 === c && l.delay && (o._delay = v = l.delay, o._start += v, l.delay = 0), s.to(h, l, d(a, h, A))
                            }
                            s.duration() ? g = v = 0 : o.timeline = 0
                        }
                        g || o.duration(g = s.duration())
                    } else o.timeline = 0;
                    return !0 !== _ || lt || (Pi = st(o), ct.killTweensOf(A), Pi = 0), S && Re(S, st(o)), (m || !g && !b && o._start === de(S._time) && qt(m) && function t(e) {
                        return !e || e._ts && t(e.parent)
                    }(st(o)) && "nested" !== S.data) && (o._tTime = -1e-8, o.render(Math.max(0, -v))), w && ze(st(o), w), o
                }
                at(e, t);
                var i = e.prototype;
                return i.render = function(t, e, i) {
                    var n, r, o, s, a, l, c, u, h, d = this._time,
                        f = this._tDur,
                        p = this._dur,
                        g = t > f - 1e-8 && t >= 0 ? f : t < 1e-8 ? 0 : t;
                    if (p) {
                        if (g !== this._tTime || !t || i || !this._initted && this._tTime || this._startAt && this._zTime < 0 != t < 0) {
                            if (n = g, u = this.timeline, this._repeat) {
                                if (s = p + this._rDelay, this._repeat < -1 && t < 0) return this.totalTime(100 * s + t, e, i);
                                if (n = de(g % s), g === f ? (o = this._repeat, n = p) : ((o = ~~(g / s)) && o === g / s && (n = p, o--), n > p && (n = p)), (l = this._yoyo && 1 & o) && (h = this._yEase, n = p - n), a = Oe(this._tTime, s), n === d && !i && this._initted) return this;
                                o !== a && (u && this._yEase && wi(u, l), !this.vars.repeatRefresh || l || this._lock || (this._lock = i = 1, this.render(de(s * o), !0).invalidate()._lock = 0))
                            }
                            if (!this._initted) {
                                if (Ie(this, t < 0 ? t : n, i, e)) return this._tTime = 0, this;
                                if (p !== this._dur) return this.render(t, e, i)
                            }
                            for (this._tTime = g, this._time = n, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = c = (h || this._ease)(n / p), this._from && (this.ratio = c = 1 - c), n && !d && !e && ri(this, "onStart"), r = this._pt; r;) r.r(c, r.d), r = r._next;
                            u && u.render(t < 0 ? t : !n && l ? -1e-8 : u._dur * c, e, i) || this._startAt && (this._zTime = t), this._onUpdate && !e && (t < 0 && this._startAt && this._startAt.render(t, !0, i), ri(this, "onUpdate")), this._repeat && o !== a && this.vars.onRepeat && !e && this.parent && ri(this, "onRepeat"), g !== this._tDur && g || this._tTime !== g || (t < 0 && this._startAt && !this._onUpdate && this._startAt.render(t, !0, !0), (t || !p) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && Ce(this, 1), e || t < 0 && !d || !g && !d || (ri(this, g === f ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < f && this.timeScale() > 0) && this._prom()))
                        }
                    } else ! function(t, e, i, n) {
                        var r, o, s, a = t.ratio,
                            l = e < 0 || !e && (!t._start && function t(e) {
                                var i = e.parent;
                                return i && i._ts && i._initted && !i._lock && (i.rawTime() < 0 || t(i))
                            }(t) || (t._ts < 0 || t._dp._ts < 0) && "isFromStart" !== t.data && "isStart" !== t.data) ? 0 : 1,
                            c = t._rDelay,
                            u = 0;
                        if (c && t._repeat && (u = We(0, t._tDur, e), o = Oe(u, c), s = Oe(t._tTime, c), t._yoyo && 1 & o && (l = 1 - l), o !== s && (a = 1 - l, t.vars.repeatRefresh && t._initted && t.invalidate())), l !== a || n || 1e-8 === t._zTime || !e && t._zTime) {
                            if (!t._initted && Ie(t, e, n, i)) return;
                            for (s = t._zTime, t._zTime = e || (i ? 1e-8 : 0), i || (i = e && !s), t.ratio = l, t._from && (l = 1 - l), t._time = 0, t._tTime = u, i || ri(t, "onStart"), r = t._pt; r;) r.r(l, r.d), r = r._next;
                            t._startAt && e < 0 && t._startAt.render(e, !0, !0), t._onUpdate && !i && ri(t, "onUpdate"), u && t._repeat && !i && t.parent && ri(t, "onRepeat"), (e >= t._tDur || e < 0) && t.ratio === l && (l && Ce(t, 1), i || (ri(t, l ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()))
                        } else t._zTime || (t._zTime = e)
                    }(this, t, e, i);
                    return this
                }, i.targets = function() {
                    return this._targets
                }, i.invalidate = function() {
                    return this._pt = this._op = this._startAt = this._onUpdate = this._lazy = this.ratio = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(), t.prototype.invalidate.call(this)
                }, i.kill = function(t, e) {
                    if (void 0 === e && (e = "all"), !(t || e && "all" !== e)) return this._lazy = this._pt = 0, this.parent ? oi(this) : this;
                    if (this.timeline) {
                        var i = this.timeline.totalDuration();
                        return this.timeline.killTweensOf(t, e, Pi && !0 !== Pi.vars.overwrite)._first || oi(this), this.parent && i !== this.timeline.totalDuration() && Be(this, this._dur * this.timeline._tDur / i, 0, 1), this
                    }
                    var n, r, o, s, a, l, c, u = this._targets,
                        h = t ? Ge(t) : u,
                        d = this._ptLookup,
                        f = this._pt;
                    if ((!e || "all" === e) && function(t, e) {
                            for (var i = t.length, n = i === e.length; n && i-- && t[i] === e[i];);
                            return i < 0
                        }(u, h)) return "all" === e && (this._pt = 0), oi(this);
                    for (n = this._op = this._op || [], "all" !== e && (Ot(e) && (a = {}, he(e, (function(t) {
                            return a[t] = 1
                        })), e = a), e = function(t, e) {
                            var i, n, r, o, s = t[0] ? ce(t[0]).harness : 0,
                                a = s && s.aliases;
                            if (!a) return e;
                            for (n in i = xe({}, e), a)
                                if (n in i)
                                    for (r = (o = a[n].split(",")).length; r--;) i[o[r]] = i[n];
                            return i
                        }(u, e)), c = u.length; c--;)
                        if (~h.indexOf(u[c]))
                            for (a in r = d[c], "all" === e ? (n[c] = e, s = r, o = {}) : (o = n[c] = n[c] || {}, s = e), s)(l = r && r[a]) && ("kill" in l.d && !0 !== l.d.kill(a) || Ae(this, l, "_pt"), delete r[a]), "all" !== o && (o[a] = 1);
                    return this._initted && !this._pt && f && oi(this), this
                }, e.to = function(t, i) {
                    return new e(t, i, arguments[2])
                }, e.from = function(t, i) {
                    return new e(t, pe(arguments, 1))
                }, e.delayedCall = function(t, i, n, r) {
                    return new e(i, 0, {
                        immediateRender: !1,
                        lazy: !1,
                        overwrite: !1,
                        delay: t,
                        onComplete: i,
                        onReverseComplete: i,
                        onCompleteParams: n,
                        onReverseCompleteParams: n,
                        callbackScope: r
                    })
                }, e.fromTo = function(t, i, n) {
                    return new e(t, pe(arguments, 2))
                }, e.set = function(t, i) {
                    return i.duration = 0, i.repeatDelay || (i.repeat = 0), new e(t, i)
                }, e.killTweensOf = function(t, e, i) {
                    return ct.killTweensOf(t, e, i)
                }, e
            }(Ei);
        _e(Fi.prototype, {
            _targets: [],
            _lazy: 0,
            _startAt: 0,
            _op: 0,
            _onInit: 0
        }), he("staggerTo,staggerFrom,staggerFromTo", (function(t) {
            Fi[t] = function() {
                var e = new Oi,
                    i = Xe.call(arguments, 0);
                return i.splice("staggerFromTo" === t ? 5 : 4, 0, 0), e[t].apply(e, i)
            }
        }));
        var ji = function(t, e, i) {
                return t[e] = i
            },
            Ni = function(t, e, i) {
                return t[e](i)
            },
            Hi = function(t, e, i, n) {
                return t[e](n.fp, i)
            },
            Wi = function(t, e, i) {
                return t.setAttribute(e, i)
            },
            Ui = function(t, e) {
                return Pt(t[e]) ? Ni : Dt(t[e]) && t.setAttribute ? Wi : ji
            },
            Xi = function(t, e) {
                return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4, e)
            },
            Yi = function(t, e) {
                return e.set(e.t, e.p, !!(e.s + e.c * t), e)
            },
            Vi = function(t, e) {
                var i = e._pt,
                    n = "";
                if (!t && e.b) n = e.b;
                else if (1 === t && e.e) n = e.e;
                else {
                    for (; i;) n = i.p + (i.m ? i.m(i.s + i.c * t) : Math.round(1e4 * (i.s + i.c * t)) / 1e4) + n, i = i._next;
                    n += e.c
                }
                e.set(e.t, e.p, n, e)
            },
            Gi = function(t, e) {
                for (var i = e._pt; i;) i.r(t, i.d), i = i._next
            },
            $i = function(t, e, i, n) {
                for (var r, o = this._pt; o;) r = o._next, o.p === n && o.modifier(t, e, i), o = r
            },
            Qi = function(t) {
                for (var e, i, n = this._pt; n;) i = n._next, n.p === t && !n.op || n.op === t ? Ae(this, n, "_pt") : n.dep || (e = 1), n = i;
                return !e
            },
            Ki = function(t, e, i, n) {
                n.mSet(t, e, n.m.call(n.tween, i, n.mt), n)
            },
            Ji = function(t) {
                for (var e, i, n, r, o = t._pt; o;) {
                    for (e = o._next, i = n; i && i.pr > o.pr;) i = i._next;
                    (o._prev = i ? i._prev : r) ? o._prev._next = o: n = o, (o._next = i) ? i._prev = o : r = o, o = e
                }
                t._pt = n
            },
            Zi = function() {
                function t(t, e, i, n, r, o, s, a, l) {
                    this.t = e, this.s = n, this.c = r, this.p = i, this.r = o || Xi, this.d = s || this, this.set = a || ji, this.pr = l || 0, this._next = t, t && (t._prev = this)
                }
                return t.prototype.modifier = function(t, e, i) {
                    this.mSet = this.mSet || this.set, this.set = Ki, this.m = t, this.mt = i, this.tween = e
                }, t
            }();
        he(ae + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", (function(t) {
            return te[t] = 1
        })), Vt.TweenMax = Vt.TweenLite = Fi, Vt.TimelineLite = Vt.TimelineMax = Oi, ct = new Oi({
            sortChildren: !1,
            defaults: wt,
            autoRemoveChildren: !0,
            id: "root",
            smoothChildTiming: !0
        }), xt.stringFilter = pi;
        var tn = {
            registerPlugin: function() {
                for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
                e.forEach((function(t) {
                    return si(t)
                }))
            },
            timeline: function(t) {
                return new Oi(t)
            },
            getTweensOf: function(t, e) {
                return ct.getTweensOf(t, e)
            },
            getProperty: function(t, e, i, n) {
                Ot(t) && (t = Ge(t)[0]);
                var r = ce(t || {}).get,
                    o = i ? ye : me;
                return "native" === i && (i = ""), t ? e ? o((ne[e] && ne[e].get || r)(t, e, i, n)) : function(e, i, n) {
                    return o((ne[e] && ne[e].get || r)(t, e, i, n))
                } : t
            },
            quickSetter: function(t, e, i) {
                if ((t = Ge(t)).length > 1) {
                    var n = t.map((function(t) {
                            return rn.quickSetter(t, e, i)
                        })),
                        r = n.length;
                    return function(t) {
                        for (var e = r; e--;) n[e](t)
                    }
                }
                t = t[0] || {};
                var o = ne[e],
                    s = ce(t),
                    a = s.harness && (s.harness.aliases || {})[e] || e,
                    l = o ? function(e) {
                        var n = new o;
                        gt._pt = 0, n.init(t, i ? e + i : e, gt, 0, [t]), n.render(1, n), gt._pt && Gi(1, gt)
                    } : s.set(t, a);
                return o ? l : function(e) {
                    return l(t, a, i ? e + i : e, s, 1)
                }
            },
            isTweening: function(t) {
                return ct.getTweensOf(t, !0).length > 0
            },
            defaults: function(t) {
                return t && t.ease && (t.ease = Ti(t.ease, wt.ease)), we(wt, t || {})
            },
            config: function(t) {
                return we(xt, t || {})
            },
            registerEffect: function(t) {
                var e = t.name,
                    i = t.effect,
                    n = t.plugins,
                    r = t.defaults,
                    o = t.extendTimeline;
                (n || "").split(",").forEach((function(t) {
                    return t && !ne[t] && !Vt[t] && Kt(e + " effect requires " + t + " plugin.")
                })), re[e] = function(t, e, n) {
                    return i(Ge(t), _e(e || {}, r), n)
                }, o && (Oi.prototype[e] = function(t, i, n) {
                    return this.add(re[e](t, Rt(i) ? i : (n = i) && {}, this), n)
                })
            },
            registerEase: function(t, e) {
                mi[t] = Ti(e)
            },
            parseEase: function(t, e) {
                return arguments.length ? Ti(t, e) : mi
            },
            getById: function(t) {
                return ct.getById(t)
            },
            exportRoot: function(t, e) {
                void 0 === t && (t = {});
                var i, n, r = new Oi(t);
                for (r.smoothChildTiming = qt(t.smoothChildTiming), ct.remove(r), r._dp = 0, r._time = r._tTime = ct._time, i = ct._first; i;) n = i._next, !e && !i._dur && i instanceof Fi && i.vars.onComplete === i._targets[0] || qe(r, i, i._start - i._delay), i = n;
                return qe(ct, r, 0), r
            },
            utils: {
                wrap: function t(e, i, n) {
                    var r = i - e;
                    return Ft(e) ? ti(e, t(0, e.length), i) : He(n, (function(t) {
                        return (r + (t - e) % r) % r + e
                    }))
                },
                wrapYoyo: function t(e, i, n) {
                    var r = i - e,
                        o = 2 * r;
                    return Ft(e) ? ti(e, t(0, e.length - 1), i) : He(n, (function(t) {
                        return e + ((t = (o + (t - e) % o) % o || 0) > r ? o - t : t)
                    }))
                },
                distribute: Qe,
                random: Ze,
                snap: Je,
                normalize: function(t, e, i) {
                    return ii(t, e, 0, 1, i)
                },
                getUnit: Ue,
                clamp: function(t, e, i) {
                    return He(i, (function(i) {
                        return We(t, e, i)
                    }))
                },
                splitColor: ci,
                toArray: Ge,
                mapRange: ii,
                pipe: function() {
                    for (var t = arguments.length, e = new Array(t), i = 0; i < t; i++) e[i] = arguments[i];
                    return function(t) {
                        return e.reduce((function(t, e) {
                            return e(t)
                        }), t)
                    }
                },
                unitize: function(t, e) {
                    return function(i) {
                        return t(parseFloat(i)) + (e || Ue(i))
                    }
                },
                interpolate: function t(e, i, n, r) {
                    var o = isNaN(e + i) ? 0 : function(t) {
                        return (1 - t) * e + t * i
                    };
                    if (!o) {
                        var s, a, l, c, u, h = Ot(e),
                            d = {};
                        if (!0 === n && (r = 1) && (n = null), h) e = {
                            p: e
                        }, i = {
                            p: i
                        };
                        else if (Ft(e) && !Ft(i)) {
                            for (l = [], c = e.length, u = c - 2, a = 1; a < c; a++) l.push(t(e[a - 1], e[a]));
                            c--, o = function(t) {
                                t *= c;
                                var e = Math.min(u, ~~t);
                                return l[e](t - e)
                            }, n = i
                        } else r || (e = xe(Ft(e) ? [] : {}, e));
                        if (!l) {
                            for (s in i) Di.call(d, e, s, "get", i[s]);
                            o = function(t) {
                                return Gi(t, d) || (h ? e.p : e)
                            }
                        }
                    }
                    return He(n, o)
                },
                shuffle: $e
            },
            install: $t,
            effects: re,
            ticker: gi,
            updateRoot: Oi.updateRoot,
            plugins: ne,
            globalTimeline: ct,
            core: {
                PropTween: Zi,
                globals: Jt,
                Tween: Fi,
                Timeline: Oi,
                Animation: Ei,
                getCache: ce,
                _removeLinkedListItem: Ae,
                suppressOverwrites: function(t) {
                    return lt = t
                }
            }
        };
        he("to,from,fromTo,delayedCall,set,killTweensOf", (function(t) {
            return tn[t] = Fi[t]
        })), gi.add(Oi.updateRoot), gt = tn.to({}, {
            duration: 0
        });
        var en = function(t, e) {
                for (var i = t._pt; i && i.p !== e && i.op !== e && i.fp !== e;) i = i._next;
                return i
            },
            nn = function(t, e) {
                return {
                    name: t,
                    rawVars: 1,
                    init: function(t, i, n) {
                        n._onInit = function(t) {
                            var n, r;
                            if (Ot(i) && (n = {}, he(i, (function(t) {
                                    return n[t] = 1
                                })), i = n), e) {
                                for (r in n = {}, i) n[r] = e(i[r]);
                                i = n
                            }! function(t, e) {
                                var i, n, r, o = t._targets;
                                for (i in e)
                                    for (n = o.length; n--;)(r = t._ptLookup[n][i]) && (r = r.d) && (r._pt && (r = en(r, i)), r && r.modifier && r.modifier(e[i], t, o[n], i))
                            }(t, i)
                        }
                    }
                }
            },
            rn = tn.registerPlugin({
                name: "attr",
                init: function(t, e, i, n, r) {
                    var o, s;
                    for (o in e)(s = this.add(t, "setAttribute", (t.getAttribute(o) || 0) + "", e[o], n, r, 0, 0, o)) && (s.op = o), this._props.push(o)
                }
            }, {
                name: "endArray",
                init: function(t, e) {
                    for (var i = e.length; i--;) this.add(t, i, t[i] || 0, e[i])
                }
            }, nn("roundProps", Ke), nn("modifiers"), nn("snap", Je)) || tn;
        Fi.version = Oi.version = rn.version = "3.6.0", ft = 1, zt() && vi();
        mi.Power0, mi.Power1, mi.Power2, mi.Power3;
        /*!
         * CSSPlugin 3.6.0
         * https://greensock.com
         *
         * Copyright 2008-2021, GreenSock. All rights reserved.
         * Subject to the terms at https://greensock.com/standard-license or for
         * Club GreenSock members, the agreement issued with that membership.
         * @author: Jack Doyle, jack@greensock.com
         */
        var on, sn, an, ln, cn, un, hn, dn, fn = mi.Power4,
            pn = (mi.Linear, mi.Quad, mi.Cubic, mi.Quart, mi.Quint, mi.Strong, mi.Elastic, mi.Back, mi.SteppedEase, mi.Bounce, mi.Sine, mi.Expo, mi.Circ, {}),
            gn = 180 / Math.PI,
            vn = Math.PI / 180,
            mn = Math.atan2,
            yn = /([A-Z])/g,
            _n = /(?:left|right|width|margin|padding|x)/i,
            bn = /[\s,\(]\S/,
            xn = {
                autoAlpha: "opacity,visibility",
                scale: "scaleX,scaleY",
                alpha: "opacity"
            },
            wn = function(t, e) {
                return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e)
            },
            Tn = function(t, e) {
                return e.set(e.t, e.p, 1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e)
            },
            Sn = function(t, e) {
                return e.set(e.t, e.p, t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b, e)
            },
            An = function(t, e) {
                var i = e.s + e.c * t;
                e.set(e.t, e.p, ~~(i + (i < 0 ? -.5 : .5)) + e.u, e)
            },
            Cn = function(t, e) {
                return e.set(e.t, e.p, t ? e.e : e.b, e)
            },
            kn = function(t, e) {
                return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e)
            },
            Ln = function(t, e, i) {
                return t.style[e] = i
            },
            En = function(t, e, i) {
                return t.style.setProperty(e, i)
            },
            On = function(t, e, i) {
                return t._gsap[e] = i
            },
            Pn = function(t, e, i) {
                return t._gsap.scaleX = t._gsap.scaleY = i
            },
            Mn = function(t, e, i, n, r) {
                var o = t._gsap;
                o.scaleX = o.scaleY = i, o.renderTransform(r, o)
            },
            Dn = function(t, e, i, n, r) {
                var o = t._gsap;
                o[e] = i, o.renderTransform(r, o)
            },
            Rn = "transform",
            qn = Rn + "Origin",
            zn = function(t, e) {
                var i = sn.createElementNS ? sn.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : sn.createElement(t);
                return i.style ? i : sn.createElement(t)
            },
            In = function t(e, i, n) {
                var r = getComputedStyle(e);
                return r[i] || r.getPropertyValue(i.replace(yn, "-$1").toLowerCase()) || r.getPropertyValue(i) || !n && t(e, Fn(i) || i, 1) || ""
            },
            Bn = "O,Moz,ms,Ms,Webkit".split(","),
            Fn = function(t, e, i) {
                var n = (e || cn).style,
                    r = 5;
                if (t in n && !i) return t;
                for (t = t.charAt(0).toUpperCase() + t.substr(1); r-- && !(Bn[r] + t in n););
                return r < 0 ? null : (3 === r ? "ms" : r >= 0 ? Bn[r] : "") + t
            },
            jn = function() {
                "undefined" != typeof window && window.document && (on = window, sn = on.document, an = sn.documentElement, cn = zn("div") || {
                    style: {}
                }, un = zn("div"), Rn = Fn(Rn), qn = Rn + "Origin", cn.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", dn = !!Fn("perspective"), ln = 1)
            },
            Nn = function t(e) {
                var i, n = zn("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
                    r = this.parentNode,
                    o = this.nextSibling,
                    s = this.style.cssText;
                if (an.appendChild(n), n.appendChild(this), this.style.display = "block", e) try {
                    i = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = t
                } catch (t) {} else this._gsapBBox && (i = this._gsapBBox());
                return r && (o ? r.insertBefore(this, o) : r.appendChild(this)), an.removeChild(n), this.style.cssText = s, i
            },
            Hn = function(t, e) {
                for (var i = e.length; i--;)
                    if (t.hasAttribute(e[i])) return t.getAttribute(e[i])
            },
            Wn = function(t) {
                var e;
                try {
                    e = t.getBBox()
                } catch (i) {
                    e = Nn.call(t, !0)
                }
                return e && (e.width || e.height) || t.getBBox === Nn || (e = Nn.call(t, !0)), !e || e.width || e.x || e.y ? e : {
                    x: +Hn(t, ["x", "cx", "x1"]) || 0,
                    y: +Hn(t, ["y", "cy", "y1"]) || 0,
                    width: 0,
                    height: 0
                }
            },
            Un = function(t) {
                return !(!t.getCTM || t.parentNode && !t.ownerSVGElement || !Wn(t))
            },
            Xn = function(t, e) {
                if (e) {
                    var i = t.style;
                    e in pn && e !== qn && (e = Rn), i.removeProperty ? ("ms" !== e.substr(0, 2) && "webkit" !== e.substr(0, 6) || (e = "-" + e), i.removeProperty(e.replace(yn, "-$1").toLowerCase())) : i.removeAttribute(e)
                }
            },
            Yn = function(t, e, i, n, r, o) {
                var s = new Zi(t._pt, e, i, 0, 1, o ? kn : Cn);
                return t._pt = s, s.b = n, s.e = r, t._props.push(i), s
            },
            Vn = {
                deg: 1,
                rad: 1,
                turn: 1
            },
            Gn = function t(e, i, n, r) {
                var o, s, a, l, c = parseFloat(n) || 0,
                    u = (n + "").trim().substr((c + "").length) || "px",
                    h = cn.style,
                    d = _n.test(i),
                    f = "svg" === e.tagName.toLowerCase(),
                    p = (f ? "client" : "offset") + (d ? "Width" : "Height"),
                    g = "px" === r,
                    v = "%" === r;
                return r === u || !c || Vn[r] || Vn[u] ? c : ("px" !== u && !g && (c = t(e, i, n, "px")), l = e.getCTM && Un(e), !v && "%" !== u || !pn[i] && !~i.indexOf("adius") ? (h[d ? "width" : "height"] = 100 + (g ? u : r), s = ~i.indexOf("adius") || "em" === r && e.appendChild && !f ? e : e.parentNode, l && (s = (e.ownerSVGElement || {}).parentNode), s && s !== sn && s.appendChild || (s = sn.body), (a = s._gsap) && v && a.width && d && a.time === gi.time ? de(c / a.width * 100) : ((v || "%" === u) && (h.position = In(e, "position")), s === e && (h.position = "static"), s.appendChild(cn), o = cn[p], s.removeChild(cn), h.position = "absolute", d && v && ((a = ce(s)).time = gi.time, a.width = s[p]), de(g ? o * c / 100 : o && c ? 100 / o * c : 0))) : (o = l ? e.getBBox()[d ? "width" : "height"] : e[p], de(v ? c / o * 100 : c / 100 * o)))
            },
            $n = function(t, e, i, n) {
                var r;
                return ln || jn(), e in xn && "transform" !== e && ~(e = xn[e]).indexOf(",") && (e = e.split(",")[0]), pn[e] && "transform" !== e ? (r = ar(t, n), r = "transformOrigin" !== e ? r[e] : lr(In(t, qn)) + " " + r.zOrigin + "px") : (!(r = t.style[e]) || "auto" === r || n || ~(r + "").indexOf("calc(")) && (r = tr[e] && tr[e](t, e, i) || In(t, e) || ue(t, e) || ("opacity" === e ? 1 : 0)), i && !~(r + "").trim().indexOf(" ") ? Gn(t, e, r, i) + i : r
            },
            Qn = function(t, e, i, n) {
                if (!i || "none" === i) {
                    var r = Fn(e, t, 1),
                        o = r && In(t, r, 1);
                    o && o !== i ? (e = r, i = o) : "borderColor" === e && (i = In(t, "borderTopColor"))
                }
                var s, a, l, c, u, h, d, f, p, g, v, m, y = new Zi(this._pt, t.style, e, 0, 1, Vi),
                    _ = 0,
                    b = 0;
                if (y.b = i, y.e = n, i += "", "auto" === (n += "") && (t.style[e] = n, n = In(t, e) || n, t.style[e] = i), pi(s = [i, n]), n = s[1], l = (i = s[0]).match(Ht) || [], (n.match(Ht) || []).length) {
                    for (; a = Ht.exec(n);) d = a[0], p = n.substring(_, a.index), u ? u = (u + 1) % 5 : "rgba(" !== p.substr(-5) && "hsla(" !== p.substr(-5) || (u = 1), d !== (h = l[b++] || "") && (c = parseFloat(h) || 0, v = h.substr((c + "").length), (m = "=" === d.charAt(1) ? +(d.charAt(0) + "1") : 0) && (d = d.substr(2)), f = parseFloat(d), g = d.substr((f + "").length), _ = Ht.lastIndex - g.length, g || (g = g || xt.units[e] || v, _ === n.length && (n += g, y.e += g)), v !== g && (c = Gn(t, e, h, g) || 0), y._pt = {
                        _next: y._pt,
                        p: p || 1 === b ? p : ",",
                        s: c,
                        c: m ? m * f : f - c,
                        m: u && u < 4 || "zIndex" === e ? Math.round : 0
                    });
                    y.c = _ < n.length ? n.substring(_, n.length) : ""
                } else y.r = "display" === e && "none" === n ? kn : Cn;
                return Ut.test(n) && (y.e = 0), this._pt = y, y
            },
            Kn = {
                top: "0%",
                bottom: "100%",
                left: "0%",
                right: "100%",
                center: "50%"
            },
            Jn = function(t) {
                var e = t.split(" "),
                    i = e[0],
                    n = e[1] || "50%";
                return "top" !== i && "bottom" !== i && "left" !== n && "right" !== n || (t = i, i = n, n = t), e[0] = Kn[i] || i, e[1] = Kn[n] || n, e.join(" ")
            },
            Zn = function(t, e) {
                if (e.tween && e.tween._time === e.tween._dur) {
                    var i, n, r, o = e.t,
                        s = o.style,
                        a = e.u,
                        l = o._gsap;
                    if ("all" === a || !0 === a) s.cssText = "", n = 1;
                    else
                        for (r = (a = a.split(",")).length; --r > -1;) i = a[r], pn[i] && (n = 1, i = "transformOrigin" === i ? qn : Rn), Xn(o, i);
                    n && (Xn(o, Rn), l && (l.svg && o.removeAttribute("transform"), ar(o, 1), l.uncache = 1))
                }
            },
            tr = {
                clearProps: function(t, e, i, n, r) {
                    if ("isFromStart" !== r.data) {
                        var o = t._pt = new Zi(t._pt, e, i, 0, 0, Zn);
                        return o.u = n, o.pr = -10, o.tween = r, t._props.push(i), 1
                    }
                }
            },
            er = [1, 0, 0, 1, 0, 0],
            ir = {},
            nr = function(t) {
                return "matrix(1, 0, 0, 1, 0, 0)" === t || "none" === t || !t
            },
            rr = function(t) {
                var e = In(t, Rn);
                return nr(e) ? er : e.substr(7).match(Nt).map(de)
            },
            or = function(t, e) {
                var i, n, r, o, s = t._gsap || ce(t),
                    a = t.style,
                    l = rr(t);
                return s.svg && t.getAttribute("transform") ? "1,0,0,1,0,0" === (l = [(r = t.transform.baseVal.consolidate().matrix).a, r.b, r.c, r.d, r.e, r.f]).join(",") ? er : l : (l !== er || t.offsetParent || t === an || s.svg || (r = a.display, a.display = "block", (i = t.parentNode) && t.offsetParent || (o = 1, n = t.nextSibling, an.appendChild(t)), l = rr(t), r ? a.display = r : Xn(t, "display"), o && (n ? i.insertBefore(t, n) : i ? i.appendChild(t) : an.removeChild(t))), e && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l)
            },
            sr = function(t, e, i, n, r, o) {
                var s, a, l, c = t._gsap,
                    u = r || or(t, !0),
                    h = c.xOrigin || 0,
                    d = c.yOrigin || 0,
                    f = c.xOffset || 0,
                    p = c.yOffset || 0,
                    g = u[0],
                    v = u[1],
                    m = u[2],
                    y = u[3],
                    _ = u[4],
                    b = u[5],
                    x = e.split(" "),
                    w = parseFloat(x[0]) || 0,
                    T = parseFloat(x[1]) || 0;
                i ? u !== er && (a = g * y - v * m) && (l = w * (-v / a) + T * (g / a) - (g * b - v * _) / a, w = w * (y / a) + T * (-m / a) + (m * b - y * _) / a, T = l) : (w = (s = Wn(t)).x + (~x[0].indexOf("%") ? w / 100 * s.width : w), T = s.y + (~(x[1] || x[0]).indexOf("%") ? T / 100 * s.height : T)), n || !1 !== n && c.smooth ? (_ = w - h, b = T - d, c.xOffset = f + (_ * g + b * m) - _, c.yOffset = p + (_ * v + b * y) - b) : c.xOffset = c.yOffset = 0, c.xOrigin = w, c.yOrigin = T, c.smooth = !!n, c.origin = e, c.originIsAbsolute = !!i, t.style[qn] = "0px 0px", o && (Yn(o, c, "xOrigin", h, w), Yn(o, c, "yOrigin", d, T), Yn(o, c, "xOffset", f, c.xOffset), Yn(o, c, "yOffset", p, c.yOffset)), t.setAttribute("data-svg-origin", w + " " + T)
            },
            ar = function(t, e) {
                var i = t._gsap || new Li(t);
                if ("x" in i && !e && !i.uncache) return i;
                var n, r, o, s, a, l, c, u, h, d, f, p, g, v, m, y, _, b, x, w, T, S, A, C, k, L, E, O, P, M, D, R, q = t.style,
                    z = i.scaleX < 0,
                    I = In(t, qn) || "0";
                return n = r = o = l = c = u = h = d = f = 0, s = a = 1, i.svg = !(!t.getCTM || !Un(t)), v = or(t, i.svg), i.svg && (C = !i.uncache && t.getAttribute("data-svg-origin"), sr(t, C || I, !!C || i.originIsAbsolute, !1 !== i.smooth, v)), p = i.xOrigin || 0, g = i.yOrigin || 0, v !== er && (b = v[0], x = v[1], w = v[2], T = v[3], n = S = v[4], r = A = v[5], 6 === v.length ? (s = Math.sqrt(b * b + x * x), a = Math.sqrt(T * T + w * w), l = b || x ? mn(x, b) * gn : 0, (h = w || T ? mn(w, T) * gn + l : 0) && (a *= Math.cos(h * vn)), i.svg && (n -= p - (p * b + g * w), r -= g - (p * x + g * T))) : (R = v[6], M = v[7], E = v[8], O = v[9], P = v[10], D = v[11], n = v[12], r = v[13], o = v[14], c = (m = mn(R, P)) * gn, m && (C = S * (y = Math.cos(-m)) + E * (_ = Math.sin(-m)), k = A * y + O * _, L = R * y + P * _, E = S * -_ + E * y, O = A * -_ + O * y, P = R * -_ + P * y, D = M * -_ + D * y, S = C, A = k, R = L), u = (m = mn(-w, P)) * gn, m && (y = Math.cos(-m), D = T * (_ = Math.sin(-m)) + D * y, b = C = b * y - E * _, x = k = x * y - O * _, w = L = w * y - P * _), l = (m = mn(x, b)) * gn, m && (C = b * (y = Math.cos(m)) + x * (_ = Math.sin(m)), k = S * y + A * _, x = x * y - b * _, A = A * y - S * _, b = C, S = k), c && Math.abs(c) + Math.abs(l) > 359.9 && (c = l = 0, u = 180 - u), s = de(Math.sqrt(b * b + x * x + w * w)), a = de(Math.sqrt(A * A + R * R)), m = mn(S, A), h = Math.abs(m) > 2e-4 ? m * gn : 0, f = D ? 1 / (D < 0 ? -D : D) : 0), i.svg && (C = t.getAttribute("transform"), i.forceCSS = t.setAttribute("transform", "") || !nr(In(t, Rn)), C && t.setAttribute("transform", C))), Math.abs(h) > 90 && Math.abs(h) < 270 && (z ? (s *= -1, h += l <= 0 ? 180 : -180, l += l <= 0 ? 180 : -180) : (a *= -1, h += h <= 0 ? 180 : -180)), i.x = n - ((i.xPercent = n && (i.xPercent || (Math.round(t.offsetWidth / 2) === Math.round(-n) ? -50 : 0))) ? t.offsetWidth * i.xPercent / 100 : 0) + "px", i.y = r - ((i.yPercent = r && (i.yPercent || (Math.round(t.offsetHeight / 2) === Math.round(-r) ? -50 : 0))) ? t.offsetHeight * i.yPercent / 100 : 0) + "px", i.z = o + "px", i.scaleX = de(s), i.scaleY = de(a), i.rotation = de(l) + "deg", i.rotationX = de(c) + "deg", i.rotationY = de(u) + "deg", i.skewX = h + "deg", i.skewY = d + "deg", i.transformPerspective = f + "px", (i.zOrigin = parseFloat(I.split(" ")[2]) || 0) && (q[qn] = lr(I)), i.xOffset = i.yOffset = 0, i.force3D = xt.force3D, i.renderTransform = i.svg ? dr : dn ? hr : ur, i.uncache = 0, i
            },
            lr = function(t) {
                return (t = t.split(" "))[0] + " " + t[1]
            },
            cr = function(t, e, i) {              
                var n = Ue(e);
                return de(parseFloat(e) + parseFloat(Gn(t, "x", i + "px", n))) + n
            },
            ur = function(t, e) {
                e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, hr(t, e)
            },
            hr = function(t, e) {
                var i = e || this,
                    n = i.xPercent,
                    r = i.yPercent,
                    o = i.x,
                    s = i.y,
                    a = i.z,
                    l = i.rotation,
                    c = i.rotationY,
                    u = i.rotationX,
                    h = i.skewX,
                    d = i.skewY,
                    f = i.scaleX,
                    p = i.scaleY,
                    g = i.transformPerspective,
                    v = i.force3D,
                    m = i.target,
                    y = i.zOrigin,
                    _ = "",
                    b = "auto" === v && t && 1 !== t || !0 === v;
                if (y && ("0deg" !== u || "0deg" !== c)) {
                    var x, w = parseFloat(c) * vn,
                        T = Math.sin(w),
                        S = Math.cos(w);
                    w = parseFloat(u) * vn, x = Math.cos(w), o = cr(m, o, T * x * -y), s = cr(m, s, -Math.sin(w) * -y), a = cr(m, a, S * x * -y + y)
                }
                "0px" !== g && (_ += "perspective(" + g + ") "), (n || r) && (_ += "translate(" + n + "%, " + r + "%) "), (b || "0px" !== o || "0px" !== s || "0px" !== a) && (_ += "0px" !== a || b ? "translate3d(" + o + ", " + s + ", " + a + ") " : "translate(" + o + ", " + s + ") "), "0deg" !== l && (_ += "rotate(" + l + ") "), "0deg" !== c && (_ += "rotateY(" + c + ") "), "0deg" !== u && (_ += "rotateX(" + u + ") "), "0deg" === h && "0deg" === d || (_ += "skew(" + h + ", " + d + ") "), 1 === f && 1 === p || (_ += "scale(" + f + ", " + p + ") "), m.style[Rn] = _ || "translate(0, 0)"
            },
            dr = function(t, e) {
                var i, n, r, o, s, a = e || this,
                    l = a.xPercent,
                    c = a.yPercent,
                    u = a.x,
                    h = a.y,
                    d = a.rotation,
                    f = a.skewX,
                    p = a.skewY,
                    g = a.scaleX,
                    v = a.scaleY,
                    m = a.target,
                    y = a.xOrigin,
                    _ = a.yOrigin,
                    b = a.xOffset,
                    x = a.yOffset,
                    w = a.forceCSS,
                    T = parseFloat(u),
                    S = parseFloat(h);
                d = parseFloat(d), f = parseFloat(f), (p = parseFloat(p)) && (f += p = parseFloat(p), d += p), d || f ? (d *= vn, f *= vn, i = Math.cos(d) * g, n = Math.sin(d) * g, r = Math.sin(d - f) * -v, o = Math.cos(d - f) * v, f && (p *= vn, s = Math.tan(f - p), r *= s = Math.sqrt(1 + s * s), o *= s, p && (s = Math.tan(p), i *= s = Math.sqrt(1 + s * s), n *= s)), i = de(i), n = de(n), r = de(r), o = de(o)) : (i = g, o = v, n = r = 0), (T && !~(u + "").indexOf("px") || S && !~(h + "").indexOf("px")) && (T = Gn(m, "x", u, "px"), S = Gn(m, "y", h, "px")), (y || _ || b || x) && (T = de(T + y - (y * i + _ * r) + b), S = de(S + _ - (y * n + _ * o) + x)), (l || c) && (s = m.getBBox(), T = de(T + l / 100 * s.width), S = de(S + c / 100 * s.height)), s = "matrix(" + i + "," + n + "," + r + "," + o + "," + T + "," + S + ")", m.setAttribute("transform", s), w && (m.style[Rn] = s)
            },
            fr = function(t, e, i, n, r, o) {
                var s, a, l = Ot(r),
                    c = parseFloat(r) * (l && ~r.indexOf("rad") ? gn : 1),
                    u = o ? c * o : c - n,
                    h = n + u + "deg";
                return l && ("short" === (s = r.split("_")[1]) && (u %= 360) !== u % 180 && (u += u < 0 ? 360 : -360), "cw" === s && u < 0 ? u = (u + 36e9) % 360 - 360 * ~~(u / 360) : "ccw" === s && u > 0 && (u = (u - 36e9) % 360 - 360 * ~~(u / 360))), t._pt = a = new Zi(t._pt, e, i, n, u, Tn), a.e = h, a.u = "deg", t._props.push(i), a
            },
            pr = function(t, e, i) {
                var n, r, o, s, a, l, c, u = un.style,
                    h = i._gsap;
                for (r in u.cssText = getComputedStyle(i).cssText + ";position:absolute;display:block;", u[Rn] = e, sn.body.appendChild(un), n = ar(un, 1), pn)(o = h[r]) !== (s = n[r]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(r) < 0 && (a = Ue(o) !== (c = Ue(s)) ? Gn(i, r, o, c) : parseFloat(o), l = parseFloat(s), t._pt = new Zi(t._pt, h, r, a, l - a, wn), t._pt.u = c || 0, t._props.push(r));
                sn.body.removeChild(un)
            };
        he("padding,margin,Width,Radius", (function(t, e) {
            var i = "Top",
                n = "Right",
                r = "Bottom",
                o = "Left",
                s = (e < 3 ? [i, n, r, o] : [i + o, i + n, r + n, r + o]).map((function(i) {
                    return e < 2 ? t + i : "border" + i + t
                }));
            tr[e > 1 ? "border" + t : t] = function(t, e, i, n, r) {
                var o, a;
                if (arguments.length < 4) return o = s.map((function(e) {
                    return $n(t, e, i)
                })), 5 === (a = o.join(" ")).split(o[0]).length ? o[0] : a;
                o = (n + "").split(" "), a = {}, s.forEach((function(t, e) {
                    return a[t] = o[e] = o[e] || o[(e - 1) / 2 | 0]
                })), t.init(e, a, r)
            }
        }));
        var gr, vr, mr = {
            name: "css",
            register: jn,
            targetTest: function(t) {
                return t.style && t.nodeType
            },
            init: function(t, e, i, n, r) {
                var o, s, a, l, c, u, h, d, f, p, g, v, m, y, _, b = this._props,
                    x = t.style,
                    w = i.vars.startAt;
                for (h in ln || jn(), e)
                    if ("autoRound" !== h && (s = e[h], !ne[h] || !Ri(h, e, i, n, t, r)))
                        if (c = typeof s, u = tr[h], "function" === c && (c = typeof(s = s.call(i, n, t, r))), "string" === c && ~s.indexOf("random(") && (s = ei(s)), u) u(this, t, h, s, i) && (_ = 1);
                        else if ("--" === h.substr(0, 2)) o = (getComputedStyle(t).getPropertyValue(h) + "").trim(), s += "", d = Ue(o), (f = Ue(s)) ? d !== f && (o = Gn(t, h, o, f) + f) : d && (s += d), this.add(x, "setProperty", o, s, n, r, 0, 0, h);
                else if ("undefined" !== c) {
                    if (w && h in w ? (o = "function" == typeof w[h] ? w[h].call(i, n, t, r) : w[h], h in xt.units && !Ue(o) && (o += xt.units[h]), "=" === (o + "").charAt(1) && (o = $n(t, h))) : o = $n(t, h), l = parseFloat(o), (p = "string" === c && "=" === s.charAt(1) ? +(s.charAt(0) + "1") : 0) && (s = s.substr(2)), a = parseFloat(s), h in xn && ("autoAlpha" === h && (1 === l && "hidden" === $n(t, "visibility") && a && (l = 0), Yn(this, x, "visibility", l ? "inherit" : "hidden", a ? "inherit" : "hidden", !a)), "scale" !== h && "transform" !== h && ~(h = xn[h]).indexOf(",") && (h = h.split(",")[0])), g = h in pn)
                        if (v || ((m = t._gsap).renderTransform && !e.parseTransform || ar(t, e.parseTransform), y = !1 !== e.smoothOrigin && m.smooth, (v = this._pt = new Zi(this._pt, x, Rn, 0, 1, m.renderTransform, m, 0, -1)).dep = 1), "scale" === h) this._pt = new Zi(this._pt, m, "scaleY", m.scaleY, p ? p * a : a - m.scaleY), b.push("scaleY", h), h += "X";
                        else {
                            if ("transformOrigin" === h) {
                                s = Jn(s), m.svg ? sr(t, s, 0, y, 0, this) : ((f = parseFloat(s.split(" ")[2]) || 0) !== m.zOrigin && Yn(this, m, "zOrigin", m.zOrigin, f), Yn(this, x, h, lr(o), lr(s)));
                                continue
                            }
                            if ("svgOrigin" === h) {
                                sr(t, s, 1, y, 0, this);
                                continue
                            }
                            if (h in ir) {
                                fr(this, m, h, l, s, p);
                                continue
                            }
                            if ("smoothOrigin" === h) {
                                Yn(this, m, "smooth", m.smooth, s);
                                continue
                            }
                            if ("force3D" === h) {
                                m[h] = s;
                                continue
                            }
                            if ("transform" === h) {
                                pr(this, s, t);
                                continue
                            }
                        }
                    else h in x || (h = Fn(h) || h);
                    if (g || (a || 0 === a) && (l || 0 === l) && !bn.test(s) && h in x) a || (a = 0), (d = (o + "").substr((l + "").length)) !== (f = Ue(s) || (h in xt.units ? xt.units[h] : d)) && (l = Gn(t, h, o, f)), this._pt = new Zi(this._pt, g ? m : x, h, l, p ? p * a : a - l, g || "px" !== f && "zIndex" !== h || !1 === e.autoRound ? wn : An), this._pt.u = f || 0, d !== f && (this._pt.b = o, this._pt.r = Sn);
                    else if (h in x) Qn.call(this, t, h, o, s);
                    else {
                        if (!(h in t)) {
                            Qt(h, s);
                            continue
                        }
                        this.add(t, h, t[h], s, n, r)
                    }
                    b.push(h)
                }
                _ && Ji(this)
            },
            get: $n,
            aliases: xn,
            getSetter: function(t, e, i) {
                var n = xn[e];
                return n && n.indexOf(",") < 0 && (e = n), e in pn && e !== qn && (t._gsap.x || $n(t, "x")) ? i && hn === i ? "scale" === e ? Pn : On : (hn = i || {}) && ("scale" === e ? Mn : Dn) : t.style && !Dt(t.style[e]) ? Ln : ~e.indexOf("-") ? En : Ui(t, e)
            },
            core: {
                _removeProperty: Xn,
                _getMatrix: or
            }
        };
        rn.utils.checkPrefix = Fn, vr = he("x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + (gr = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", (function(t) {
            pn[t] = 1
        })), he(gr, (function(t) {
            xt.units[t] = "deg", ir[t] = 1
        })), xn[vr[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + gr, he("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", (function(t) {
            var e = t.split(":");
            xn[e[1]] = vr[e[0]]
        })), he("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", (function(t) {
            xt.units[t] = "px"
        })), rn.registerPlugin(mr);
        var yr = rn.registerPlugin(mr) || rn,
            _r = (yr.core.Tween, C((function(t) {
                var e = t.node,
                    i = D(e),
                    n = i.flavorMenu,
                    r = i.flavorList,
                    o = i.flavorListContent,
                    s = i.flavorToggle,
                    a = i.pInfoSub,
                    l = i.pInfoOne,
                    c = i.pInfoOnePrice,
                    u = i.qtyAdd,
                    h = i.qtySub,
                    d = i.qtyAmnt,
                    f = i.rcOne,
                    p = i.rcSub,
                    g = i.rcFreqToggle,
                    v = i.rcFreqOp,
                    m = i.rcFreqOpItem,
                    y = i.rcFreqSelect,
                    _ = i.rcFreqList,
                    b = i.rcFreqListContent,
                    x = i.rcFreqSlot,
                    w = i.rcAutoPrice,
                    T = i.rcAutoPriceSlot,
                    S = i.ogPrice,
                    A = i.basePrice,
                    C = i.rcSave,
                    k = i.rcInfo,
                    L = i.rcWrap,
                    E = i.productTypeSelect,
                    P = i.optionRecharge,
                    R = i.optionOne,
                    q = document.querySelector(".btn-recharge--one"),
                    z = document.querySelector(".btn-recharge--sub"),
                    I = yr.timeline();
                setTimeout((function() {
                    try {
                    var t = w.innerHTML;
                    T && (T.innerHTML = t);
                    var e = parseFloat(A.innerHTML.replace(/\D/g, ""));
                    parseFloat(w.innerHTML.replace(/\D/g, ""));
                    S && (S.innerHTML = "$" + e)
                    } catch( e) {
                      console.log('doing nothing: ', e)
                    }
                }), 1e3), C && setTimeout((function() {

                    try {
                      var t;
                    t = parseFloat(A.innerHTML.replace(/\D/g, "")) - parseFloat(w.innerHTML.replace(/\D/g, "")), C.innerHTML = t
                    } catch (e) {
                      console.log('doing nothing part 2: ', e)
                    }
                    
                }), 1e3), f && O(f, "click", (function() {
                    k.style.display = "none", l && (l.style.display = "block"), a && (a.style.display = "none"), v && (v.style.display = "none"), P && (R.setAttribute("selected", "selected"), P.removeAttribute("selected")), E.dataset.type = "onetime", q.classList.add("active"), z.classList.remove("active")
                })), p && O(p, "click", (function() {
                    k.style.display = "block", l && (l.style.display = "none"), a && (a.style.display = "block"), v && (v.style.display = "block"), P && (P.setAttribute("selected", "selected"), R.removeAttribute("selected")), E.dataset.type = "recharge", q.classList.remove("active"), z.classList.add("active")
                }));
                var B = function() {
                    if (v) {
                        var t = b.getBoundingClientRect().height + 2;
                        v.classList.contains("isOpen") ? (v.classList.remove("isOpen"), I.to(_, {
                            maxHeight: 0,
                            duration: .2
                        }).to(g, {
                            borderBottomLeftRadius: "4rem",
                            borderBottomRightRadius: "4rem",
                            borderTopLeftRadius: "4rem",
                            borderTopRightRadius: "4rem",
                            duration: .2
                        })) : (v.classList.add("isOpen"), I.to(g, {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                            borderTopLeftRadius: "2rem",
                            borderTopRightRadius: "2rem",
                            duration: .2
                        }).to(_, {
                            maxHeight: t,
                            duration: .2
                        }))
                    }
                };
                g && O(g, "click", (function() {
                    B()
                })), s && O(s, "click", (function() {
                    var t = o.getBoundingClientRect().height + 2;
                    n.classList.contains("isOpen") ? (n.classList.remove("isOpen"), I.to(r, {
                        maxHeight: 0,
                        duration: .2
                    }).to(s, {
                        borderBottomLeftRadius: "4rem",
                        borderBottomRightRadius: "4rem",
                        borderTopLeftRadius: "4rem",
                        borderTopRightRadius: "4rem",
                        duration: .2
                    })) : (n.classList.add("isOpen"), I.to(s, {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        borderTopLeftRadius: "2rem",
                        borderTopRightRadius: "2rem",
                        duration: .2
                    }).to(r, {
                        maxHeight: t,
                        duration: .2
                    }))
                })), m && O(m, "click", (function(t) {
                    var e = t.target.dataset.frequency,
                        i = t.target.dataset.id;
                    y.querySelector("option[value='" + e + "']"), y.querySelector("option[value='" + e + "']");
                    B(), M(".js-sellingPlan").setAttribute("value", i), v.classList.remove("isOpen"), x.innerHTML = e
                })), u && O(u, "click", (function() {
                  
                    var t = d.value,
                        e = parseFloat(t) + 1,
                        i = L ? L.querySelectorAll(".product--price") : [];
                    d.value = e;
                  console.log('values: ', e,i,A)
                   var event = new Event("change");
                  document.querySelector(`[name="quantity"]`).dispatchEvent(event)                  
                    var n = e * parseFloat(A.innerHTML.replace(/[^\d.]/g, "")),
                        r = e * parseFloat(w.innerHTML.replace(/[^\d.]/g, ""));
                    S.innerHTML = "$" + n, c.innerHTML = "$" + n, i.forEach((function(t) {
                        t.innerHTML = "$" + n.toStrong()
                    })), T.innerHTML = "$" + r.toStrong();
                    var o = n - r;
                    C.innerHTML = o.toString()
                })), h && O(h, "click", (function() {
                    var t = d.value,
                        e = L ? L.querySelectorAll(".product--price") : [];
                    if (t > 1) var i = parseFloat(t) - 1;
                    else i = 1;
                    d.value = i;
                  var event = new Event("change");
                  document.querySelector(`[name="quantity"]`).dispatchEvent(event)
                    var n = i * parseFloat(A.innerHTML.replace(/[^\d.]/g, "")),
                        r = i * parseFloat(w.innerHTML.replace(/[^\d.]/g, ""));
                    S.innerHTML = "$" + n, c.innerHTML = "$" + n, e.forEach((function(t) {
                        t.innerHTML = "$" + n.toStrong()
                    })), T.innerHTML = "$" + r.toStrong();
                    var o = n - r;
                    C.innerHTML = o.toString()
                }))
            }))),
            br = C((function(t) {
                var e = D(t),
                    i = e.rcOne,
                    n = e.rcSub,
                    r = e.rcFreqToggle,
                    o = e.rcInfo,
                    s = e.productTypeSelect,
                    a = t.querySelector(".btn-recharge--one"),
                    l = t.querySelector(".btn-recharge--sub");
                O(i, "click", (function() {
                    P(o, "dn"), s.dataset.type = "onetime", a.classList.add("active"), l.classList.remove("active")
                    var one_price = $(this).parent('.btn-recharge--one').find('.product-single__price').attr('one-price');
                    $(this).closest('form').find('.btn-add-to-cart ins').html(one_price);
                })), O(n, "click", (function() {
                    ! function(t) {
                        for (var e = arguments.length, i = new Array(e > 1 ? e - 1 : 0), n = 1; n < e; n++) i[n - 1] = arguments[n];
                        E("remove").apply(void 0, [t].concat(i))
                    }(o, "dn"), s.dataset.type = "recharge", a.classList.remove("active"), l.classList.add("active")
                      var sub_price = $(this).parent('.btn-recharge--small').find('.rc_price__autodeliver').attr('final');
                      $(this).closest('form').find('.btn-add-to-cart ins').html(sub_price);
                })), O(r, "click", (function() {
                    toggleOptions()
                }))
            })),
            xr = C((function(t) {
                var e = t.node,
                    i = D(e),
                    n = i.rcFreqToggle,
                    r = i.rcFreqOp,
                    o = i.rcFreqOpItem,
                    s = i.rcFreqList,
                    a = i.rcFreqListContent,
                    l = i.optionRecharge,
                    c = i.optionOne,
                    u = i.freqToggleText,
                    h = i.addPrice,
                    d = yr.timeline(),
                    f = function() {
                        var t = a.getBoundingClientRect().height + 2;
                        r.classList.contains("isOpen") ? (r.classList.remove("isOpen"), d.to(s, {
                            maxHeight: 0,
                            duration: .2
                        }).to(n, {
                            borderBottomLeftRadius: "4rem",
                            borderBottomRightRadius: "4rem",
                            borderTopLeftRadius: "4rem",
                            borderTopRightRadius: "4rem",
                            duration: .2
                        })) : (r.classList.add("isOpen"), d.to(n, {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0,
                            borderTopLeftRadius: "2rem",
                            borderTopRightRadius: "2rem",
                            duration: .2
                        }).to(s, {
                            maxHeight: t,
                            duration: .2
                        }))
                    },
                    p = O(n, "click", (function() {
                        f()
                    })),
                    g = O(o, "click", (function(t) {
                        f();
                        var e = t.target.dataset.price,
                            i = t.target,
                            n = i.innerHTML;
                        h && (h.innerHTML = e), i.innerHTML.indexOf("Subscribe") > -1 ? (l.setAttribute("selected", "selected"), c.removeAttribute("selected")) : (c.setAttribute("selected", "selected"), l.removeAttribute("selected")), u.innerHTML = n
                    }));
                return function() {
                    p(), g()
                }
            })),
            wr = C((function(t) {
                var e = t.node,
                    i = D(e),
                    n = i.flavorMenu,
                    r = i.flavorList,
                    o = i.flavorListContent,
                    s = i.flavorToggle,
                    a = i.qtyAdd,
                    l = i.qtySub,
                    c = i.qtyAmnt,
                    u = i.ogPrice,
                    h = u.innerHTML.replace(/\D/g, ""),
                    d = yr.timeline();
                O(s, "click", (function() {
                    var t = o.getBoundingClientRect().height + 2;
                    n.classList.contains("isOpen") ? (n.classList.remove("isOpen"), d.to(r, {
                        maxHeight: 0,
                        duration: .2
                    }).to(s, {
                        borderBottomLeftRadius: "4rem",
                        borderBottomRightRadius: "4rem",
                        borderTopLeftRadius: "4rem",
                        borderTopRightRadius: "4rem",
                        duration: .2
                    })) : (n.classList.add("isOpen"), d.to(s, {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        borderTopLeftRadius: "2rem",
                        borderTopRightRadius: "2rem",
                        duration: .2
                    }).to(r, {
                        maxHeight: t,
                        duration: .2
                    }))
                })), O(a, "click", (function() {
                    var t = c.value,
                        e = parseFloat(t) + 1;
                    c.value = e;
                    var i = e * parseFloat(h);
                    u.innerHTML = i
                })), O(l, "click", (function() {
                    var t = c.value;
                    if (t > 1) var e = parseFloat(t) - 1;
                    else e = 1;
                    c.value = e;
                    var i = e * parseFloat(h);
                    u.innerHTML = i
                }))
            })),
            Tr = C((function(t) {
                var e = t.node,
                    i = D(e),
                    n = i.qtyAdd,
                    r = i.qtySub,
                    o = i.qtyAmnt;     
               if($("[data-template]").attr('data-template') !== 'cranberry-ginger-3'){
                O(n, "click", (function() {
                  console.log(o.value,'ooooooo')
                    var t = o.value,
                        e = parseFloat(t) + 1;
                    o.value = e
                })), O(r, "click", (function() {
                    var t = o.value;
                    if (t > 1) var e = parseFloat(t) - 1;
                    else e = 1;
                    o.value = e
                }))
               }
            })),
            Sr = i(0),
            Ar = i.n(Sr),
            Cr = C((function(t) {
                var e = D(t),
                    i = e.productCarousel,
                    n = (e.productCarouselImg, e.productCarouselNav),
                    r = (i.querySelectorAll("img")[0], document.querySelectorAll(".product-img")),
                    o = document.querySelectorAll(".js-productCarouselNavImg .product-img"),
                    s = new Ar.a(i, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        pageDots: !0,
                        wrapAround: !0,
                        lazyLoad: !0
                    }),
                    a = new Ar.a(n, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        pageDots: !1,
                        wrapAround: !1,
                        lazyLoad: !0
                    });
                   
                return s.on("change", (function(t) {
                        _(), a.select(t), o.forEach((function(e, i) {
                            i != t ? e.classList.remove("active") : e.classList.add("active")
                        }))
                    })), setTimeout((function() {
                        s.resize(), a.resize(), r.forEach((function(t) {
                            t.classList.remove("o0")
                        }))
                    }), 500), o.forEach((function(t) {
                        O(t, "click", (function(t) {
                            var e = parseInt(t.target.getAttribute("data-index"));
                            o.forEach((function(t) {
                                t.classList.remove("active")
                            })), t.target.classList.add("active"), s.select(e - 1), a.select(e - 1)
                        }))
                    })), setTimeout((function() {
                        _()
                    }), 1500),
                    function() {
                        s.destroy(), a.destroy()
                    }
            })),
            kr = C((function(t) {
                var e = new Ar.a(t, {
                    prevNextButtons: !1,
                    wrapAround: true,
                    freeScroll: !true,
                    contain: !true,
                    cellAlign: 'center'
                });
                setTimeout((function() {
                    e.resize()
                }), 500)
            })),
            Lr = C((function(t) {
                var e = D(t),
                    i = e.nutritionLabel,
                    n = e.nutritionModal,
                    r = e.ingredientClose,
                    o = e.ingredientOpen,
                    s = yr.timeline();
                O(o, "click", (function() {
                    s.to(n, {
                        autoAlpha: 1,
                        display: "block",
                        duration: .3
                    }).from(i, {
                        autoAlpha: 0,
                        y: 15,
                        duration: 1.5,
                        stagger: .1,
                        ease: fn.easeOut
                    }, "-=.15")
                })), O(r, "click", (function() {
                    yr.to(n, {
                        autoAlpha: 0,
                        display: "none",
                        duration: .3
                    })
                }))
            })),
            modalIngredientDescFunctions = C((function(t) {
                var btns = t.querySelectorAll('.js-modalIngredientDescOpen');
                var modal = document.querySelector('.modal-ingredient-id-' + t.dataset.section);
                var closeBtn = modal.querySelector('.js-modalIngredientDescClose');
                if (btns.length > 0 && closeBtn && modal) {
                    btns.forEach(elm => {
                        elm.addEventListener('click', function(evt) {
                            modal.style.display = 'block';
                            var titleContainer = modal.querySelector('#modal-info-title');
                            var itemsContainer = modal.querySelector('#modal-info-items');
                            if (this.dataset.title && titleContainer) {
                                titleContainer.textContent = this.dataset.title;
                            }
                            itemsContainer.innerHTML = '';
                            if (this.dataset.items && itemsContainer) {
                                var items = this.dataset.items.split("|");
                                var itemsHTML = '';
                                for (let index = 0; index < items.length; index++) {
                                    itemsHTML += '<li class="list-item">';
                                    itemsHTML += items[index];
                                    itemsHTML += '</li>';
                                }
                                itemsContainer.innerHTML = itemsHTML;
                            }
                        });
                        closeBtn.addEventListener('click', function(evt) {
                            modal.style.display = 'none';
                        })
                    });
                }
            })),
            newFunctions = C((function(t) {
                console.log(t);
            })),
            sliderLogo = C((function(t) {
                console.log('pc');
                const slide = tns({
                    container: '.container-press',
                    items: 1,
                    autoplay: 'true',
                    speed: 400,
                    responsive: {
                        640: {
                            items: 1
                        },
                    }
                });
            })),
            sliderBogoFunc = C((function(t) {
                var bogo_info_icon_carousel = new Swiper(".bogo-info-icon-carousel", {
                    slidesPerView: 4,
                    spaceBetween: 20,
                    loop: true,
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        769: {
                            slidesPerView: 4,
                            autoplay: {
                                enabled: false,
                            },
                        },
                        641: {
                            slidesPerView: 3,
                        },
                        481: {
                            slidesPerView: 2,
                        },
                        319: {
                            slidesPerView: 1,
                        },
                    },
                });
            })),
            filterFunction = C((function(t) {            
                let main = document.querySelector('#root');
                let menuBlur = document.querySelector('.js-header');
                let jsMenu = document.querySelector('.js-menu');
                let body = document.body;                    
                document.addEventListener('click', function() {
                    if (menuBlur.classList.contains('isOpen') || jsMenu.classList.contains('active')) {
                        main.classList.add('blur');                   
                    } else {
                        main.classList.remove('blur');
                    }
                });
                window.onresize = function() {
                    actualizarEstilos();
                };

                function actualizarEstilos() {
                    var anchura = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
                    if (anchura >= 850) {
                        main.classList.remove('blur');
                        header.classList.remove('isOpen');
                    }
                }
            })),
            sliderTns = C((function(t) {
                console.log('jl');
                tns({
                    container: '.js-carousel-marketing-duplicate',
                    items: 1,
                    controlsContainer: "#customize-controls",
                    responsive: {
                        850: {
                            items: 3,
                        }
                    }
                });
            })),
            welcomeSliderTns = C((function(t) {
                console.log('jl');
                tns({
                    container: '.js-carousel-marketing-duplicate',
                    items: 1,
                    controlsContainer: "#customize-controls",
                    responsive: {
                        850: {
                            items: 3,
                        },
                        1400: {
                            items: 5,
                        }
                    }
                });
            })),
            arrowFunctionProduct = C((function(t) {
         
                // window.PRIVE_WIDGET.PriveWidget.init()
                //console.log('This is to make prive widget run. unclear how this index.js is injected into product pages. so we put it here.', window.location.pathname)
                /*if (window.location.pathname == '/apps/customers/portal') {
                  location.reload();
                } */               
                
                let prevBtnProduct = document.querySelector('.prev');
                let nextBtnProduct = document.querySelector('.next');

                function prev() {
                    var dots = document.querySelectorAll('.productCarousel-wrap .dot');
                    let active = document.querySelector('.flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.previousElementSibling) {
                        active.previousElementSibling.classList.add('is-selected');
                    } else {
                        dots[dots.length - 1].classList.add('is-selected');
                    }
                }

                function next() {
                    var dots = document.querySelectorAll('.productCarousel-wrap .dot');
                    let active = document.querySelector('.flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.nextElementSibling) {
                        active.nextElementSibling.classList.add('is-selected');
                    } else {
                        dots[0].classList.add('is-selected');
                    }
                }
                prevBtnProduct.addEventListener('click', () => {
                    prev();
                    let active = document.querySelector('.flickity-page-dots .is-selected');
                    active.click();
                });
                nextBtnProduct.addEventListener('click', () => {
                    next();
                    let active = document.querySelector('.flickity-page-dots .is-selected');
                    active.click();
                });
            })),
            arrowFunctionProductSingle = C((function(t) {
                console.log('Product single media slider', t);
                let prevBtnProduct = document.querySelector('.prev');
                let nextBtnProduct = document.querySelector('.next');

                function prev() {
                    var dots = document.querySelectorAll('.destiny-unic .flickity-page-dots .dot');
                    let active = document.querySelector('.flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.previousElementSibling) {
                        active.previousElementSibling.classList.add('is-selected');
                    } else {
                        dots[dots.length - 1].classList.add('is-selected');
                    }
                }

                function next() {
                    var dots = document.querySelectorAll('.destiny-unic .flickity-page-dots .dot');
                    let active = document.querySelector('.destiny-unic .flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.nextElementSibling) {
                        active.nextElementSibling.classList.add('is-selected');
                    } else {
                        dots[0].classList.add('is-selected');
                    }
                }
                prevBtnProduct.addEventListener('click', () => {
                    prev();
                    let active = document.querySelector('.destiny-unic .flickity-page-dots .is-selected');
                    active.click();
                });
                nextBtnProduct.addEventListener('click', () => {
                    next();
                    let active = document.querySelector('.destiny-unic .flickity-page-dots .is-selected');
                    active.click();
                });
            })),
            arrowFuctionMarketing = C((function(t) {
                let prevBtnMarke = document.querySelector('.rel.marketing-flavors .prev');
                let nextBtnMarke = document.querySelector('.rel.marketing-flavors .next');

                function prev() {
                    var dots = document.querySelectorAll('.marketing-flavors .dot');
                    let active = document.querySelector('.marketing-flavors .flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.previousElementSibling) {
                        active.previousElementSibling.classList.add('is-selected');
                    } else {
                        dots[dots.length - 1].classList.add('is-selected');
                    }
                }

                function next() {
                    var dots = document.querySelectorAll('.marketing-flavors .dot');
                    let active = document.querySelector('.marketing-flavors .flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.nextElementSibling) {
                        active.nextElementSibling.classList.add('is-selected');
                    } else {
                        dots[0].classList.add('is-selected');
                    }
                }
                if (prevBtnMarke !== null) {
                    prevBtnMarke.addEventListener('click', () => {
                        prev();
                        let active = document.querySelector('.marketing-flavors .flickity-page-dots .is-selected');
                        active.click();
                    });
                }
                if (nextBtnMarke !== null) {
                    nextBtnMarke.addEventListener('click', () => {
                        next();
                        let active = document.querySelector('.marketing-flavors .flickity-page-dots .is-selected');
                        active.click();
                    });
                }
            })),
            arrowIngredientFunction = C((function(t) {
                const prevIngedient = document.querySelector('.ingredient .prev');
                const nextIngedient = document.querySelector('.ingredient .next');

                function prevIngedients() {
                    var dots = document.querySelectorAll('.ingredients .dot');
                    let active = document.querySelector('.ingredients .flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.previousElementSibling) {
                        active.previousElementSibling.classList.add('is-selected');
                    } else {
                        dots[dots.length - 1].classList.add('is-selected');
                    }
                }

                function nextIngedients() {
                    var dots = document.querySelectorAll('.ingredients .dot');
                    let active = document.querySelector('.ingredients .flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.nextElementSibling) {
                        active.nextElementSibling.classList.add('is-selected');
                    } else {
                        dots[0].classList.add('is-selected');
                    }
                }
                prevIngedient.addEventListener('click', () => {
                    prevIngedients();
                    let active = document.querySelector('.ingredients .flickity-page-dots .is-selected');
                    active.click();
                });
                nextIngedient.addEventListener('click', () => {
                    nextIngedients();
                    let active = document.querySelector('.ingredients .flickity-page-dots .is-selected');
                    active.click();
                });
            })),
            arrowReviewFunction = C((function(t) {
                const prevReviews = document.querySelector('.reviews .prev');
                const nextReviews = document.querySelector('.reviews .next');

                function prevReview() {
                    var dots = document.querySelectorAll('.reviews .dot');
                    let active = document.querySelector('.reviews .flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.previousElementSibling) {
                        active.previousElementSibling.classList.add('is-selected');
                    } else {
                        dots[dots.length - 1].classList.add('is-selected');
                    }
                }

                function nextReview() {
                    var dots = document.querySelectorAll('.reviews .dot');
                    let active = document.querySelector('.reviews .flickity-page-dots .is-selected');
                    active.classList.remove('is-selected');
                    if (active.nextElementSibling) {
                        active.nextElementSibling.classList.add('is-selected');
                    } else {
                        dots[0].classList.add('is-selected');
                    }
                }
                prevReviews.addEventListener('click', () => {
                    prevReview();
                    let active = document.querySelector('.reviews .flickity-page-dots .is-selected');
                    active.click();
                });
                nextReviews.addEventListener('click', () => {
                    nextReview();
                    let active = document.querySelector('.reviews .flickity-page-dots .is-selected');
                    active.click();
                });
            })),
            sliderHome = C((function(t) {
                //console.log('sliderHome length', $(".mySwiper").length);
                var swiper = new Swiper(".mySwiper", {
                    slidesPerView: 6,
                    spaceBetween: 30,
                    loop: true,
                    freeMode: true,
                    pagination: {
                        clickable: true
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 3,
                            paceBetween: 5,
                        },
                        576: {
                            spaceBetween: 10,
                            slidesPerView: 4,
                        },
                        768: {
                            slidesPerView: 5,
                        },
                        991: {
                            slidesPerView: 6,
                        },
                    },
                });
            })),
            Er = C((function(t) {
                var e = D(t),
                    i = e.rewardsModal,
                    n = e.rewardsClose,
                    r = e.rewardsOpen,
                    o = yr.timeline();
                document.documentElement.clientWidth > 850 ? O(r, "click", (function() {
                    o.to(i, {
                        autoAlpha: 1,
                        display: "block",
                        duration: .3
                    }).fromTo(".rewardItem", {
                        autoAlpha: 0,
                        x: -15
                    }, {
                        autoAlpha: 1,
                        x: 0,
                        duration: 1.5,
                        stagger: .1,
                        ease: fn.easeOut
                    }, "-=.1");
                })) : O(r, "click", (function() {
                    o.to(i, {
                        autoAlpha: 1,
                        display: "block",
                        duration: .3
                    }).fromTo(".rewardItemMobile", {
                        autoAlpha: 0,
                        x: -15
                    }, {
                        autoAlpha: 1,
                        x: 0,
                        duration: 1.5,
                        stagger: -.1,
                        ease: fn.easeOut
                    }, "-=.1")
                })), O(n, "click", (function() {
                    yr.to(i, {
                        autoAlpha: 0,
                        display: "none",
                        duration: .3
                    })
                }))
            })),
            Or = C((function(t) {
                var e = D(t).learnOpen,
                    i = document.querySelector(".js-learnClose"),
                    n = yr.timeline(),
                    r = O(e, "click", (function() {
                        n.to(".learnModal", {
                            autoAlpha: 1,
                            display: "block",
                            duration: .3
                        }).from(".learnTheanine", {
                            autoAlpha: 0,
                            x: -15,
                            duration: 1.5,
                            ease: fn.easeOut
                        }).from(".learnAshwaganda", {
                            autoAlpha: 0,
                            x: 15,
                            duration: 1.5,
                            ease: fn.easeOut
                        }, "-=1.5")
                    })),
                    o = O(i, "click", (function() {
                        yr.to(".learnModal", {
                            autoAlpha: 0,
                            display: "none",
                            duration: .3
                        })
                    }));
                return function() {
                    o(), r()
                }
            })),
            Pr = C((function(t) {
                var e = D(t).carousel;
                new Ar.a(e, {
                    cellAlign: "center",
                    contain: !0,
                    prevNextButtons: !1,
                    pageDots: !0,
                    wrapAround: !0,
                    autoPlay: 5e3
                })
            }));
        var Mr, Dr, Rr, qr, zr, Ir, Br, Fr, jr, Nr, Hr, Wr, Ur, Xr, Yr, Vr, Gr, $r, Qr, Kr, Jr, Zr, to, eo, io, no, ro, oo = C((function(t) {
                var e = D(t).slides,
                    i = fn.easeInOut,
                    n = null,
                    r = 0,
                    o = yr.timeline();

                function s(t) {
                    n = r, r = t;
                    var a = e[n],
                        l = e[r];
                    n > -1 && o.to(a, {
                        duration: 1,
                        y: -100,
                        opacity: 0,
                        ease: i
                    }), o.fromTo(l, {
                        y: 100,
                        opacity: 0
                    }, {
                        duration: 1,
                        y: 0,
                        opacity: 1,
                        ease: i,
                        onComplete: function() {
                            setTimeout((function() {
                                s(function(t, e) {
                                    return t < 0 && (t = e + t % e), t >= e ? t % e : t
                                }(r + 1, e.length))
                            }), 2e3)
                        }
                    }, "-=1")
                }
                yr.set(e, {
                    opacity: 0
                }), s(0)
            })),
            so = C((function(t) {
                var e, i = D(t),
                    n = i.toggle,
                    r = i.content,
                    o = i.body,
                    s = document.querySelectorAll(".firstContent"),
                    a = document.querySelectorAll(".firstBody");              
                  s.forEach((function(s,i) {
                          //console.log('i====',i);
                      e = s.getBoundingClientRect().height; 
                      a[i].style.maxHeight = e + "px" 
                  })),
                  //e = s.getBoundingClientRect().height, 
                  //a.style.maxHeight = e + "px", 
                  O(n, "click", (function() {                    
                    var t = r.getBoundingClientRect().height;
                    if (n.classList.contains("isOpen")) o.style.maxHeight = "0px", n.classList.remove("isOpen");
                    else {
                        var e = document.querySelectorAll(".js-body"),
                            i = document.querySelectorAll(".js-toggle");
                        e.forEach((function(t) {
                            t.style.maxHeight = "0px"
                        })), i.forEach((function(t) {
                          
                          if(t.classList.contains("isOpen")){
                            t.classList.remove("isOpen")
                          }
                        })), o.style.maxHeight = t + "px", n.classList.add("isOpen")
                    }
                }))
            })),
            ao = rn.registerPlugin(mr) || rn,
            lo = (ao.core.Tween, 1),
            co = [],
            uo = [],
            ho = Date.now,
            fo = ho(),
            po = 0,
            go = 1,
            vo = function(t) {
                return t
            },
            mo = function() {
                return "undefined" != typeof window
            },
            yo = function() {
                return Mr || mo() && (Mr = window.gsap) && Mr.registerPlugin && Mr
            },
            _o = function(t) {
                return !!~Br.indexOf(t)
            },
            bo = function(t, e) {
                return ~co.indexOf(t) && co[co.indexOf(t) + 1][e]
            },
            xo = function(t, e) {
                var i = e.s,
                    n = e.sc,
                    r = uo.indexOf(t),
                    o = n === qo.sc ? 1 : 2;
                return !~r && (r = uo.push(t) - 1), uo[r + o] || (uo[r + o] = bo(t, i) || (_o(t) ? n : function(e) {
                    return arguments.length ? t[i] = e : t[i]
                }))
            },
            wo = function(t) {
                return bo(t, "getBoundingClientRect") || (_o(t) ? function() {
                    return bs.width = Rr.innerWidth, bs.height = Rr.innerHeight, bs
                } : function() {
                    return Bo(t)
                })
            },
            To = function(t, e) {
                var i = e.s,
                    n = e.d2,
                    r = e.d,
                    o = e.a;
                return (i = "scroll" + n) && (o = bo(t, i)) ? o() - wo(t)()[r] : _o(t) ? Math.max(zr[i], Ir[i]) - (Rr["inner" + n] || zr["client" + n] || Ir["client" + n]) : t[i] - t["offset" + n]
            },
            So = function(t, e) {
                for (var i = 0; i < Jr.length; i += 3)(!e || ~e.indexOf(Jr[i + 1])) && t(Jr[i], Jr[i + 1], Jr[i + 2])
            },
            Ao = function(t) {
                return "string" == typeof t
            },
            Co = function(t) {
                return "function" == typeof t
            },
            ko = function(t) {
                return "number" == typeof t
            },
            Lo = function(t) {
                return "object" == typeof t
            },
            Eo = function(t) {
                return Co(t) && t()
            },
            Oo = function(t, e) {
                return function() {
                    var i = Eo(t),
                        n = Eo(e);
                    return function() {
                        Eo(i), Eo(n)
                    }
                }
            },
            Po = Math.abs,
            Mo = "padding",
            Do = "px",
            Ro = {
                s: "scrollLeft",
                p: "left",
                p2: "Left",
                os: "right",
                os2: "Right",
                d: "width",
                d2: "Width",
                a: "x",
                sc: function(t) {
                    return arguments.length ? Rr.scrollTo(t, qo.sc()) : Rr.pageXOffset || qr.scrollLeft || zr.scrollLeft || Ir.scrollLeft || 0
                }
            },
            qo = {
                s: "scrollTop",
                p: "top",
                p2: "Top",
                os: "bottom",
                os2: "Bottom",
                d: "height",
                d2: "Height",
                a: "y",
                op: Ro,
                sc: function(t) {
                    return arguments.length ? Rr.scrollTo(Ro.sc(), t) : Rr.pageYOffset || qr.scrollTop || zr.scrollTop || Ir.scrollTop || 0
                }
            },
            zo = function(t) {
                return Rr.getComputedStyle(t)
            },
            Io = function(t, e) {
                for (var i in e) i in t || (t[i] = e[i]);
                return t
            },
            Bo = function(t, e) {
                var i = e && "matrix(1, 0, 0, 1, 0, 0)" !== zo(t)[Gr] && Mr.to(t, {
                        x: 0,
                        y: 0,
                        xPercent: 0,
                        yPercent: 0,
                        rotation: 0,
                        rotationX: 0,
                        rotationY: 0,
                        scale: 1,
                        skewX: 0,
                        skewY: 0
                    }).progress(1),
                    n = t.getBoundingClientRect();
                return i && i.progress(0).kill(), n
            },
            Fo = function(t, e) {
                var i = e.d2;
                return t["offset" + i] || t["client" + i] || 0
            },
            jo = function(t) {
                var e, i = [],
                    n = t.labels,
                    r = t.duration();
                for (e in n) i.push(n[e] / r);
                return i
            },
            No = function(t, e, i, n) {
                return i.split(",").forEach((function(i) {
                    return t(e, i, n)
                }))
            },
            Ho = function(t, e, i) {
                return t.addEventListener(e, i, {
                    passive: !0
                })
            },
            Wo = function(t, e, i) {
                return t.removeEventListener(e, i)
            },
            Uo = {
                startColor: "green",
                endColor: "red",
                indent: 0,
                fontSize: "16px",
                fontWeight: "normal"
            },
            Xo = {
                toggleActions: "play",
                anticipatePin: 0
            },
            Yo = {
                top: 0,
                left: 0,
                center: .5,
                bottom: 1,
                right: 1
            },
            Vo = function(t, e) {
                if (Ao(t)) {
                    var i = t.indexOf("="),
                        n = ~i ? +(t.charAt(i - 1) + 1) * parseFloat(t.substr(i + 1)) : 0;
                    ~i && (t.indexOf("%") > i && (n *= e / 100), t = t.substr(0, i - 1)), t = n + (t in Yo ? Yo[t] * e : ~t.indexOf("%") ? parseFloat(t) * e / 100 : parseFloat(t) || 0)
                }
                return t
            },
            Go = function(t, e, i, n, r, o, s) {
                var a = r.startColor,
                    l = r.endColor,
                    c = r.fontSize,
                    u = r.indent,
                    h = r.fontWeight,
                    d = qr.createElement("div"),
                    f = _o(i) || "fixed" === bo(i, "pinType"),
                    p = -1 !== t.indexOf("scroller"),
                    g = f ? Ir : i,
                    v = -1 !== t.indexOf("start"),
                    m = v ? a : l,
                    y = "border-color:" + m + ";font-size:" + c + ";color:" + m + ";font-weight:" + h + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
                return y += "position:" + (p && f ? "fixed;" : "absolute;"), (p || !f) && (y += (n === qo ? "right" : "bottom") + ":" + (o + parseFloat(u)) + "px;"), s && (y += "box-sizing:border-box;text-align:left;width:" + s.offsetWidth + "px;"), d._isStart = v, d.setAttribute("class", "gsap-marker-" + t), d.style.cssText = y, d.innerText = e || 0 === e ? t + "-" + e : t, g.children[0] ? g.insertBefore(d, g.children[0]) : g.appendChild(d), d._offset = d["offset" + n.op.d2], $o(d, 0, n, v), d
            },
            $o = function(t, e, i, n) {
                var r = {
                        display: "block"
                    },
                    o = i[n ? "os2" : "p2"],
                    s = i[n ? "p2" : "os2"];
                t._isFlipped = n, r[i.a + "Percent"] = n ? -100 : 0, r[i.a] = n ? "1px" : 0, r["border" + o + "Width"] = 1, r["border" + s + "Width"] = 0, r[i.p] = e + "px", Mr.set(t, r)
            },
            Qo = [],
            Ko = {},
            Jo = function() {
                return Nr || (Nr = jr(fs))
            },
            Zo = function() {
                Nr || (Nr = jr(fs), po || ss("scrollStart"), po = ho())
            },
            ts = function() {
                return !Yr && !eo && !qr.fullscreenElement && Fr.restart(!0)
            },
            es = {},
            is = [],
            ns = [],
            rs = function(t) {
                var e, i = Mr.ticker.frame,
                    n = [],
                    r = 0;
                if (ro !== i || lo) {
                    for (cs(); r < ns.length; r += 4)(e = Rr.matchMedia(ns[r]).matches) !== ns[r + 3] && (ns[r + 3] = e, e ? n.push(r) : cs(1, ns[r]) || Co(ns[r + 2]) && ns[r + 2]());
                    for (ls(), r = 0; r < n.length; r++) e = n[r], no = ns[e], ns[e + 2] = ns[e + 1](t);
                    no = 0, Dr && us(0, 1), ro = i, ss("matchMedia")
                }
            },
            os = function t() {
                return Wo(As, "scrollEnd", t) || us(!0)
            },
            ss = function(t) {
                return es[t] && es[t].map((function(t) {
                    return t()
                })) || is
            },
            as = [],
            ls = function(t) {
                for (var e = 0; e < as.length; e += 4) t && as[e + 3] !== t || (as[e].style.cssText = as[e + 1], as[e + 2].uncache = 1)
            },
            cs = function(t, e) {
                var i;
                for ($r = 0; $r < Qo.length; $r++) i = Qo[$r], e && i.media !== e || (t ? i.kill(1) : (i.scroll.rec || (i.scroll.rec = i.scroll()), i.revert()));
                ls(e), e || ss("revert")
            },
            us = function(t, e) {
                if (!po || t) {
                    var i = ss("refreshInit");
                    for (Zr && As.sort(), e || cs(), $r = 0; $r < Qo.length; $r++) Qo[$r].refresh();
                    for (i.forEach((function(t) {
                            return t && t.render && t.render(-1)
                        })), $r = Qo.length; $r--;) Qo[$r].scroll.rec = 0;
                    Fr.pause(), ss("refresh")
                } else Ho(As, "scrollEnd", os)
            },
            hs = 0,
            ds = 1,
            fs = function() {
                var t = Qo.length,
                    e = ho(),
                    i = e - fo >= 50,
                    n = t && Qo[0].scroll();
                if (ds = hs > n ? -1 : 1, hs = n, i && (po && !Vr && e - po > 200 && (po = 0, ss("scrollEnd")), Ur = fo, fo = e), ds < 0) {
                    for ($r = t; $r--;) Qo[$r] && Qo[$r].update(0, i);
                    ds = 1
                } else
                    for ($r = 0; $r < t; $r++) Qo[$r] && Qo[$r].update(0, i);
                Nr = 0
            },
            ps = ["left", "top", "bottom", "right", "marginBottom", "marginRight", "marginTop", "marginLeft", "display", "flexShrink", "float", "zIndex"],
            gs = ps.concat(["width", "height", "boxSizing", "maxWidth", "maxHeight", "position", "margin", Mo, Mo + "Top", Mo + "Right", Mo + "Bottom", Mo + "Left"]),
            vs = function(t, e, i, n) {
                if (t.parentNode !== e) {
                    for (var r, o = ps.length, s = e.style, a = t.style; o--;) s[r = ps[o]] = i[r];
                    s.position = "absolute" === i.position ? "absolute" : "relative", "inline" === i.display && (s.display = "inline-block"), a.bottom = a.right = "auto", s.overflow = "visible", s.boxSizing = "border-box", s.width = Fo(t, Ro) + Do, s.height = Fo(t, qo) + Do, s[Mo] = a.margin = a.top = a.left = "0", ys(n), a.width = a.maxWidth = i.width, a.height = a.maxHeight = i.height, a[Mo] = i[Mo], t.parentNode.insertBefore(e, t), e.appendChild(t)
                }
            },
            ms = /([A-Z])/g,
            ys = function(t) {
                if (t) {
                    var e, i, n = t.t.style,
                        r = t.length,
                        o = 0;
                    for ((t.t._gsap || Mr.core.getCache(t.t)).uncache = 1; o < r; o += 2) i = t[o + 1], e = t[o], i ? n[e] = i : n[e] && n.removeProperty(e.replace(ms, "-$1").toLowerCase())
                }
            },
            _s = function(t) {
                for (var e = gs.length, i = t.style, n = [], r = 0; r < e; r++) n.push(gs[r], i[gs[r]]);
                return n.t = t, n
            },
            bs = {
                left: 0,
                top: 0
            },
            xs = function(t, e, i, n, r, o, s, a, l, c, u, h) {
                if (Co(t) && (t = t(a)), Ao(t) && "max" === t.substr(0, 3) && (t = h + ("=" === t.charAt(4) ? Vo("0" + t.substr(3), i) : 0)), ko(t)) s && $o(s, i, n, !0);
                else {
                    Co(e) && (e = e(a));
                    var d, f, p, g = Hr(e)[0] || Ir,
                        v = Bo(g) || {},
                        m = t.split(" ");
                    v && (v.left || v.top) || "none" !== zo(g).display || (p = g.style.display, g.style.display = "block", v = Bo(g), p ? g.style.display = p : g.style.removeProperty("display")), d = Vo(m[0], v[n.d]), f = Vo(m[1] || "0", i), t = v[n.p] - l[n.p] - c + d + r - f, s && $o(s, f, n, i - f < 20 || s._isStart && f > 20), i -= i - f
                }
                if (o) {
                    var y = t + i,
                        _ = o._isStart;
                    h = "scroll" + n.d2, $o(o, y, n, _ && y > 20 || !_ && (u ? Math.max(Ir[h], zr[h]) : o.parentNode[h]) <= y + 1), u && (l = Bo(s), u && (o.style[n.op.p] = l[n.op.p] - n.op.m - o._offset + Do))
                }
                return Math.round(t)
            },
            ws = /(?:webkit|moz|length|cssText|inset)/i,
            Ts = function(t, e, i, n) {
                if (t.parentNode !== e) {
                    var r, o, s = t.style;
                    if (e === Ir) {
                        for (r in t._stOrig = s.cssText, o = zo(t)) + r || ws.test(r) || !o[r] || "string" != typeof s[r] || "0" === r || (s[r] = o[r]);
                        s.top = i, s.left = n
                    } else s.cssText = t._stOrig;
                    Mr.core.getCache(t).uncache = 1, e.appendChild(t)
                }
            },
            Ss = function(t, e) {
                var i, n, r = xo(t, e),
                    o = "_scroll" + e.p2,
                    s = function e(s, a, l, c, u) {
                        var h = e.tween,
                            d = a.onComplete,
                            f = {};
                        return h && h.kill(), i = Math.round(l), a[o] = s, a.modifiers = f, f[o] = function(t) {
                            return (t = Math.round(r())) !== i && t !== n && Math.abs(t - i) > 2 ? (h.kill(), e.tween = 0) : t = l + c * h.ratio + u * h.ratio * h.ratio, n = i, i = Math.round(t)
                        }, a.onComplete = function() {
                            e.tween = 0, d && d.call(h)
                        }, h = e.tween = Mr.to(t, a)
                    };
                return t[o] = r, t.addEventListener("mousewheel", (function() {
                    return s.tween && s.tween.kill() && (s.tween = 0)
                })), s
            };
        Ro.op = qo;
        var As = function() {
            function t(e, i) {
                Dr || t.register(Mr) || console.warn("Please gsap.registerPlugin(ScrollTrigger)"), this.init(e, i)
            }
            return t.prototype.init = function(e, i) {
                if (this.progress = this.start = 0, this.vars && this.kill(1), go) {
                    var n, r, o, s, a, l, c, u, h, d, f, p, g, v, m, y, _, b, x, w, T, S, A, C, k, L, E, O, P, M, D, R, q, z, I, B, F, j, N, H = (e = Io(Ao(e) || ko(e) || e.nodeType ? {
                            trigger: e
                        } : e, Xo)).horizontal ? Ro : qo,
                        W = e,
                        U = W.onUpdate,
                        X = W.toggleClass,
                        Y = W.id,
                        V = W.onToggle,
                        G = W.onRefresh,
                        $ = W.scrub,
                        Q = W.trigger,
                        K = W.pin,
                        J = W.pinSpacing,
                        Z = W.invalidateOnRefresh,
                        tt = W.anticipatePin,
                        et = W.onScrubComplete,
                        it = W.onSnapComplete,
                        nt = W.once,
                        rt = W.snap,
                        ot = W.pinReparent,
                        st = !$ && 0 !== $,
                        at = Hr(e.scroller || Rr)[0],
                        lt = Mr.core.getCache(at),
                        ct = _o(at),
                        ut = "pinType" in e ? "fixed" === e.pinType : ct || "fixed" === bo(at, "pinType"),
                        ht = [e.onEnter, e.onLeave, e.onEnterBack, e.onLeaveBack],
                        dt = st && e.toggleActions.split(" "),
                        ft = "markers" in e ? e.markers : Xo.markers,
                        pt = ct ? 0 : parseFloat(zo(at)["border" + H.p2 + "Width"]) || 0,
                        gt = this,
                        vt = e.onRefreshInit && function() {
                            return e.onRefreshInit(gt)
                        },
                        mt = function(t, e, i) {
                            var n = i.d,
                                r = i.d2,
                                o = i.a;
                            return (o = bo(t, "getBoundingClientRect")) ? function() {
                                return o()[n]
                            } : function() {
                                return (e ? Rr["inner" + r] : t["client" + r]) || 0
                            }
                        }(at, ct, H),
                        yt = function(t, e) {
                            return !e || ~co.indexOf(t) ? wo(t) : function() {
                                return bs
                            }
                        }(at, ct);
                    gt.media = no, tt *= 45, Qo.push(gt), gt.scroller = at, gt.scroll = xo(at, H), a = gt.scroll(), gt.vars = e, i = i || e.animation, "refreshPriority" in e && (Zr = 1), lt.tweenScroll = lt.tweenScroll || {
                        top: Ss(at, qo),
                        left: Ss(at, Ro)
                    }, gt.tweenTo = n = lt.tweenScroll[H.p], i && (i.vars.lazy = !1, i._initted || !1 !== i.vars.immediateRender && !1 !== e.immediateRender && i.render(0, !0, !0), gt.animation = i.pause(), i.scrollTrigger = gt, (R = ko($) && $) && (D = Mr.to(i, {
                        ease: "power3",
                        duration: R,
                        onComplete: function() {
                            return et && et(gt)
                        }
                    })), P = 0, Y || (Y = i.vars.id)), rt && (Lo(rt) || (rt = {
                        snapTo: rt
                    }), "scrollBehavior" in Ir.style && Mr.set(ct ? [Ir, zr] : at, {
                        scrollBehavior: "auto"
                    }), o = Co(rt.snapTo) ? rt.snapTo : "labels" === rt.snapTo ? function(t) {
                        return function(e) {
                            return Mr.utils.snap(jo(t), e)
                        }
                    }(i) : "labelsDirectional" === rt.snapTo ? (j = i, function(t, e) {
                        var i, n = jo(j);
                        if (n.sort((function(t, e) {
                                return t - e
                            })), e.direction > 0) {
                            for (i = 0; i < n.length; i++)
                                if (n[i] >= t) return n[i];
                            return n.pop()
                        }
                        for (i = n.length; i--;)
                            if (n[i] <= t) return n[i];
                        return n[0]
                    }) : Mr.utils.snap(rt.snapTo), q = rt.duration || {
                        min: .1,
                        max: 2
                    }, q = Lo(q) ? Wr(q.min, q.max) : Wr(q, q), z = Mr.delayedCall(rt.delay || R / 2 || .1, (function() {
                        if (Math.abs(gt.getVelocity()) < 10 && !Vr) {
                            var t = i && !st ? i.totalProgress() : gt.progress,
                                e = (t - M) / (ho() - Ur) * 1e3 || 0,
                                r = Po(e / 2) * e / .185,
                                s = t + r,
                                a = Wr(0, 1, o(s, gt)),
                                l = gt.scroll(),
                                h = Math.round(c + a * v),
                                d = n.tween;
                            if (l <= u && l >= c && h !== l) {
                                if (d && !d._initted && d.data <= Math.abs(h - l)) return;
                                n(h, {
                                    duration: q(Po(.185 * Math.max(Po(s - t), Po(a - t)) / e / .05 || 0)),
                                    ease: rt.ease || "power3",
                                    data: Math.abs(h - l),
                                    onComplete: function() {
                                        P = M = i && !st ? i.totalProgress() : gt.progress, it && it(gt)
                                    }
                                }, l, r * v, h - l - r * v)
                            }
                        } else gt.isActive && z.restart(!0)
                    })).pause()), Y && (Ko[Y] = gt), Q = gt.trigger = Hr(Q || K)[0], K = !0 === K ? Q : Hr(K)[0], Ao(X) && (X = {
                        targets: Q,
                        className: X
                    }), K && (!1 === J || "margin" === J || (J = !(!J && "flex" === zo(K.parentNode).display) && Mo), gt.pin = K, !1 !== e.force3D && Mr.set(K, {
                        force3D: !0
                    }), (r = Mr.core.getCache(K)).spacer ? m = r.pinState : (r.spacer = b = qr.createElement("div"), b.setAttribute("class", "pin-spacer" + (Y ? " pin-spacer-" + Y : "")), r.pinState = m = _s(K)), gt.spacer = b = r.spacer, O = zo(K), C = O[J + H.os2], w = Mr.getProperty(K), T = Mr.quickSetter(K, H.a, Do), vs(K, b, O), _ = _s(K)), ft && (g = Lo(ft) ? Io(ft, Uo) : Uo, f = Go("scroller-start", Y, at, H, g, 0), p = Go("scroller-end", Y, at, H, g, 0, f), x = f["offset" + H.op.d2], h = Go("start", Y, at, H, g, x), d = Go("end", Y, at, H, g, x), ut || ((N = ct ? Ir : at).style.position = "absolute" === zo(N).position ? "absolute" : "relative", Mr.set([f, p], {
                        force3D: !0
                    }), L = Mr.quickSetter(f, H.a, Do), E = Mr.quickSetter(p, H.a, Do))), gt.revert = function(t) {
                        var e = !1 !== t || !gt.enabled,
                            n = Yr;
                        e !== s && (e && (B = Math.max(gt.scroll(), gt.scroll.rec || 0), I = gt.progress, F = i && i.progress()), h && [h, d, f, p].forEach((function(t) {
                            return t.style.display = e ? "none" : "block"
                        })), e && (Yr = 1), gt.update(e), Yr = n, K && (e ? function(t, e, i) {
                            if (ys(i), t.parentNode === e) {
                                var n = e.parentNode;
                                n && (n.insertBefore(t, e), n.removeChild(e))
                            }
                        }(K, b, m) : (!ot || !gt.isActive) && vs(K, b, zo(K), k)), s = e)
                    }, gt.refresh = function(n) {
                        if (!Yr && gt.enabled)
                            if (K && n && po) Ho(t, "scrollEnd", os);
                            else {
                                Yr = 1, D && D.pause(), Z && i && i.progress(0).invalidate(), s || gt.revert();
                                for (var r, o, g, x, T, C, L, E, O, P = mt(), M = yt(), R = To(at, H), q = 0, z = 0, j = e.end, N = e.endTrigger || Q, W = e.start || (0 !== e.start && Q ? K ? "0 0" : "0 100%" : 0), U = Q && Math.max(0, Qo.indexOf(gt)) || 0, X = U; X--;)(L = Qo[X].pin) && (L === Q || L === K) && Qo[X].revert();
                                for (c = xs(W, Q, P, H, gt.scroll(), h, f, gt, M, pt, ut, R) || (K ? -.001 : 0), Co(j) && (j = j(gt)), Ao(j) && !j.indexOf("+=") && (~j.indexOf(" ") ? j = (Ao(W) ? W.split(" ")[0] : "") + j : (q = Vo(j.substr(2), P), j = Ao(W) ? W : c + q, N = Q)), u = Math.max(c, xs(j || (N ? "100% 0" : R), N, P, H, gt.scroll() + q, d, p, gt, M, pt, ut, R)) || -.001, v = u - c || (c -= .01) && .001, q = 0, X = U; X--;)(L = (C = Qo[X]).pin) && C.start - C._pinPush < c && (r = C.end - C.start, L === Q && (q += r), L === K && (z += r));
                                if (c += q, u += q, gt._pinPush = z, h && q && ((r = {})[H.a] = "+=" + q, Mr.set([h, d], r)), K) r = zo(K), x = H === qo, g = gt.scroll(), S = parseFloat(w(H.a)) + z, !R && u > 1 && ((ct ? Ir : at).style["overflow-" + H.a] = "scroll"), vs(K, b, r), _ = _s(K), o = Bo(K, !0), E = ut && xo(at, x ? Ro : qo)(), J && ((k = [J + H.os2, v + z + Do]).t = b, (X = J === Mo ? Fo(K, H) + v + z : 0) && k.push(H.d, X + Do), ys(k), ut && gt.scroll(B)), ut && ((T = {
                                    top: o.top + (x ? g - c : E) + Do,
                                    left: o.left + (x ? E : g - c) + Do,
                                    boxSizing: "border-box",
                                    position: "fixed"
                                }).width = T.maxWidth = Math.ceil(o.width) + Do, T.height = T.maxHeight = Math.ceil(o.height) + Do, T.margin = T.marginTop = T.marginRight = T.marginBottom = T.marginLeft = "0", T[Mo] = r[Mo], T[Mo + "Top"] = r[Mo + "Top"], T[Mo + "Right"] = r[Mo + "Right"], T[Mo + "Bottom"] = r[Mo + "Bottom"], T[Mo + "Left"] = r[Mo + "Left"], y = function(t, e, i) {
                                    for (var n, r = [], o = t.length, s = i ? 8 : 0; s < o; s += 2) n = t[s], r.push(n, n in e ? e[n] : t[s + 1]);
                                    return r.t = t.t, r
                                }(m, T, ot)), i ? (O = i._initted, to(1), i.progress(1, !0), A = w(H.a) - S + v + z, v !== A && y.splice(y.length - 2, 2), i.progress(0, !0), O || i.invalidate(), to(0)) : A = v;
                                else if (Q && gt.scroll())
                                    for (o = Q.parentNode; o && o !== Ir;) o._pinOffset && (c -= o._pinOffset, u -= o._pinOffset), o = o.parentNode;
                                for (X = 0; X < U; X++)(C = Qo[X].pin) && (C === Q || C === K) && Qo[X].revert(!1);
                                gt.start = c, gt.end = u, (a = l = gt.scroll()) < B && gt.scroll(B), gt.revert(!1), Yr = 0, i && st && i._initted && i.progress(F, !0).render(i.time(), !0, !0), I !== gt.progress && (D && i.totalProgress(I, !0), gt.progress = I, gt.update()), K && J && (b._pinOffset = Math.round(gt.progress * A)), G && G(gt)
                            }
                    }, gt.getVelocity = function() {
                        return (gt.scroll() - l) / (ho() - Ur) * 1e3 || 0
                    }, gt.update = function(t, e) {
                        var r, o, s, h, d, p = gt.scroll(),
                            g = t ? 0 : (p - c) / v,
                            m = g < 0 ? 0 : g > 1 ? 1 : g || 0,
                            x = gt.progress;
                        if (e && (l = a, a = p, rt && (M = P, P = i && !st ? i.totalProgress() : m)), tt && !m && K && !Yr && !lo && po && c < p + (p - l) / (ho() - Ur) * tt && (m = 1e-4), m !== x && gt.enabled) {
                            if (h = (d = (r = gt.isActive = !!m && m < 1) !== (!!x && x < 1)) || !!m != !!x, gt.direction = m > x ? 1 : -1, gt.progress = m, st || (!D || Yr || lo ? i && i.totalProgress(m, !!Yr) : (D.vars.totalProgress = m, D.invalidate().restart())), K)
                                if (t && J && (b.style[J + H.os2] = C), ut) {
                                    if (h) {
                                        if (s = !t && m > x && u + 1 > p && p + 1 >= To(at, H), ot)
                                            if (t || !r && !s) Ts(K, b);
                                            else {
                                                var w = Bo(K, !0),
                                                    k = p - c;
                                                Ts(K, Ir, w.top + (H === qo ? k : 0) + Do, w.left + (H === qo ? 0 : k) + Do)
                                            }
                                        ys(r || s ? y : _), A !== v && m < 1 && r || T(S + (1 !== m || s ? 0 : A))
                                    }
                                } else T(S + A * m);
                            rt && !n.tween && !Yr && !lo && z.restart(!0), X && (d || nt && m && (m < 1 || !io)) && Hr(X.targets).forEach((function(t) {
                                return t.classList[r || nt ? "add" : "remove"](X.className)
                            })), U && !st && !t && U(gt), h && !Yr ? (o = m && !x ? 0 : 1 === m ? 1 : 1 === x ? 2 : 3, st && (s = !d && "none" !== dt[o + 1] && dt[o + 1] || dt[o], i && ("complete" === s || "reset" === s || s in i) && ("complete" === s ? i.pause().totalProgress(1) : "reset" === s ? i.restart(!0).pause() : i[s]()), U && U(gt)), !d && io || (V && d && V(gt), ht[o] && ht[o](gt), nt && (1 === m ? gt.kill(!1, 1) : ht[o] = 0), d || ht[o = 1 === m ? 1 : 3] && ht[o](gt))) : st && U && !Yr && U(gt)
                        }
                        E && (L(p + (f._isFlipped ? 1 : 0)), E(p))
                    }, gt.enable = function() {
                        gt.enabled || (gt.enabled = !0, Ho(at, "resize", ts), Ho(at, "scroll", Zo), vt && Ho(t, "refreshInit", vt), i && i.add ? Mr.delayedCall(.01, (function() {
                            return c || u || gt.refresh()
                        })) && (v = .01) && (c = u = 0) : gt.refresh())
                    }, gt.disable = function(e, i) {
                        if (gt.enabled && (!1 !== e && gt.revert(), gt.enabled = gt.isActive = !1, i || D && D.pause(), B = 0, r && (r.uncache = 1), vt && Wo(t, "refreshInit", vt), z && (z.pause(), n.tween && n.tween.kill() && (n.tween = 0)), !ct)) {
                            for (var o = Qo.length; o--;)
                                if (Qo[o].scroller === at && Qo[o] !== gt) return;
                            Wo(at, "resize", ts), Wo(at, "scroll", Zo)
                        }
                    }, gt.kill = function(t, e) {
                        gt.disable(t, e), Y && delete Ko[Y];
                        var n = Qo.indexOf(gt);
                        Qo.splice(n, 1), n === $r && ds > 0 && $r--, i && (i.scrollTrigger = null, t && i.render(-1), e || i.kill()), h && [h, d, f, p].forEach((function(t) {
                            return t.parentNode.removeChild(t)
                        })), K && (r && (r.uncache = 1), n = 0, Qo.forEach((function(t) {
                            return t.pin === K && n++
                        })), n || (r.spacer = 0))
                    }, gt.enable()
                } else this.update = this.refresh = this.kill = vo
            }, t.register = function(e) {
                if (!Dr && (Mr = e || yo(), mo() && window.document && (Rr = window, qr = document, zr = qr.documentElement, Ir = qr.body), Mr && (Hr = Mr.utils.toArray, Wr = Mr.utils.clamp, to = Mr.core.suppressOverwrites || vo, Mr.core.globals("ScrollTrigger", t), Ir))) {
                    jr = Rr.requestAnimationFrame || function(t) {
                        return setTimeout(t, 16)
                    }, Ho(Rr, "mousewheel", Zo), Br = [Rr, qr, zr, Ir], Ho(qr, "scroll", Zo);
                    var i, n = Ir.style,
                        r = n.borderTop;
                    n.borderTop = "1px solid #000", i = Bo(Ir), qo.m = Math.round(i.top + qo.sc()) || 0, Ro.m = Math.round(i.left + Ro.sc()) || 0, r ? n.borderTop = r : n.removeProperty("border-top"), Xr = setInterval(Jo, 200), Mr.delayedCall(.5, (function() {
                        return lo = 0
                    })), Ho(qr, "touchcancel", vo), Ho(Ir, "touchstart", vo), No(Ho, qr, "pointerdown,touchstart,mousedown", (function() {
                        return Vr = 1
                    })), No(Ho, qr, "pointerup,touchend,mouseup", (function() {
                        return Vr = 0
                    })), Gr = Mr.utils.checkPrefix("transform"), gs.push(Gr), Dr = ho(), Fr = Mr.delayedCall(.2, us).pause(), Jr = [qr, "visibilitychange", function() {
                        var t = Rr.innerWidth,
                            e = Rr.innerHeight;
                        qr.hidden ? (Qr = t, Kr = e) : Qr === t && Kr === e || ts()
                    }, qr, "DOMContentLoaded", us, Rr, "load", function() {
                        return po || us()
                    }, Rr, "resize", ts], So(Ho)
                }
                return Dr
            }, t.defaults = function(t) {
                for (var e in t) Xo[e] = t[e]
            }, t.kill = function() {
                go = 0, Qo.slice(0).forEach((function(t) {
                    return t.kill(1)
                }))
            }, t.config = function(t) {
                "limitCallbacks" in t && (io = !!t.limitCallbacks);
                var e = t.syncInterval;
                e && clearInterval(Xr) || (Xr = e) && setInterval(Jo, e), "autoRefreshEvents" in t && (So(Wo) || So(Ho, t.autoRefreshEvents || "none"), eo = -1 === (t.autoRefreshEvents + "").indexOf("resize"))
            }, t.scrollerProxy = function(t, e) {
                var i = Hr(t)[0],
                    n = uo.indexOf(i),
                    r = _o(i);
                ~n && uo.splice(n, r ? 6 : 2), r ? co.unshift(Rr, e, Ir, e, zr, e) : co.unshift(i, e)
            }, t.matchMedia = function(t) {
                var e, i, n, r, o;
                for (i in t) n = ns.indexOf(i), r = t[i], no = i, "all" === i ? r() : (e = Rr.matchMedia(i)) && (e.matches && (o = r()), ~n ? (ns[n + 1] = Oo(ns[n + 1], r), ns[n + 2] = Oo(ns[n + 2], o)) : (n = ns.length, ns.push(i, r, o), e.addListener ? e.addListener(rs) : e.addEventListener("change", rs)), ns[n + 3] = e.matches), no = 0;
                return ns
            }, t.clearMatchMedia = function(t) {
                t || (ns.length = 0), (t = ns.indexOf(t)) >= 0 && ns.splice(t, 4)
            }, t
        }();
        As.version = "3.6.0", As.saveStyles = function(t) {
            return t ? Hr(t).forEach((function(t) {
                if (t && t.style) {
                    var e = as.indexOf(t);
                    e >= 0 && as.splice(e, 4), as.push(t, t.style.cssText, Mr.core.getCache(t), no)
                }
            })) : as
        }, As.revert = function(t, e) {
            return cs(!t, e)
        }, As.create = function(t, e) {
            return new As(t, e)
        }, As.refresh = function(t) {
            return t ? ts() : us(!0)
        }, As.update = fs, As.maxScroll = function(t, e) {
            return To(t, e ? Ro : qo)
        }, As.getScrollFunc = function(t, e) {
            return xo(Hr(t)[0], e ? Ro : qo)
        }, As.getById = function(t) {
            return Ko[t]
        }, As.getAll = function() {
            return Qo.slice(0)
        }, As.isScrolling = function() {
            return !!po
        }, As.addEventListener = function(t, e) {
            var i = es[t] || (es[t] = []);
            ~i.indexOf(e) || i.push(e)
        }, As.removeEventListener = function(t, e) {
            var i = es[t],
                n = i && i.indexOf(e);
            n >= 0 && i.splice(n, 1)
        }, As.batch = function(t, e) {
            var i, n = [],
                r = {},
                o = e.interval || .016,
                s = e.batchMax || 1e9,
                a = function(t, e) {
                    var i = [],
                        n = [],
                        r = Mr.delayedCall(o, (function() {
                            e(i, n), i = [], n = []
                        })).pause();
                    return function(t) {
                        i.length || r.restart(!0), i.push(t.trigger), n.push(t), s <= i.length && r.progress(1)
                    }
                };
            for (i in e) r[i] = "on" === i.substr(0, 2) && Co(e[i]) && "onRefreshInit" !== i ? a(0, e[i]) : e[i];
            return Co(s) && (s = s(), Ho(As, "refresh", (function() {
                return s = e.batchMax()
            }))), Hr(t).forEach((function(t) {
                var e = {};
                for (i in r) e[i] = r[i];
                e.trigger = t, n.push(As.create(e))
            })), n
        }, As.sort = function(t) {
            return Qo.sort(t || function(t, e) {
                return -1e6 * (t.vars.refreshPriority || 0) + t.start - (e.start + -1e6 * (e.vars.refreshPriority || 0))
            })
        }, yo() && Mr.registerPlugin(As);
        var Cs = C((function(t, e) {
                var i = D(t),
                    n = i.aboutSection,
                    r = i.aboutTitle,
                    o = i.aboutMask,
                    s = (i.aboutBlur, i.aboutImage, document.querySelectorAll(".image-about").length, function() {
                        ao.set(".image-about", {
                            autoAlpha: 0
                        }), ao.set(".js-aboutImage0", {
                            autoAlpha: 1
                        }), ao.utils.toArray(n).forEach((function(t, e) {
                            var i = ao.timeline(),
                                n = document.querySelector(".js-aboutBody" + (e + 1)),
                                r = document.querySelector(".js-aboutImage" + (e + 1));
                            As.create({
                                trigger: t,
                                start: "top 50%",
                                end: "bottom 50%",
                                animation: i,
                                toggleActions: "play reverse play reverse"
                            }), i.fromTo(n, {
                                autoAlpha: 0,
                                y: -30
                            }, {
                                duration: .3,
                                autoAlpha: 1,
                                y: 0,
                                ease: fn.easeOut
                            }, 0).fromTo(r, {
                                autoAlpha: 0
                            }, {
                                autoAlpha: 1,
                                duration: .3
                            }, 0)
                        })), As.create({
                            trigger: "#shopify-section-footer",
                            start: "top bottom+=100",
                            onEnter: function() {
                                r.classList.add("o0"), o.classList.add("o0")
                            },
                            onLeaveBack: function() {
                                r.classList.remove("o0"), o.classList.remove("o0")
                            }
                        }), document.querySelectorAll("img").forEach((function(t) {
                            t.onload = function() {
                                As.refresh(), t.onload = null
                            }
                        })), e.hydrate({
                            trigger: "active"
                        })
                    }),
                    a = function() {
                        var t = ao.timeline();
                        As.create({
                            trigger: "#shopify-section-footer",
                            start: "top bottom+=100",
                            onEnter: function() {
                                r.classList.add("o0"), o.classList.add("o0"), t.to(".image-bg-multi", {
                                    opacity: 0,
                                    duration: .3
                                }).to(".image-blur-multi", {
                                    opacity: 0,
                                    duration: .3
                                }, 0)
                            },
                            onLeaveBack: function() {
                                r.classList.remove("o0"), o.classList.remove("o0"), t.to(".image-bg-multi", {
                                    opacity: 1,
                                    duration: .3
                                }).to(".image-blur-multi", {
                                    opacity: 1,
                                    duration: .3
                                }, 0)
                            }
                        })
                    };
                a(), document.documentElement.clientWidth > 850 && s(), O(window, "resize", (function() {
                    (document.documentElement.clientWidth > 850 && "active" != e.getState().trigger && (s(), a()), document.documentElement.clientWidth < 850 && "active" == e.getState().trigger) && (As.getAll().forEach((function(t) {
                        t.kill()
                    })), a(), ao.set(".about-body", {
                        autoAlpha: 1,
                        y: 0
                    }), ao.set(".image-about", {
                        autoAlpha: 1
                    }), e.hydrate({
                        trigger: "inactive"
                    }))
                }))
            })),
             ks = C((function(t) {
                var e = D(t),
                    i = e.menu,
                    n = e.menuClose,
                    r = e.menuOpen,
                    o = e.menuLink,
                    s = (e.subNav, function(t, e) {
                        return void 0 === e && (e = document), [].slice.call(e.querySelectorAll(t))
                    }(".js-subNav"));
                O(n, "click", (function() {
                    document.getElementById('shopify-section-footer').classList.remove('blur'), t.classList.remove("isOpen"), i.classList.add("pen")
                })), O(r, "click", (function() {
                    document.getElementById('shopify-section-footer').classList.add('blur'), t.classList.add("isOpen"), i.classList.remove("pen")
                })), 
                O(o, "click", (function(e) {
                      console.log(e.target,'submenuuuu');
                      if(!e.target.classList.contains("sub-menu")){                     
                        t.classList.remove("isOpen"), i.classList.add("pen")
                      }
                })),
               s.length > 0 && s.forEach((function(t) {
                    O(t, "mouseleave", (function() {
                        t.classList.contains("isOpen") && t.classList.remove("isOpen")
                    })), O(t, "mouseenter", (function() {
                        t.classList.contains("isOpen") || t.classList.add("isOpen")
                    }))
                }))
            })),
            Ls = C((function(t) {
                $(t).on("click", (function(t) {
                    if (t.target.hasAttribute("data-disable-recharge")) console.info("ReCharge disabled");
                    else {
                        t.preventDefault();
                        var e = "&cart_token=" + (document.cookie.match("(^|; )cart=([^;]*)") || 0)[2];
                        $.ajax({
                            type: "GET",
                            url: "/cart.js",
                            dataType: "text",
                            success: function(t) {
                                if (t.indexOf("shipping_interval_frequency") > -1) {
                                    try {
                                        var i = "&" + ga.getAll()[0].get("linkerParam")
                                    } catch (t) {
                                        i = ""
                                    }
                                    console.log('hola mundooooooooooooooooooooooooooooooooooooooo');
                                    window.location = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=moment-drink-your-meditation.myshopify.com" + e + i
                                } else window.location = "/checkout"
                            }
                        })
                    }
                }))
            })),
            Es = C((function(t) {
                D(t).noList;
                ao.timeline({
                    scrollTrigger: {
                        trigger: t,
                        start: "top center"
                    }
                }).to(".noStrike", {
                    scaleX: 1,
                    duration: 1,
                    ease: fn.easeInOut,
                    stagger: .35
                }), document.querySelectorAll("img").forEach((function(t) {
                    t.onload = function() {
                        As.refresh(), t.onload = null
                    }
                }))
            })),
            Os = C((function(t) {
                document.documentElement.clientWidth > 850 ? As.create({
                    trigger: t,
                    start: "top top",
                    end: "bottom center+=200",
                    onUpdate: function(t) {
                        var e = t.progress;
                        e < .2 ? (ao.set(".sequence-hero", {
                            opacity: 0
                        }), ao.set(".hero1", {
                            opacity: 1
                        })) : e > .2 && e < .4 ? (ao.set(".sequence-hero", {
                            opacity: 0
                        }), ao.set(".hero2", {
                            opacity: 1
                        })) : e > .4 && e < .6 ? (ao.set(".sequence-hero", {
                            opacity: 0
                        }), ao.set(".hero3", {
                            opacity: 1
                        })) : e > .6 && e < .8 ? (ao.set(".sequence-hero", {
                            opacity: 0
                        }), ao.set(".hero4", {
                            opacity: 1
                        })) : (ao.set(".sequence-hero", {
                            opacity: 0
                        }), ao.set(".hero5", {
                            opacity: 1
                        }))
                    }
                }) : As.create({
                    trigger: t,
                    start: "top top",
                    end: "bottom center+=200",
                    onUpdate: function(t) {
                        var e = t.progress;
                        e < .33 ? (ao.set(".sequence-hero", {
                            opacity: 0
                        }), ao.set(".hero1", {
                            opacity: 1
                        })) : e > .33 && e < .66 ? (ao.set(".sequence-hero", {
                            opacity: 0
                        }), ao.set(".hero3", {
                            opacity: 1
                        })) : (ao.set(".sequence-hero", {
                            opacity: 0
                        }), ao.set(".hero5", {
                            opacity: 1
                        }))
                    }
                })
            })),
            Ps = C((function(t) {
                document.documentElement.clientWidth > 850 ? As.create({
                    trigger: t,
                    start: "top bottom-=200",
                    end: "bottom bottom",
                    onUpdate: function(t) {
                        var e = t.progress;
                        e < .33 ? (ao.set(".sequence-learn", {
                            opacity: 0
                        }), ao.set(".learn1", {
                            opacity: 1
                        })) : e > .33 && e < .66 ? (ao.set(".sequence-learn", {
                            opacity: 0
                        }), ao.set(".learn2", {
                            opacity: 1
                        })) : (ao.set(".sequence-learn", {
                            opacity: 0
                        }), ao.set(".learn3", {
                            opacity: 1
                        }))
                    }
                }) : As.create({
                    trigger: t,
                    start: "top center",
                    end: "bottom center",
                    onUpdate: function(t) {
                        var e = t.progress;
                        e < .33 ? (ao.set(".sequence-learn", {
                            opacity: 0
                        }), ao.set(".learn1", {
                            opacity: 1
                        })) : e > .33 && e < .66 ? (ao.set(".sequence-learn", {
                            opacity: 0
                        }), ao.set(".learn2", {
                            opacity: 1
                        })) : (ao.set(".sequence-learn", {
                            opacity: 0
                        }), ao.set(".learn3", {
                            opacity: 1
                        }))
                    }
                })
            })),
            Ms = C((function(t) {
                document.documentElement.clientWidth > 850 ? As.create({
                    trigger: t,
                    start: "top bottom-=200",
                    end: "bottom bottom",
                    onUpdate: function(t) {
                        var e = t.progress;
                        e < .33 ? (ao.set(".sequence-sub", {
                            opacity: 0
                        }), ao.set(".sub1", {
                            opacity: 1
                        })) : e > .33 && e < .66 ? (ao.set(".sequence-sub", {
                            opacity: 0
                        }), ao.set(".sub2", {
                            opacity: 1
                        })) : (ao.set(".sequence-sub", {
                            opacity: 0
                        }), ao.set(".sub3", {
                            opacity: 1
                        }))
                    }
                }) : As.create({
                    trigger: t,
                    start: "top center",
                    end: "bottom center",
                    onUpdate: function(t) {
                        var e = t.progress;
                        e < .33 ? (ao.set(".sequence-sub", {
                            opacity: 0
                        }), ao.set(".sub1", {
                            opacity: 1
                        })) : e > .33 && e < .66 ? (ao.set(".sequence-sub", {
                            opacity: 0
                        }), ao.set(".sub2", {
                            opacity: 1
                        })) : (ao.set(".sequence-sub", {
                            opacity: 0
                        }), ao.set(".sub3", {
                            opacity: 1
                        }))
                    }
                })
            })),
            Ds = C((function(t) {
                document.documentElement.clientWidth > 850 ? As.create({
                    trigger: t,
                    start: "top bottom-=200",
                    end: "bottom bottom",
                    onUpdate: function(t) {
                        var e = t.progress;
                        e < .25 ? (ao.set(".sequence-subPro", {
                            opacity: 0
                        }), ao.set(".subPro1", {
                            opacity: 1
                        })) : e > .25 && e < .5 ? (ao.set(".sequence-subPro", {
                            opacity: 0
                        }), ao.set(".subPro2", {
                            opacity: 1
                        })) : e > .5 && e < .75 ? (ao.set(".sequence-subPro", {
                            opacity: 0
                        }), ao.set(".subPro3", {
                            opacity: 1
                        })) : (ao.set(".sequence-subPro", {
                            opacity: 0
                        }), ao.set(".subPro4", {
                            opacity: 1
                        }))
                    }
                }) : As.create({
                    trigger: t,
                    start: "top center",
                    end: "bottom center",
                    onUpdate: function(t) {
                        var e = t.progress;
                        e < .25 ? (ao.set(".sequence-subPro", {
                            opacity: 0
                        }), ao.set(".subPro1", {
                            opacity: 1
                        })) : e > .25 && e < .5 ? (ao.set(".sequence-subPro", {
                            opacity: 0
                        }), ao.set(".subPro2", {
                            opacity: 1
                        })) : e > .5 && e < .75 ? (ao.set(".sequence-subPro", {
                            opacity: 0
                        }), ao.set(".subPro3", {
                            opacity: 1
                        })) : (ao.set(".sequence-subPro", {
                            opacity: 0
                        }), ao.set(".subPro4", {
                            opacity: 1
                        }))
                    }
                })
            })),
            Rs = C((function() {
                M(".image-learn").classList.remove("dn"), M(".image-subscribe").classList.remove("dn")
            })),
            qs = C((function(t) {
                O(t, "click", (function() {
                    window.location = "/tools/recurring/login/"
                }))
            }));
        var zs, Is, Bs, Fs, js, Ns, Hs, Ws = C((function(t) {
                var e = D(t).phone;
                O(t, "submit", (function(t) {
                    t.preventDefault();
                    (function(t, e, i) {
                        void 0 === i && (i = {});
                        var n = Object.assign({}, i, {
                                g: t,
                                email: e
                            }),
                            r = Object.keys(n).reduce((function(t, e) {
                                return t.append(e, n[e]), t
                            }), new URLSearchParams);
                        return fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
                            method: "POST",
                            headers: {
                                "Access-Control-Allow-Headers": "*",
                                "Content-Type": "application/x-www-form-urlencoded; charset=utf-8"
                            },
                            body: r
                        }).then((function(t) {
                            return t.json()
                        }))
                    })("TRWm88", e.value, {}).then((function(t) {
                        console.log("response", t)
                    }))
                }))
            })),
            Us = C((function(t) {
                var e = D(t),
                    i = e.carousel,
                    n = (e.nav, e.navItem),
                    r = new Ar.a(i, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        wrapAround: !0,
                        pageDots: !1,
                        autoPlay: 5e3
                    });
                n.forEach((function(t) {
                    O(t, "click", (function(t) {
                        var e = parseInt(t.target.dataset.index);
                        r.select(e - 1)
                    }))
                })), r.on("change", (function(e) {
                    n.forEach((function(t) {
                        t.classList.remove("active")
                    })), P(M('.js-navItem[data-index="'.concat(e + 1, '"]'), t), "active")
                })), setTimeout((function() {
                    r.resize()
                }), 500)
            })),
            Xs = C((function(t) {
                var e = D(t),
                    i = e.carousel,
                    n = (e.nav, e.navItem, e.flavorMenu),
                    r = e.flavorList,
                    o = e.flavorListContent,
                    s = e.flavorToggle,
                    a = yr.timeline(),
                    l = new Ar.a(i, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        wrapAround: !0
                    });
                setTimeout((function() {
                    l.resize()
                }), 1500);
                var c = O(s, "click", (function() {
                    var t = o.getBoundingClientRect().height + 2;
                    n.classList.contains("isOpen") ? (n.classList.remove("isOpen"), a.to(r, {
                        maxHeight: 0,
                        duration: .2
                    }).to(s, {
                        borderBottomLeftRadius: "4rem",
                        borderBottomRightRadius: "4rem",
                        borderTopLeftRadius: "4rem",
                        borderTopRightRadius: "4rem",
                        duration: .2
                    })) : (n.classList.add("isOpen"), a.to(s, {
                        borderBottomLeftRadius: 0,
                        borderBottomRightRadius: 0,
                        borderTopLeftRadius: "2rem",
                        borderTopRightRadius: "2rem",
                        duration: .2
                    }).to(r, {
                        maxHeight: t,
                        duration: .2
                    }))
                }));
                return function() {
                    c()
                }
            })),
            Ys = C((function(t) {
                var e = D(t).carousel,
                    i = document.documentElement.clientWidth,
                    n = new Ar.a(e, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        pageDots: !0,
                        wrapAround: !0
                    });
                i < 850 ? n.resize() : n.destroy();
                O(window, "resize", (function() {
                    document.documentElement.clientWidth < 850 ? n = new Ar.a(e, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        pageDots: !0,
                        wrapAround: !0
                    }) : n.destroy()
                }));
                return setTimeout((function() {
                        n.resize()
                    }), 500),
                    function() {
                        n.destroy()
                    }
            })),
            Ysd = C((function(t) {
                var e = D(t).carousel,
                    i = document.documentElement.clientWidth,
                    n = new Ar.a(e, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        pageDots: !0,
                        wrapAround: !0,
                        autoPlay: 5e3
                    });
                i < 850 ? n.resize() : n.destroy();
                O(window, "resize", (function() {
                    document.documentElement.clientWidth < 850 ? n = new Ar.a(e, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        pageDots: !0,
                        wrapAround: !0,
                        autoPlay: 5e3
                    }) : n.destroy()
                }));
                return setTimeout((function() {
                        n.resize()
                    }), 500),
                    function() {
                        n.destroy()
                    }
            })),
            Sab = C((function(t) {
                console.log('hrehrh');
                if (!t) return;
                console.log('hrehrh2');

                let storedHeight = null;

                const footer = document.querySelector('footer');

                const handleScroll = () => {
                    const rect = t.getBoundingClientRect();
                    const isTopVisible = rect.top >= 0;

                    let footerVisible = false;

                    if (footer) {
                        const footerRect = footer.getBoundingClientRect();
                        footerVisible = footerRect.top < window.innerHeight;
                    }

                    if (!isTopVisible && !footerVisible && !t.classList.contains('sticky')) {
                        storedHeight = t.offsetHeight;
                        t.style.height = `${storedHeight}px`;
                        setTimeout(function(){t.classList.add('sticky')},300);
                    }

                    if ((isTopVisible || footerVisible) && t.classList.contains('sticky')) {
                        t.classList.remove('sticky');
                        setTimeout(function(){t.style.height = ''},300);
                        storedHeight = null;
                    }
                };

                handleScroll();
                window.addEventListener('scroll', handleScroll, { passive: true });

            })),
            YT = C((function(t) {
                var groupCount = 1;
                var e = D(t).carousel,
                    i = document.documentElement.clientWidth,
                    n = new Ar.a(e, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        pageDots: !0,
                        wrapAround: !0,
                        groupCells: groupCount
                    });
                n.resize();
                O(window, "resize", (function() {
                    n = new Ar.a(e, {
                        cellAlign: "center",
                        contain: !0,
                        prevNextButtons: !1,
                        pageDots: !0,
                        wrapAround: !0,
                        groupCells: groupCount
                    })
                }));
                return setTimeout((function() {
                        n.resize()
                    }), 500),
                    function() {
                        n.destroy()
                    }
            })),
            Vs = function() {
                return "undefined" != typeof window
            },
            Gs = function() {
                return zs || Vs() && (zs = window.gsap) && zs.registerPlugin && zs
            },
            $s = function(t) {
                return "string" == typeof t
            },
            Qs = function(t) {
                return "function" == typeof t
            },
            Ks = function(t, e) {
                var i = "x" === e ? "Width" : "Height",
                    n = "scroll" + i,
                    r = "client" + i;
                return t === Bs || t === Fs || t === js ? Math.max(Fs[n], js[n]) - (Bs["inner" + i] || Fs[r] || js[r]) : t[n] - t["offset" + i]
            },
            Js = function(t, e) {
                var i = "scroll" + ("x" === e ? "Left" : "Top");
                return t === Bs && (null != t.pageXOffset ? i = "page" + e.toUpperCase() + "Offset" : t = null != Fs[i] ? Fs : js),
                    function() {
                        return t[i]
                    }
            },
            Zs = function(t, e) {
                if (!(t = Ns(t)[0]) || !t.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || {
                    x: 0,
                    y: 0
                };
                var i = t.getBoundingClientRect(),
                    n = !e || e === Bs || e === js,
                    r = n ? {
                        top: Fs.clientTop - (Bs.pageYOffset || Fs.scrollTop || js.scrollTop || 0),
                        left: Fs.clientLeft - (Bs.pageXOffset || Fs.scrollLeft || js.scrollLeft || 0)
                    } : e.getBoundingClientRect(),
                    o = {
                        x: i.left - r.left,
                        y: i.top - r.top
                    };
                return !n && e && (o.x += Js(e, "x")(), o.y += Js(e, "y")()), o
            },
            ta = function(t, e, i, n, r) {
                return isNaN(t) || "object" == typeof t ? $s(t) && "=" === t.charAt(1) ? parseFloat(t.substr(2)) * ("-" === t.charAt(0) ? -1 : 1) + n - r : "max" === t ? Ks(e, i) - r : Math.min(Ks(e, i), Zs(t, e)[i] - r) : parseFloat(t) - r
            },
            ea = function() {
                zs = Gs(), Vs() && zs && document.body && (Bs = window, js = document.body, Fs = document.documentElement, Ns = zs.utils.toArray, zs.config({
                    autoKillThreshold: 7
                }), Hs = zs.config(), Is = 1)
            },
            ia = {
                version: "3.6.0",
                name: "scrollTo",
                rawVars: 1,
                register: function(t) {
                    zs = t, ea()
                },
                init: function(t, e, i, n, r) {
                    Is || ea();
                    this.isWin = t === Bs, this.target = t, this.tween = i, e = function(t, e, i, n) {
                        if (Qs(t) && (t = t(e, i, n)), "object" != typeof t) return $s(t) && "max" !== t && "=" !== t.charAt(1) ? {
                            x: t,
                            y: t
                        } : {
                            y: t
                        };
                        if (t.nodeType) return {
                            y: t,
                            x: t
                        };
                        var r, o = {};
                        for (r in t) "onAutoKill" !== r && (o[r] = Qs(t[r]) ? t[r](e, i, n) : t[r]);
                        return o
                    }(e, n, t, r), this.vars = e, this.autoKill = !!e.autoKill, this.getX = Js(t, "x"), this.getY = Js(t, "y"), this.x = this.xPrev = this.getX(), this.y = this.yPrev = this.getY(), null != e.x ? (this.add(this, "x", this.x, ta(e.x, t, "x", this.x, e.offsetX || 0), n, r, Math.round), this._props.push("scrollTo_x")) : this.skipX = 1, null != e.y ? (this.add(this, "y", this.y, ta(e.y, t, "y", this.y, e.offsetY || 0), n, r, Math.round), this._props.push("scrollTo_y")) : this.skipY = 1
                },
                render: function(t, e) {
                    for (var i, n, r, o, s, a = e._pt, l = e.target, c = e.tween, u = e.autoKill, h = e.xPrev, d = e.yPrev, f = e.isWin; a;) a.r(t, a.d), a = a._next;
                    i = f || !e.skipX ? e.getX() : h, r = (n = f || !e.skipY ? e.getY() : d) - d, o = i - h, s = Hs.autoKillThreshold, e.x < 0 && (e.x = 0), e.y < 0 && (e.y = 0), u && (!e.skipX && (o > s || o < -s) && i < Ks(l, "x") && (e.skipX = 1), !e.skipY && (r > s || r < -s) && n < Ks(l, "y") && (e.skipY = 1), e.skipX && e.skipY && (c.kill(), e.vars.onAutoKill && e.vars.onAutoKill.apply(c, e.vars.onAutoKillParams || []))), f ? Bs.scrollTo(e.skipX ? i : e.x, e.skipY ? n : e.y) : (e.skipY || (l.scrollTop = e.y), e.skipX || (l.scrollLeft = e.x)), e.xPrev = e.x, e.yPrev = e.y
                },
                kill: function(t) {
                    var e = "scrollTo" === t;
                    (e || "scrollTo_x" === t) && (this.skipX = 1), (e || "scrollTo_y" === t) && (this.skipY = 1)
                }
            };
        ia.max = Ks, ia.getOffset = Zs, ia.buildGetter = Js, Gs() && zs.registerPlugin(ia);
        var na = function(t, e, i) {
                void 0 === t && (t = {}), void 0 === e && (e = {}), void 0 === i && (i = []);
                var n = T(e),
                    r = [];                    
                return {
                    on: n.on,
                    emit: n.emit,
                    getState: function() {
                        return n.getState()
                    },
                    add: function(e) {
                        if (!S(e)) throw "components should be an object";
                        Object.assign(t, e)
                    },
                    use: function(t) {
                        if (!A(t)) throw "plugins should be a function";
                        i.push(t)
                    },
                    hydrate: function(t) {
                        return n.hydrate(t)
                    },
                    mount: function(e) {
                        void 0 === e && (e = "data-component"), e = [].concat(e);
                        for (var o = 0; o < e.length; o++) {
                            for (var s = e[o], a = [].slice.call(document.querySelectorAll("[" + s + "]")), l = function() {
                                    for (var e = a.pop(), o = e.getAttribute(s).split(/\s/), l = 0; l < o.length; l++) {
                                        var c = t[o[l]];
                                        if (c) {
                                            e.removeAttribute(s);
                                            try {
                                                var u = i.reduce((function(t, i) {
                                                        var r = i(e, n);
                                                        return S(r) ? Object.assign(t, r) : t
                                                    }), {}),
                                                    h = c(e, Object.assign({}, u, n));
                                                A(h.unmount) && r.push(h)
                                            } catch (t) {
                                                console.log('some error', t);
                                                // console.error(t), n.emit("error", {
                                                //     error: t
                                                // }), n.hydrate({
                                                //     error: void 0
                                                // })
                                            }
                                        }
                                    }
                                }; a.length;) l();
                            n.emit("mount")
                        }
                    },
                    unmount: function() {
                        for (var t = r.length - 1; t > -1; t--) {
                            var e = r[t],
                                i = e.subs;
                            (0, e.unmount)(e.node), i.map((function(t) {
                                return t()
                            })), r.splice(t, 1)
                        }
                        n.emit("unmount")
                    }
                }
            }({
                accountLogin: et,
                header: R,
                productSelection: U,
                cartDrawer: Z,
                cartDrawerItem: tt,
                product: it,
                productMarketing: nt,
                productCounter: ot,
                productOptionsMarketing: xr,
                productOptions: _r,
                productOptionsCollection: br,
                productOptionsSimple: wr,
                productOptionsLimited: Tr,
                productCarousel: Cr,
                ingredientCarousel: kr,
                arrowSliderIngredient: arrowIngredientFunction,
                arrowMarketingSlider: arrowFuctionMarketing,
                arrowProductSlider: arrowFunctionProduct,
                arrowProductSliderSingle: arrowFunctionProductSingle,
                ingredientModal: Lr,
                modalIngredientDesc: modalIngredientDescFunctions,
                newCode: newFunctions,
                filterMenu: filterFunction,
                marketingTns: sliderTns,
                welcomeMarketingTns: welcomeSliderTns,
                narrowSliderReview: arrowReviewFunction,
                newSliderHome: sliderHome,
                sliderLogos: sliderLogo,
                sliderBogoIcon: sliderBogoFunc,
                rewardsModal: Er,
                learnModal: Or,
                reviewsCarousel: Pr,
                marquee: oo,
                drawer: so,
                about: Cs,
                sequenceHero: Os,
                sequenceLearn: Ps,
                sequenceSubscribe: Ms,
                sequenceSubscribeProduct: Ds,
                menu: ks,
                checkout: Ls,
                productFeatured: rt,
                noList: Es,
                lazy: Rs,
                subscription: qs,
                notifySignup: Ws,
                marketingPress: Us,
                marketingShop: Xs,
                mobileCarousel: Ys,
                mobileCarouselAutoplay: Ysd,
                stickyAtcBtn:Sab,
                customFullCarousel: YT,
                anchorShop: C((function(t) {                   
                    ao.registerPlugin(ia), O(t, "click", (function() {
                      console.log($(this).hasClass('retailers-test'),'innnnnn');
                        if(!$(this).hasClass('retailers-test')){
                         if($(window).width() > 768){      
                            ao.to(window, {duration: 1,scrollTo: "#marketingShop"})
                         }else{                    
                           if($('body').hasClass('custom-template-page')){                             
                              ao.to(window, { duration: 1, scrollTo: "#marketingShop" });         
                           }else{
                              ao.to(window, {duration: 1,scrollTo: "#marketingShop .marketing-shop-details"})
                           }
                         }
                        }else{
                          var get_attr= $(this).attr('data-href');
                          window.location = get_attr;
                        }
                    }))                                     
                })),
                anchorShopBogo: C((function(t) {  
                    sticky_marketing_btn();         
                    ao.registerPlugin(ia), O(t, "click", (function() {
                         if($(window).width() > 768){      
                            $('html,body').animate({
                                scrollTop: $("#marketingShop,.product-new-custom").offset().top -70
                            }, 'slow');
                         }else{                    
                              $('html, body').animate({
                                  scrollTop: $('#AddToCart').offset().top + $('#AddToCart').outerHeight() - $(window).height()
                              }, 'slow'); 
                         }
                    }))                                     
                })),
                headerSpace: C((function(t) {
                    let banner_wrp = t.closest('div');

                    function headerspace() {
                        const header = document.querySelector('.js-header');
                        if (header && banner_wrp) {
                            console.log('hhrhrh',header,$(t) );
                            const headerHeight = header.offsetHeight;
                            banner_wrp.style.marginTop = (headerHeight) + 'px';
                        }
                    }

                    headerspace();

                    window.addEventListener('resize', headerspace);
                    window.addEventListener('orientationchange', headerspace);



                })),
                triggerATC: C((function(t) {
                    t.addEventListener('click', function () {
                        const form = document.querySelector(`#${t.dataset.formId}`);
                        if (!form) return;

                        const atcButton = form.querySelector('button[name="add"]');
                        if (atcButton && !atcButton.disabled) {
                        form.requestSubmit();
                        }
                    });
                })),
                inspiredSlider: C((function(t) {
                    var inspiredSwiper = new Swiper(t, {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        autoplay: {
                            delay: 3000,
                        },
                        loop: true,
                        breakpoints: {
                            576: {
                            slidesPerView: 2,
                            spaceBetween: 28,
                            },
                            1024: {
                            slidesPerView: 3,
                            spaceBetween: 28,
                            },
                        },
                    });
                })),
                feelingSlider: C((function(t) {
                    var feelingSwiper = new Swiper(t, {
                        slidesPerView: 1,
                        spaceBetween: 0,
                        autoplay: {
                            delay: 3000,
                        },
                        loop: true,
                        breakpoints: {
                            576: {
                            slidesPerView: 2,
                            spaceBetween: 75,
                            },
                            1024: {
                            slidesPerView: 3,
                            spaceBetween: 75,
                            },
                        },
                    });
                })),
                barbieSlider2: C((function(t) {
                    let barbie_slider = t.querySelector('.barbie_product_slider_2');
                    let barbe_thumbs = t.querySelector('.barbie_product_thumb_slider_2');
                    var swiper3 = new Swiper(barbe_thumbs, {
                        direction: 'vertical',
                        loop: false,
                        spaceBetween: 10,
                        slidesPerView: 'auto',
                    });
                    
                    var swiper4 = new Swiper(barbie_slider, {
                        loop: true,
                        spaceBetween: 0,
                        thumbs: {
                        swiper: swiper3,
                        },
                    }); 
                })),
                ctTimer: C((function (t){
                  let timer_div = document.querySelector('.ct_timer');
                  
                  if(timer_div){
                    var now = new Date();
                    var expiry_time;
                    if(sessionStorage.getItem("expiry_time") == null){
                      expiry_time = now.getTime() + (parseInt(timer_div.dataset.mins) * 60000);
                      sessionStorage.setItem("expiry_time",expiry_time);
                    }else{
                      expiry_time = sessionStorage.getItem("expiry_time");
                    }
                    
                    // Timer
                    var x = setInterval(function () {
                      now = new Date();
                      const now_time = now.getTime();
                      var distance = expiry_time - now_time;
                      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                      var totalHours = (days * 24) + hours;
                      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                    
                      // Pad all values to 2 digits
                      var paddedHours = String(totalHours).padStart(2, '0');
                      var paddedMinutes = String(minutes).padStart(2, '0');
                      var paddedSeconds = String(seconds).padStart(2, '0');
                    
                      timer_div.innerHTML = 'ENDS IN ' + paddedHours + " : " + paddedMinutes + " : " + paddedSeconds;
                    
                      if (distance < 0) {
                        clearInterval(x);
                        timer_div.innerHTML = "EXPIRED";
                      }
                    }, 1000);
                  }
                })),
                pdpFlavourSlider: C((function(t) {
                    let FlavorSlider = t.querySelector('.pdp-flavor_slider');
                    var flavor_swiper = new Swiper(FlavorSlider, {
                        spaceBetween: 6,
                        slidesPerView: 4,
                        freeMode: true,
                        mousewheel: {
                            releaseOnEdges: true,
                        },
                        breakpoints: {
                            525: {
                                slidesPerView: 4,
                            },
                            768: {
                                slidesPerView: 4,
                            },
                            1140: {
                                slidesPerView: 5.5,
                            }
                        }
                    });
                    FlavorSlider.querySelectorAll('.swiper-slide').forEach((slide, index) => {
                        slide.addEventListener('click', () => {
                            FlavorSlider.querySelectorAll('.swiper-slide').forEach(s => {
                                s.classList.remove('selected-slide');
                            });
                            slide.classList.add('selected-slide');
                        });
                    });
                })),
                mainProductSwipers: C((function(t) {
                    let thumb_swiper;
                    let thumbs = t.querySelector('.main-product-horiz-thumb-swiper');
                    if(thumbs){
                        thumb_swiper = new Swiper(thumbs, {
                            spaceBetween: 14,
                            slidesPerView: "auto",
                            freeMode: true,
                            watchSlidesProgress: true,
                        });
                    }else{
                        let thumbs2 = t.querySelector('.main-product-thumb-swiper');
                        thumb_swiper = new Swiper(thumbs2, {
                            spaceBetween: 10,
                            slidesPerView: 5,
                            freeMode: true,
                            direction: 'horizontal',
                            watchSlidesProgress: true,
                            breakpoints: {
                                767: {
                                    direction: 'vertical',
                                },
                            },
                        });
                    }
                    let mainSwiperPdp =  t.querySelector('.main-product-swiper');
                    let mainSwiperPdp_pagination = mainSwiperPdp.querySelector('.swiper-pagination');
                    let main_swiper = new Swiper(mainSwiperPdp, {
                        spaceBetween: 10,
                        slidesPerView: 1,
                        thumbs: {
                            swiper: thumb_swiper,
                        },
                        pagination: {
                            el: mainSwiperPdp_pagination,
                            clickable: true,
                        },
                    });
                })),
                bestSellingSlider: C((function(t) {
                    let best_selling = new Swiper(t, {
                        spaceBetween: 10,
                        slidesPerView: 2.5,
                        centeredSlides: true,
                        loop: true,
                        autoplay: {
                            delay: 2500,
                            disableOnInteraction: false,
                        },
                        breakpoints: {
                            576: {
                            slidesPerView: 4,
                            spaceBetween: 10,
                            },
                            767: {
                            slidesPerView: 5,
                            spaceBetween: 15,
                            },
                            1024: {
                            slidesPerView: 6,
                            spaceBetween: 30,
                            autoplay: false,
                            centeredSlides: false,
                            loop: false,
                            },
                        },
                    });
                })),
                feelTheDifference: C((function(t) {
                    var swiper = new Swiper(t, {
                        spaceBetween: 40,
                        centeredSlides: true,
                        loop: true,
                        slidesPerView: 1.6,
                        autoplay: {
                        delay: 2500,
                        disableOnInteraction: false,
                        },
                        breakpoints: {
                            480: {
                                slidesPerView: 2,
                                spaceBetween: 20,
                            },
                            767: {
                                slidesPerView: 3,
                                spaceBetween: 30,
                            },
                        },
                    });
                })),
                whyItWorks: C((function(t) {
                    new Swiper(t, {
                        spaceBetween: 0,
                        loop: true,
                        slidesPerView: 1,
                        autoplay: {
                            delay: 2500,
                            disableOnInteraction: false,
                        },
                        breakpoints: {
                            576: {
                            slidesPerView: 2,
                            spaceBetween: 15,
                            },
                            1024: {
                            slidesPerView: 3,
                            spaceBetween: 20,
                            autoplay: false,
                            loop: false,
                            },
                        },
                    });
                })),
                variantRadios: C((function(t) {
                    function initVariantSync(t) {
                        var variantRadios = t;
                        let parent = variantRadios.closest('.product-new-custom');
                        console.log('ggrgrgrgrgrr');
                        var productSelect = parent ? parent.querySelector(`#ProductSelect-${variantRadios.dataset.section}`) : document.getElementById(`ProductSelect-${variantRadios.dataset.section}`);

                        if (!variantRadios || !productSelect) return;

                        var variantsScript = variantRadios.querySelector('script[type="application/json"]');
                        if (!variantsScript) return;

                        var variants;
                        try { variants = JSON.parse(variantsScript.textContent); }
                        catch (e) { return; }

                        variantRadios.addEventListener('change', function () {
                            var selectedOptions = [];
                            variantRadios.querySelectorAll('fieldset').forEach(function (fieldset) {
                            var checked = fieldset.querySelector('input[type="radio"]:checked');
                            if (checked) selectedOptions.push(checked.value);
                            });

                            var match = variants.find(function (v) {
                            return v.options.every(function (opt, i) {
                                return opt === selectedOptions[i];
                            });
                            });

                            if (match) {
                            productSelect.value = String(match.id);
                            }
                        });
                    }
                    initVariantSync(t);
                }))
            }, {
                cartOpen: !1
            }),
            ra = i(9);

        function oa(t) {
            if ("/" === t) return t;
            47 === t.charCodeAt(0) && (t = t.substring(1));
            var e = t.length - 1;
            return 47 === t.charCodeAt(e) ? t.substring(0, e) : t
        }

        function sa(t) {
            return "/" === (t = oa(t)) ? ["/"] : t.split("/")
        }

        function aa(t, e, i) {
            return i = t[i], e.val === i && 0 === e.type || ("/" === i ? e.type > 1 : 0 !== e.type && (i || "").endsWith(e.end))
        }

        function la(t) {
            if ("/" === t) return [{
                old: t,
                type: 0,
                val: t,
                end: ""
            }];
            for (var e, i, n, r, o = oa(t), s = -1, a = 0, l = o.length, c = []; ++s < l;)
                if (58 !== (e = o.charCodeAt(s)))
                    if (42 !== e) {
                        for (a = s; s < l && 47 !== o.charCodeAt(s);) ++s;
                        c.push({
                            old: t,
                            type: 0,
                            val: o.substring(a, s),
                            end: ""
                        }), o = o.substring(s), l -= s, s = a = 0
                    } else c.push({
                        old: t,
                        type: 2,
                        val: o.substring(s),
                        end: ""
                    });
            else {
                for (a = s + 1, n = 1, i = 0, r = ""; s < l && 47 !== o.charCodeAt(s);) 63 === (e = o.charCodeAt(s)) ? (i = s, n = 3) : 46 === e && 0 === r.length && (r = o.substring(i = s)), s++;
                c.push({
                    old: t,
                    type: n,
                    val: o.substring(a, i || s),
                    end: r
                }), o = o.substring(s), l -= s, s = 0
            }
            return c
        }

        function ca(t, e) {
            for (var i, n, r = 0, o = sa(t), s = {}; r < e.length; r++) i = o[r], n = e[r], "/" !== i && void 0 !== i && !1 | n.type && (s[n.val] = i.replace(n.end, ""));
            return s
        }
        var ua = new Map;

        function ha(t) {
            return t.replace(window.location.origin, "")
        }

        function da(t, e) {
            var i = "",
                n = "",
                r = t.split(/#|\?/),
                o = r[0],
                s = r.slice(1);
            o = (o = o.replace(/\/$/g, "")) || "/";
            for (var a = 0; a < s.length; a++) {
                var l = t.split(s[a])[0];
                "?" === l[l.length - 1] && (n = s[a]), "#" === l[l.length - 1] && (i = s[a])
            }
            var c = function(t, e) {
                    for (var i, n, r = 0, o = sa(t), s = o.length, a = aa.bind(aa, o); r < e.length; r++)
                        if (((n = (i = e[r]).length) === s || n < s && 2 === i[n - 1].type || n > s && 3 === i[n - 1].type) && ra(i, a)) return i;
                    return []
                }(o, e.map((function(t) {
                    return t.matcher
                }))),
                u = e.filter((function(t) {
                    return t.path === c[0].old
                }))[0];
            return c[0] ? Object.assign({}, u, {
                params: ca(o, c),
                hash: i,
                search: n,
                pathname: o,
                location: t
            }) : null
        }
        var fa = function(t, e) {
            void 0 === e && (e = ["*"]);
            var i, n = document.querySelector(t),
                r = [],
                o = {};
            e = e.concat(e.indexOf("*") < 0 ? "*" : []).reduce((function(t, e) {
                return "function" == typeof e ? (r.push(e), t) : t.concat(e)
            }), []).map((function(t) {
                return t.path ? Object.assign({}, t, {
                    matcher: la(t.path)
                }) : {
                    path: t,
                    matcher: la(t)
                }
            }));
            var s = da(ha(window.location.href), e),
                a = Object.assign({
                    previousDocument: null
                }, s);

            function l(t) {
                return o[t] ? o[t].map((function(t) {
                    return t(a)
                })) : []
            }

            function c(t, e, i, o) {
                a.previousDocument = t.cloneNode(!0), Promise.all(r.concat(i.handler || []).map((function(t) {
                    return t(a)
                }))).then((function() {
                    requestAnimationFrame((function() {
                        n.innerHTML = e, l("after"), i.hash && l("hash")
                    }))
                }))
            }

            function u(e, i, n) {
                if (!i) return window.location.href = e;
                fetch(e, {
                    credentials: "include"
                }).then((function(t) {
                    return t.text()
                })).then((function(r) {
                    var o = (new window.DOMParser).parseFromString(r, "text/html"),
                        s = [o, o.querySelector(t).innerHTML];
                  var site_logo_source = o.querySelector('.nav-logo');
                  var site_logo_destination = document.querySelector('.nav-logo');
                  if(site_logo_source && site_logo_destination) {
                    site_logo_destination.innerHTML = site_logo_source.innerHTML;
                  }
                    ua.set(e, s), n && n(s[0], s[1], i)
                }))
            }

            function h(t, e, n) {
                i = function() {
                    var i = ua.get(t);
                    i && !1 !== e.cache ? c(i[0], i[1], e) : u(t, e, c)
                }, Object.assign(a, e), Promise.all(l("before")).then(i)
            }

            function d(t) {
                var i = ha(t);
                return [i, da(i, e)]
            }
            return document.body.addEventListener("click", (function(t) {
                if (!(t.ctrlKey || t.metaKey || t.altKey || t.shiftKey || t.defaultPrevented)) {
                    for (var e = t.target; e && (!e.href || "A" !== e.nodeName);) e = e.parentNode;
                    if (!e) return t;
                    var i = d(e.href),
                        n = i[0],
                        r = i[1];
                    return r.ignore ? t : a.pathname === r.pathname && r.hash ? (t.preventDefault(), Object.assign(a, r), l("hash"), t) : window.location.origin !== e.origin || e.hasAttribute("download") || "_blank" === e.target || /^(?:mailto|tel):/.test(e.href) || e.classList.contains("no-ajax") ? t : (t.preventDefault(), a.location !== n && h(n, r), l("navigate"), !1)
                }
            })), window.addEventListener("popstate", (function(t) {
                if (t.target.location.pathname !== a.pathname) return h.apply(void 0, d(t.target.location.href).concat([!0])), !1
            })), {
                get state() {
                    return a
                },
                go: function(t) {
                    i = null, h.apply(void 0, d(t).concat([!1]))
                },
                load: function(t, e) {
                    return u.apply(void 0, d(t).concat([e]))
                },
                on: function(t, e) {
                    return o[t] = o[t] ? o[t].concat(e) : [e],
                        function() {
                            return o[t].slice(o[t].indexOf(e), 1)
                        }
                }
            }
        }("#root", [function() {
            return new Promise((function(t) {
                yr.timeline().to("main", {
                    opacity: 0,
                    duration: .01,
                    onComplete: function() {
                        t(), window.scrollTo(0, 0)                      
                    }
                }).to("main", {
                    opacity: 1,
                    duration: .5
                })
            }))
        }, {
            path: "/tools/*",
            ignore: !0
        }]);
        fa.on("after", (function(t) {
            if(t.pathname.indexOf('/collections/') !== -1){
              var e = t.location;
            } else{
              var e = t.pathname;
            }
            if (window.history.pushState({}, "", e), null != document.querySelector("[data-title]")) {
                var i = document.querySelector("[data-title]").dataset.title;
                document.title = i       
                // Powder Slider
                if ($('.video_gallery_wpr').length > 0) {                                    
                    $('.video_gallery_wpr').each(function () {           
                        var $video_gallery_wpr = $(this);
                        if ($(window).width() > 768) {
                            if ($video_gallery_wpr.hasClass('slick-initialized')) {
                                $video_gallery_wpr.slick('unslick');
                            }
                        }
                        else {
                            if (!$video_gallery_wpr.hasClass('slick-initialized')) {
                                $video_gallery_wpr.slick({
                                   slidesToShow: 2,
                                   slidesToScroll: 1,
                                   dots: true,
                                   appendDots: $('.slick-dots'),
                                   arrows: true,
                                   infinite: false,
                                   autoplay: false,
                                   prevArrow: $('.prev'),
                                   nextArrow: $('.next')
                                });
                            }
                        }
                    });   
                    $('body').on('click', '.video_play_btn' , function(e){
                        e.preventDefault();   
                        $('.col_inner video').each(function() {
                            $(this).get(0).pause();
                            $(this).parents('.video_gallery_col').removeClass('play-video');
                        });
                        $(this).parents('.video_gallery_col').find('video').each(function (k, v) {
                            if (v.paused) {
                            v.play();
                            $(this).parents('.video_gallery_col').addClass('play-video');
                            $(this).parents('.video_gallery_col').addClass('pause-video');
                            }else {
                            v.pause();
                            $(this).parents('.video_gallery_col').removeClass('play-video');
                            $(this).parents('.video_gallery_col').addClass('pause-video');
                            }
                        });    
                    }); 
                    $('body').on('click', '.video_puse_btn' , function(e){
                        e.preventDefault();  
                        $(this).parents('.video_gallery_col').removeClass('pause-video');
                        $(this).parents('.video_gallery_col').find('video').each(function (k, v) {
                            v.pause();
                            $(this).parents('.video_gallery_col').removeClass('play-video');
                            $(this).parents('.video_gallery_col').addClass('pause-video');
                        });    
                    });                     
                }
                  var get_template = $("[data-template]").attr('data-template');                    
                  if($("[data-template]").attr('data-template') == 'custom-template-page' ){
                    $('body').addClass(get_template);   
                  }else{     
                    $('body').removeClass('custom-template-page');                            
                  }
                  if($("[data-template]").attr('data-template') == 'shop-about' ){
                    $('body').addClass(get_template);   
                  }else{     
                    $('body').removeClass('shop-about');                            
                  }
            }

            //yotpo widgets reinitialize code
            yotpoWidgetsContainer.initWidgets();
        }));
        var pa = fa;
        b(), ao.registerPlugin(As), pa.on("after", (function(t) {            
           // Trigger Swatch  
            jQuery('.swatch :radio').on('change',function() {               
              var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
              var optionValue = jQuery(this).val();
              jQuery(this)
              .closest('form')
              .find('.single-option-selector')
              .eq(optionIndex)
              .val(optionValue)
              .trigger('change');
            }); 
          if($('#ProductSelect-template').length){                                   
            var get_json = JSON.parse($('#ProductJson--template-1').html()); 
             // BEGIN SWATCHES                                                      
            var selectCallback = function(variant, selector){ 
              console.log(variant,'apppppppp in');
                if (variant) {
                    var form = jQuery('#' + selector.domIdPrefix).closest('form');
                    for (var i=0,length=variant.options.length; i<length; i++) {
                    var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]')
                        if (radioButton.length) {                        
                            radioButton.get(0).checked = true;                        
                        }
                    }
                }
              $('.variant_dropdown[name="id"]').find('option[value="'+ variant.id +'"]').prop('selected',true).trigger('change');     
            }          
            console.log(get_json,'get_jsonget_json');
            new Shopify.OptionSelectors("ProductSelect-template", { product:get_json, onVariantSelected: selectCallback, enableHistoryState: true });                      
          }            
             if (window.location.href == 'https://drinkmoment.com/pages/store-locator') {
              if (window.location.href.indexOf('#')==-1) {
                   window.location.replace(window.location.href+'#');
                   location.reload(true);
              }
            }   
           //Article Js              
              var length = $(".rte-container").find("h2").length;
              if (length > 0) {
              for ( let i=0 ; i < length ; i++ ){
                  let $h2 = $(".rte-container").find("h2:eq("+i+")");
                  if($h2.text() != ''){
                    $('.table-contents-main .table-contents').append('<li data-id='+i+'>'+$h2.text()+'</li>');
                  }
              }
              
              $('body').on('click','.table-contents li',function(){
                  var id = $(this).attr('data-id');
                  var $h2 = $(".rte-container").find("h2:eq("+id+")");
                  if( $h2.length ){
                      var $jumpto = $h2.offset().top;
                      $('html, body').animate({
                        scrollTop: $jumpto - 115
                      },1000);
                  }
              });
              } else{
              $('body').find('.table-contents-main').css('display','none');
              }
              
              
              const win = $(window);
                if (win.width() < 575) {
                    $(".table-select-wp").click(function() {
                        const $accordion_wrapper = $(this).parent();
                        const $accordion_content = $(this).parent().find(".table-contents-wp").first();
                        const $accordion_open = "accordion--open";
                
                        // If this accordion is already open
                        if ($accordion_wrapper.hasClass($accordion_open)) {
                            $accordion_content.slideUp(); // Close the content.
                            $accordion_wrapper.removeClass($accordion_open); // Remove the accordionm--open class.
                        }
                        // If this accordion is not already open
                        else {
                            $accordion_content.slideDown(); // Show this accordion's content.
                            $accordion_wrapper.addClass($accordion_open); // Add the accordion--open class.
                        }
                    });
                }
                // fermat js start
                if(window.location.href.indexOf('/pages/fermat')!==-1){
                  console.log('run this js ----------------------------------');
                  $('body').on('click','.fe-product-link', function(e) {
                    e.preventDefault();
                    var linkk = $(this).attr('data-href');
                    if(linkk.indexOf('/products/')!==-1){
                        $.ajax({
                            url: linkk+'?view=fermat-get-json', 
                            type: 'GET',
                            dataType: 'html', 
                            success: function(response) {
                                var htmlResponse = $(response);
                                $('[data-fermat-product]').html(htmlResponse.find('[data-fermat-product]').html());
                                $("body").find(".new_shop_drawer").addClass('is-open');
                                $("body").addClass('is-open');
                                $("body").find(".new_overlay").addClass('is-open');
                            },
                            error: function(xhr, status, error) {
                                console.error('AJAX Error: ' + status + error);
                            }
                        });
                    }else{
                       window.location.replace(linkk);
                    }
                  });
                  $('body').on('click','.new_close_icon,.new_overlay', function(e) {
                    $("body").find('.new_shop_drawer').removeClass('is-open');
                    $("body").removeClass('is-open');
                    $("body").find(".new_overlay").removeClass('is-open');
                    $('[data-fermat-product]').html('');
                  });
                  
                  $('body').on('click','.drawer_tabs li', function(e) {
                      var tab_id = $(this).attr('data-tab');
                      $(this).closest('.has_parent').find('.drawer_tabs li').removeClass('current');
                      $(this).closest('.has_parent').find('.drawer_tab_content').removeClass('current');
                      $(this).addClass('current');
                      $("#" + tab_id).addClass('current');
                  });
                  /*fermat main product js start----------*/
                  window.productStrings = {
                    addToCart: 'Add to Cart',
                    soldOut: 'Sold Out',
                    unavailable: 'Unavailable'
                  }
                  function swipercall(){
                    var sliderThumbnail = new Swiper('.fermat_product_thumbnail_slider', {
                      slidesPerView: 4,
                      spaceBetween: 8,
                      freeMode: true,
                      watchSlidesVisibility: true,
                      watchSlidesProgress: true,
                    });
                    var mainSlider = new Swiper('.fermat_product_slider', {
                      slidesPerView: 1,
                      thumbs: {
                        swiper: sliderThumbnail
                      }
                    });
                  }
                  swipercall();
                  (function() {
                    window.retextionApi = Object.assign({
                      productData: [],
                      variants: {},
                      queryParamsGet: function() {
                        let [location, searchHash] = window.location.toString().split('?');
                        let [search] = (searchHash || "").split('#');
                        return(search || '').split('&').reduce((o, e) => {
                          let [key, value] = e.split('=').map(x => decodeURIComponent(x));
                          if (!key || !value) 
                            return o;
                
                          o[key] = value;
                          return o;
                        }, {});
                      },
                      queryParamsGenerate: function(params) {
                        let {queryParams} = params;
                        queryParams = queryParams || {};
                
                      // Remove undefined
                        Object.keys(queryParams).forEach(key => {
                          if (typeof queryParams[key] !== typeof undefined) 
                            return;
                
                          delete queryParams[key];
                        });
                        return Object.keys(queryParams).reduce((x, key, i) => {
                          let value = queryParams[key];
                          if (i != 0) 
                            x += '&';
                
                          return x += encodeURIComponent(key) + '=' + encodeURIComponent(value);
                        }, '');
                      },
                      sellingPlanPushHistory: function(params) {
                        const {sellingPlan} = params;
                        let queryParams = window.retextionApi.queryParamsGet();
                        if (sellingPlan) {
                          queryParams['selling_plan'] = sellingPlan.id || sellingPlan;
                        } else {
                          delete queryParams['selling_plan'];
                        }
                        const qs = window.retextionApi.queryParamsGenerate({queryParams});
                        try {
                          let hash;
                          hash = (hash = window.location.toString().split('#')).length > 1
                            ? hash[1]
                            : null;
                          const url = (window.location.toString().split('?')[0] + (
                            qs.length
                              ? '?' + qs
                              : ''
                          ) + (
                            hash
                              ? '#' + hash
                              : ''
                          ));
                          window.history.pushState(queryParams, '', url);
                        } catch (e) { // Catching since older browsers and iOS can have issues
                          console.error(e);
                        }
                      },
                      productAdd: function(params) {
                        const {product} = params;
                        if (!product) 
                          return;
                
                        window.retextionApi.productData.push(product);
                        product.variants.forEach(variant => {
                          window.retextionApi.variants[variant.id] = product.id;
                        });
                      },
                      formatMoney: function(money) {
                        try {
                          if (window && window.Shopify && typeof window.Shopify.formatMoney === 'function')
                            return window.Shopify.formatMoney(money).toFixed(0);
                
                          if (window && window.theme && window.theme.utils && typeof window.theme.utils === 'function')
                            return theme.utils.formatMoney(money).toFixed(0);
                
                          return '$' + (
                            money / 100
                          );
                        } catch (e) {
                          return '$' + (
                            money / 100
                          );
                        }
                      }
                    }, window.retextionApi);
                  })();
                      
                  
                      function FermatStayCode(product, currentVariantID,element){
                        let prodTitle = 'fermat-featured-product';
                        let functionName = `stayCode-${prodTitle}`;  
                        ((buyBoxes) => {
                          const buyBox = {
                            boxId: product.id
                          };      
                          buyBox.product = product;
                          buyBox.variantId = currentVariantID ? currentVariantID : product.variants[0].id;
                          var prodID = product.id; 
                          var defaultToSubscription = true;
                          buyBox.requiresPlan = false;
                          buyBox.sellingPlanGroups = buyBox.product.selling_plan_groups.filter(g => g.app_id == '5859381');      
                          if(buyBox.sellingPlanGroups.length > 0){
                            var boxId = `div[data-rtx-subscription-${prodID}]`;
                            buyBox.purchaseTypeLbl = element.querySelector(`.purchaseTypeLbl`);
                            buyBox.widget = element.querySelector(boxId);
                            buyBox.root = element.querySelector(boxId);
                            if(!buyBox.root){         
                              return;
                            }
                            buyBox.form = element.querySelector(`form[action="/cart/add"]`) || buyBox.root.closest('form[action="/cart/add"]') || buyBox.root.closest('form')  || document.documentElement;
                            buyBox.subscriptionBox = buyBox.root.querySelector(`[data-retextion-subscription-box-${prodID}]`);
                            buyBox.sellingPlanSelector = buyBox.root.querySelector(`.rtx-subscription-dropdown-${prodID}`);      
                            buyBox.purchaseType = buyBox.root.querySelectorAll(`[name="purchaseType-${prodID}"]`);
                            buyBox.labelOneTime = buyBox.root.querySelector(`[for="purchaseTypeOneTime-${prodID}"]`);
                            buyBox.labelSubscription = buyBox.root.querySelector(`[for="purchaseTypeSubscription-${prodID}"]`);
                            buyBox.sellingPlanInput = element.querySelector(`input[name="selling_plan"]`);
                            buyBox.cachedSellingPlanId = buyBox.sellingPlanSelector.value;
                            
                            // Note:
                            // Adjust these selectors as needed to match theme's structure
                            buyBox.variantSelectors = buyBox.form.querySelectorAll(`[name="id"]`);
                            buyBox.productPriceLbl = element.querySelector(`.js-pInfoOne .product--price`);
                            buyBox.discount_prcntt = element.querySelector(`.js-pInfoOne .discount_percentt`);
                            // Remove the 'Select frequency' option from the frequency selector
                            buyBox.removeEmptyOption = () => {
                              const optEmpty = buyBox.sellingPlanSelector.querySelectorAll('[value=""]');
                              optEmpty.forEach(e => e.remove());
                            }
                            // Adds a 'Select frequency' option to the frequency selector
                            buyBox.addEmptyOption = () => {
                              let optEmpty = buyBox.sellingPlanSelector.querySelector('[value=""]');
                              if(optEmpty) return;
                              optEmpty = document.createElement('option');
                              optEmpty.value = '';
                              optEmpty.textContent = 'Select frequency';
                              buyBox.sellingPlanSelector.appendChild(optEmpty);
                            }
                            // Hide the frequency selector and calls the updateSellingPlan function
                            buyBox.hideSubscriptionBox = () => {
                              buyBox.cachedSellingPlanId = buyBox.sellingPlanSelector.value;
                              // Hide the frequency selector unless the block settings frequencyVisible is true
                              true ? '' : buyBox.subscriptionBox.classList.remove('is-visible');
                              buyBox.addEmptyOption();
                              buyBox.sellingPlanSelector.value = '';
                              if(buyBox.sellingPlanInput) buyBox.sellingPlanInput.value = '';
                              buyBox.updateSellingPlan();
                              if(buyBox.labelOneTime) buyBox.labelOneTime.classList.add('is-selected');
                              if(buyBox.labelSubscription) buyBox.labelSubscription.classList.remove('is-selected');
                            }
                            // Display frequency selector and trigger updateSellingPlan function
                            buyBox.showSubscriptionBox = () => {
                              buyBox.subscriptionBox.classList.add('is-visible');
                              buyBox.sellingPlanSelector.value = buyBox.cachedSellingPlanId;
                              if(buyBox.sellingPlanInput) buyBox.sellingPlanInput.value = buyBox.cachedSellingPlanId;
                              buyBox.removeEmptyOption();
                              if(window.location.href.includes('collections')){
                                let frequency = Array.from(buyBox.sellingPlanSelector.options).filter(option => option.innerText.includes('30 days'))[0];
                                frequency.selected = true;          
                              }else{
                                 buyBox.sellingPlanSelector.options[0].selected = true;
                              }
                             
                              buyBox.updateSellingPlan();
                              if(buyBox.labelOneTime) buyBox.labelOneTime.classList.remove('is-selected');
                              if(buyBox.labelSubscription) buyBox.labelSubscription.classList.add('is-selected');        
                            }
                  
                            // Displays the widget based on the variant
                            buyBox.showStayWidget = (currentVariant) => {
                              var sellingPlans = [];
                              let group;
                  
                              // Retrieve the selling plans for the current variant
                              if(currentVariant.selling_plan_allocations.length > 0){
                                currentVariant.selling_plan_allocations.forEach((spa) => {
                                    group = buyBox.sellingPlanGroups.find(g => g.id == spa.selling_plan_group_id);
                                    if(group)
                                    sellingPlans.push(group.selling_plans.find(sp => sp.id == spa.selling_plan_id)); 
                                }); 
                                
                                if(sellingPlans.length > 0){
                                  
                                    while (buyBox.sellingPlanSelector.options.length > 0) {
                                      buyBox.sellingPlanSelector.remove(0);
                                    }
                                    // Update subscription frequency selector and selling plans values
                                    sellingPlans.forEach((sp, i) => {
                                        const newOption = document.createElement('option');
                                        newOption.textContent = sp.options[0].value;
                                        newOption.value = sp.id;
                                        buyBox.sellingPlanSelector.appendChild(newOption);
                                    });
                                  
                                    buyBox.widget.style.display = 'block';
                                    buyBox.purchaseTypeLbl.style.display = 'block';
                                    
                                    // If the default purchase type is subscription or the product requires a selling plan,
                                    // select the subscription option
                                    setTimeout(()=>{
                                      if(defaultToSubscription){
                                        //buyBox.labelSubscription.click();
                                      } else{
                                        //buyBox.labelOneTime?.click();
                                      }
                                      (defaultToSubscription || buyBox.requiresPlan) ? buyBox.showSubscriptionBox() : buyBox.hideSubscriptionBox();
                                    }, 100);
                                  
                                }
                              }else{
                                // Hide the widget if there are no selling plans available
                                buyBox.widget.style.display = 'none';
                                buyBox.purchaseTypeLbl.style.display = 'none';
                                buyBox.hideSubscriptionBox();
                              }
                            }
                          
                            // Returns true if the subscription purchase type is selected 
                            buyBox.isSubscriptionSelected = () => {
                              return buyBox.labelSubscription.classList.contains('is-selected');
                            } 
                            // Returns the selling plan ID 
                            buyBox.getSellingPlanId = () => {
                              let sellingPlanId = buyBox.sellingPlanSelector.value;
                              return parseInt(sellingPlanId);
                            }     
                            // Function handling selling plan logic, updating price and selling plan value
                            buyBox.updateSellingPlan = () => {
                              let discountLabels = buyBox.root.querySelectorAll('[data-rtx-subscription-price]');
                              const fullPriceLabels = buyBox.root.querySelectorAll('[data-rtx-onetime-price]');
                              const variant = buyBox.product.variants.find(v => v.id == buyBox.variantId);
                              const sellingPlanId = buyBox.isSubscriptionSelected() ? buyBox.getSellingPlanId() : '';
                              const sellingPlanAllocation = sellingPlanId ? variant.selling_plan_allocations.find(spa => spa.selling_plan_id == sellingPlanId) : undefined;
                              const firstSellingPlanAllocation = variant.selling_plan_allocations.find(spa => spa.selling_plan_id == buyBox.getSellingPlanId()) || variant.selling_plan_allocations.find(spa => spa);
                              const sellingPlanGroup = firstSellingPlanAllocation ? buyBox.sellingPlanGroups.find(spg => spg.id == firstSellingPlanAllocation.selling_plan_group_id) || buyBox.sellingPlanGroups[0] : undefined;
                              var sellingPlan = sellingPlanGroup ? sellingPlanGroup.selling_plans.find(sp => sp.id == firstSellingPlanAllocation.selling_plan_id) || sellingPlanGroup.selling_plans[0] : undefined;
                              
                             
                              // Calculate the discount, one-time purchase and subscription prices
                              let strDiscount = ` ${window.retextionApi.formatMoney(variant.price)}`;
                              let savings = buyBox.root.querySelector('.savings');
                              let percentage = Math.round((1.0 - (firstSellingPlanAllocation.price / variant.price)) * 100);
                              let discount_Prcnt =  `${percentage}%`;
                              let subPrice;
                    
                              if(firstSellingPlanAllocation && firstSellingPlanAllocation.price != variant.price && sellingPlan) {
                                let percentage = Math.round((1.0 - (firstSellingPlanAllocation.price / variant.price)) * 100);
                                if(sellingPlan.price_adjustments[0].value_type == 'percentage' ){
                                  if(percentage > 0) {
                                    savings.innerHTML = `${percentage}%: `;
                                    strDiscount = `<m>${window.retextionApi.formatMoney(firstSellingPlanAllocation.price)}</m> <s>${window.retextionApi.formatMoney(variant.price)}</s>`;
                                    subPrice = ` ${window.retextionApi.formatMoney(firstSellingPlanAllocation.price)}`;
                                    discount_Prcnt = `${percentage}%`;
                                    
                                  }else{
                                    strDiscount = ` ${window.retextionApi.formatMoney(firstSellingPlanAllocation.price)}`;
                                    subPrice = ` ${window.retextionApi.formatMoney(firstSellingPlanAllocation.price)}`;
                                    discount_Prcnt = ``;
                                  }
                                }else{
                                  savings.innerHTML = `${window.retextionApi.formatMoney(variant.price - firstSellingPlanAllocation.price)} `;
                                  strDiscount = `<m>${window.retextionApi.formatMoney(firstSellingPlanAllocation.price )}</m> <s>${window.retextionApi.formatMoney(variant.price)}</s>`;
                                  subPrice = ` ${window.retextionApi.formatMoney(firstSellingPlanAllocation.price )}`;
                                   if(percentage > 0) {
                                    discount_Prcnt = `${percentage}%`;
                                   }else{
                                     discount_Prcnt = ``;
                                   }
                                } 
                              } 
                  
                              // Create selling plan input and add it to the buy button form
                              if(sellingPlan){
                                  var query = `form#product_form_${prodID}[action='/cart/add']`;
                                  setTimeout( ()=>{
                                    buyBox.form = element.querySelector(query);
                                    if(!buyBox.sellingPlanInput ){
                                        let input = document.createElement('input');
                                        input.setAttribute('name', 'selling_plan');
                                        input.setAttribute('type', 'hidden');
                                        input.setAttribute('value', sellingPlan.id);
                                        buyBox.form.appendChild(input);
                                        buyBox.sellingPlanInput = element.querySelector('input[name="selling_plan"]');
                                    }else{
                                        buyBox.sellingPlanInput.setAttribute('value', sellingPlan.id);
                                    }
                                    if(!buyBox.isSubscriptionSelected()) buyBox.sellingPlanInput.setAttribute('value', '');
                  
                                    // Disable frequency selection if subscription option isn't selected
                                    buyBox.isSubscriptionSelected() ? buyBox.sellingPlanSelector.removeAttribute('disabled') : buyBox.sellingPlanSelector.setAttribute('disabled', true);
                  
                                    // Update product price label
                                    buyBox.productPriceLbl = element.querySelector(`.js-pInfoOne .product--price`);   
                                    buyBox.discount_prcntt = element.querySelector(`.js-pInfoOne .discount_percentt`);
                                    if(buyBox.productPriceLbl){
                                      buyBox.productPriceLbl.innerHTML = buyBox.isSubscriptionSelected() ? strDiscount : strFullPrice;
                                      buyBox.discount_prcntt.innerHTML = buyBox.isSubscriptionSelected() ? discount_Prcnt: '';
                                    }
                  
                                  }, 100);
                              }
                              // Update purchase type prices
                              let strFullPrice = ` ${window.retextionApi.formatMoney(variant.price)}`;
                              console.log(strFullPrice,'strFullPricestrFullPrice');
                              discountLabels.forEach(dl => dl.innerHTML = subPrice);
                              fullPriceLabels.forEach(fp => fp.textContent = strFullPrice);
                              
                            }
                            // Event Listeners
                            // Add event listeners to the purchase type radio buttons to display the frequency selector
                            buyBox.purchaseType.forEach(el => {
                              el.addEventListener('change', e => {
                                if(el.value.includes('purchaseTypeSubscription')) {
                                  buyBox.showSubscriptionBox();
                                } else {
                                  buyBox.hideSubscriptionBox();
                                }
                              });
                            });
                            // Add event listener to the frequency selector to update the selling plan
                            buyBox.sellingPlanSelector.addEventListener('change', e => {
                              console.log('change',buyBox);
                              
                              buyBox.updateSellingPlan();
                            });
                            // Add event listener to the variant selector to update the variant and call the showStayWidget function
                            buyBox.variantSelectors.forEach(vs => {
                              vs.addEventListener('change', e => {
                                buyBox.variantId = e.target.value;
                                let currentVariant = buyBox.product.variants.find(v => v.id == buyBox.variantId);
                                buyBox.showStayWidget(currentVariant);
                              });
                            });
                            //Membership modal
                            setTimeout(()=>{
                              let infoBtn = element.querySelectorAll(`.rewardsModalBtn`);
                              let modalInfo = element.querySelector(`div.js-rewardsModal.modal-info`);
                              if(!infoBtn || !modalInfo) return;
                              infoBtn.forEach((modalButton) => {
                                modalButton.addEventListener('click', e =>{
                                    modalInfo.classList.remove('dn');
                                    modalInfo.style.display = 'block';
                                    modalInfo.style.opacity = 1;
                                    modalInfo.style.visibility = 'visible';
                                    let closeBtn = element.querySelector(`button.js-rewardsClose`);
                                    if(closeBtn)
                                    closeBtn.addEventListener('click', e =>{
                                          modalInfo.classList.add('dn');
                                          modalInfo.style.display = 'none';
                                          modalInfo.style.opacity = 0;
                                          modalInfo.style.visibility = 'hidden';
                                      });
                                });          
                              })
                            })
                            
                            // Init
                            let selectedVariant = buyBox.product.variants[0];
                            buyBox.showStayWidget(selectedVariant);
                            if(buyBox.isSubscriptionSelected()) buyBox.removeEmptyOption();          
                            window.retextionApi.productAdd({ product: buyBox.product });
                  
                            // Find all spans with "Subscribe & Save" and update their text
                            function updateSubscriptionLabels() {    
                            if (window.innerWidth >= 1025 && window.innerWidth <= 1199) {
                              if (window.location.href.includes('collections')) {
                                
                                element.querySelectorAll('.subpurchase-label .rtx-purchase-label__inner span').forEach(span => {
                                  if (span.innerText === 'Subscribe & Save') {
                                    span.innerText = 'Subscribe';
                                  }
                                });
                              }
                            }
                          } 
                          updateSubscriptionLabels();
                          window.addEventListener('resize', updateSubscriptionLabels);
                  
                        }
                  
                        // Export globally
                        return Object.assign(buyBoxes, {
                          [buyBox.boxId]: buyBox
                        });
                  
                       })((window.retextionBuyBox = {}));
                  
                      }   
                      // Set the interval ID
                      const intermainFermat = setInterval(() => {
                        checkURLForFermatProduct();
                      }, 1000);
                      
                      // Automatically clear the interval after 5 seconds if not cleared already
                      setTimeout(() => {
                        clearInterval(intermainFermat);
                        console.log('Interval automatically cleared after 5 seconds');
                      }, 5000);
                      
                      function checkURLForFermatProduct() {
                        const stayWidget = document.querySelectorAll('[fermat-featured-product]');
                        if (stayWidget.length > 0) {  // Check if any elements are found
                          document.querySelectorAll('.fermat-product-json').forEach(p => {
                            clearInterval(intermainFermat);
                            const product = p.innerHTML;
                            const currentProduct = JSON.parse(product);
                            console.log('Product:', currentProduct.product.title);
                      
                            const fermatFeaturedProduct = p.closest('[fermat-featured-product]');
                            FermatStayCode(currentProduct.product, currentProduct.selectedOrFirstAvailableVariant, fermatFeaturedProduct);
                          });
                          console.log('Interval cleared as the condition was met');
                        }
                      }
                      //FermatStayCode({{ product | json }},{{currentVariant.id | json}});

                  }
                /*fermat main product js end -------------*/
                //fermat js end
                // product variants js start
                $('.toggle-variant-option').click(function(){
                  $(this).toggleClass('is-open');
                  $(this).closest('.variant-option-wrap').find('.option-btn-wrp').slideToggle();
                });
                $('.option-btn-wrp input').click(function(){
                  $(this).closest('.variant-option-wrap').find('button.toggle-variant-option span').html($(this).val());
                });
                $('.option-btn-wrp label').click(function(){
                  $(this).closest('.option-btn-wrp').slideToggle();
                  $(this).closest('.variant-option-wrap').find('button.toggle-variant-option').toggleClass('is-open');
                });
                // product variants js end
                /*product-selector js start*/
          
                // document.querySelectorAll('.pdp-flavor_slider .swiper-slide').forEach((slide, index) => {
                //     slide.addEventListener('click', () => {
                //         document.querySelectorAll('.pdp-flavor_slider .swiper-slide').forEach(s => {
                //             s.classList.remove('selected-slide');
                //         });
                //         slide.classList.add('selected-slide');
                //     });
                // });
                // var thumb_swiper;
                // if(document.querySelector('.main-product-horiz-thumb-swiper')){
                //   thumb_swiper = new Swiper(".main-product-horiz-thumb-swiper", {
                //       spaceBetween: 14,
                //       slidesPerView: "auto",
                //       freeMode: true,
                //       watchSlidesProgress: true,
                //   });
                // }else{
                //   thumb_swiper = new Swiper(".main-product-thumb-swiper", {
                //       spaceBetween: 10,
                //       slidesPerView: 5,
                //       direction: 'vertical',
                //       freeMode: true,
                //       watchSlidesProgress: true,
                //   });
                // }  
                // window.main_swiper = new Swiper(".main-product-swiper", {
                //     spaceBetween: 10,
                //     slidesPerView: 1,
                //     thumbs: {
                //         swiper: thumb_swiper,
                //     },
                //     pagination: {
                //         el: ".swiper-pagination",
                //         clickable: true,
                //     },
                // });
          
                /*product-selector js start*/
                initAOS();
            t.title, t.pathname;
            (na.unmount(), na.mount(), b(), window.location.href.indexOf("products") > -1) && new Yotpo.API(yotpo).refreshWidgets()
        })), Promise.all([F()]).then((function(t) {
            var e = r()(t, 1)[0];
            na.hydrate({
                cart: e
            }), na.mount()
        }))
    }
]);
$(document).ready(function(){
  
   
   $('body').on('click','.get_sub',function(){
      
     var get_name = $(this).attr('data-types'); 
     console.log(get_name,'INdex JS et_name');
       $('.item_checked').removeClass('active_button');
       $(this).closest('.item_checked').addClass('active_button');
       $('.recharge_plan button[data-type="'+ get_name +'"]').trigger('click');
  });
});


//Run stay buy box JS when product changes
function checkURLForProduct() {
    stayWidget = document.querySelector('.rtx-subscription');
    // Check if the URL contains "product"
    var product, currentProduct;
    if (stayWidget) {
        // document.querySelectorAll('.js-product-json:not(.fermat-product-json)').forEach(p =>{
        //     product = p.innerHTML;
        //     currentProduct = JSON.parse(product);
        //     console.log('Product:', currentProduct.product.title);
        //     stayCode(currentProduct.product, currentProduct.selectedOrFirstAvailableVariant);       
            
        // });
        document.querySelectorAll('script[data-name="stayCode"]').forEach((script) => {
            console.log('evaluate staycode');
            eval( script.text ); 
        });
        clearInterval();
    }
    let old_recepient_script = document.querySelector('script[data-name="recepient-form-code"]');
    if(old_recepient_script){
      var recepient_script = document.createElement("script");  
      recepient_script.src = old_recepient_script.src; 
      document.head.appendChild(recepient_script); 
    }
}
var initialURL = window.location.href;
function checkURLChange() {
    // Check if the URL has changed since the last check
    if (window.location.href !== initialURL) {
        checkURLForProduct();
        // Update the initial URL
        initialURL = window.location.href;
    }
}

// Start the interval to check for content changes
// var stayWidget = document.querySelector('.rtx-subscription');
// if (stayWidget){
//   setInterval(checkURLChange, 1000);
// }
setInterval(checkURLChange, 1000);

$('body').on('click', '.more_info_button_pro', function() {
  if($('.meta-description.desc_hide').length > 0){
    $('.meta-description').removeClass('desc_hide');
    $('.more_info_button_pro p').html("- Less Info");
  }else{
    $('.meta-description').addClass('desc_hide');
    $('.more_info_button_pro p').html("+ More Info");
  }
});

function sticky_marketing_btn (){
    const mobileBtnBox = document.querySelector('.sticky-btn-boozer');
    console.log('gegeeggegeg',mobileBtnBox);

    // Guard: if sticky button doesn't exist on this page, skip initialization
    if (!mobileBtnBox) return;

    const sections = document.querySelectorAll('.marketing-boozer-hero-sec, .featured-product-section, .footer_wrp');

    // If no sections to observe, skip initialization
    if (sections.length === 0) return;

    // Track visibility of each section
    let visibleSections = new Set();

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Section is visible
                visibleSections.add(entry.target);
            } else {
                // Section is completely out of view
                visibleSections.delete(entry.target);
            }
        });

        // If none of the target sections are visible → activate sticky button
        if (visibleSections.size === 0) {
            mobileBtnBox.classList.add('active');
        } else {
            mobileBtnBox.classList.remove('active');
        }
    }, {
        root: null,
        threshold: 0 // triggers even if 1px is visible
    });

    // Observe all sections
    sections.forEach(section => observer.observe(section));
}

function initAOS(){
    AOS.init({
        once: true, // optional: animation runs only once per element
        duration: 800,
        easing: 'ease-out-cubic'
    });
}

if (Shopify.designMode) {
    $(document).on('shopify:section:select', function(e) {
        if($(event.target).hasClass('cashback-popup')){
            $('body').find('.cashback-popup').addClass('open');
        }
    });
    $(document).on('shopify:section:deselect', function(e) {
        if($(event.target).hasClass('cashback-popup')){
            $('body').find('.cashback-popup').removeClass('open');
        }
    });

  $(document).on('shopify:section:load shopify:section:unload shopify:block:select shopify:block:deselect shopify:section:reorder shopify:section:select shopify:section:deselect', function() {
    initAOS();
  });
}

initAOS();


document.addEventListener('click', function (e) {
  const button = e.target.closest('.js-alia-popup');
  if (!button) return;

  e.preventDefault();

  const campaignID = parseInt(button.dataset.campaignId, 10);

  window.alia = window.alia || [];
  window.alia.push({
    type: "open",
    campaignID: campaignID,
    ignoreTargeting: true
  });
});